// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!./styles/smileStudio.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

/*
! tailwindcss v3.4.17 | MIT License | https://tailwindcss.com
*/

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  -o-tab-size: 4;
     tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/

dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}

body{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}

.uris-cases-scope body {
  background-color: #1a1b1f;
}
.\\!container{
  width: 100% !important;
}
.container{
  width: 100%;
}
@media (min-width: 640px){

  .\\!container{
    max-width: 640px !important;
  }

  .container{
    max-width: 640px;
  }
}
@media (min-width: 768px){

  .\\!container{
    max-width: 768px !important;
  }

  .container{
    max-width: 768px;
  }
}
@media (min-width: 1024px){

  .\\!container{
    max-width: 1024px !important;
  }

  .container{
    max-width: 1024px;
  }
}
@media (min-width: 1280px){

  .\\!container{
    max-width: 1280px !important;
  }

  .container{
    max-width: 1280px;
  }
}
@media (min-width: 1536px){

  .\\!container{
    max-width: 1536px !important;
  }

  .container{
    max-width: 1536px;
  }
}
.sr-only{
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none{
  pointer-events: none;
}
.pointer-events-auto{
  pointer-events: auto;
}
.visible{
  visibility: visible;
}
.static{
  position: static;
}
.fixed{
  position: fixed;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.sticky{
  position: sticky;
}
.inset-0{
  inset: 0px;
}
.inset-x-0{
  left: 0px;
  right: 0px;
}
.inset-y-0{
  top: 0px;
  bottom: 0px;
}
.-bottom-0\\.5{
  bottom: -0.125rem;
}
.-bottom-32{
  bottom: -8rem;
}
.-bottom-40{
  bottom: -10rem;
}
.-bottom-\\[5vw\\]{
  bottom: -5vw;
}
.-left-24{
  left: -6rem;
}
.-left-3{
  left: -0.75rem;
}
.-left-32{
  left: -8rem;
}
.-left-40{
  left: -10rem;
}
.-left-48{
  left: -12rem;
}
.-right-0\\.5{
  right: -0.125rem;
}
.-right-1{
  right: -0.25rem;
}
.-right-1\\.5{
  right: -0.375rem;
}
.-right-2{
  right: -0.5rem;
}
.-right-24{
  right: -6rem;
}
.-right-3{
  right: -0.75rem;
}
.-right-40{
  right: -10rem;
}
.-top-0\\.5{
  top: -0.125rem;
}
.-top-1{
  top: -0.25rem;
}
.-top-1\\.5{
  top: -0.375rem;
}
.-top-2{
  top: -0.5rem;
}
.-top-24{
  top: -6rem;
}
.-top-40{
  top: -10rem;
}
.-top-48{
  top: -12rem;
}
.bottom-0{
  bottom: 0px;
}
.bottom-0\\.5{
  bottom: 0.125rem;
}
.bottom-1{
  bottom: 0.25rem;
}
.bottom-2{
  bottom: 0.5rem;
}
.bottom-3{
  bottom: 0.75rem;
}
.bottom-4{
  bottom: 1rem;
}
.bottom-\\[1vw\\]{
  bottom: 1vw;
}
.bottom-\\[calc\\(100\\%\\+6px\\)\\]{
  bottom: calc(100% + 6px);
}
.left-0{
  left: 0px;
}
.left-0\\.5{
  left: 0.125rem;
}
.left-1{
  left: 0.25rem;
}
.left-1\\.5{
  left: 0.375rem;
}
.left-1\\/2{
  left: 50%;
}
.left-2{
  left: 0.5rem;
}
.left-3{
  left: 0.75rem;
}
.left-3\\.5{
  left: 0.875rem;
}
.left-4{
  left: 1rem;
}
.left-5{
  left: 1.25rem;
}
.left-\\[11px\\]{
  left: 11px;
}
.left-\\[1vw\\]{
  left: 1vw;
}
.left-\\[3\\.75rem\\]{
  left: 3.75rem;
}
.right-0{
  right: 0px;
}
.right-0\\.5{
  right: 0.125rem;
}
.right-1{
  right: 0.25rem;
}
.right-1\\.5{
  right: 0.375rem;
}
.right-2{
  right: 0.5rem;
}
.right-3{
  right: 0.75rem;
}
.right-3\\.5{
  right: 0.875rem;
}
.right-4{
  right: 1rem;
}
.right-5{
  right: 1.25rem;
}
.right-64{
  right: 16rem;
}
.top-0{
  top: 0px;
}
.top-0\\.5{
  top: 0.125rem;
}
.top-1{
  top: 0.25rem;
}
.top-1\\.5{
  top: 0.375rem;
}
.top-1\\/2{
  top: 50%;
}
.top-2{
  top: 0.5rem;
}
.top-2\\.5{
  top: 0.625rem;
}
.top-3{
  top: 0.75rem;
}
.top-3\\.5{
  top: 0.875rem;
}
.top-4{
  top: 1rem;
}
.top-5{
  top: 1.25rem;
}
.top-8{
  top: 2rem;
}
.top-\\[4\\.25rem\\]{
  top: 4.25rem;
}
.top-\\[4\\.5rem\\]{
  top: 4.5rem;
}
.top-\\[calc\\(100\\%\\+0\\.5rem\\)\\]{
  top: calc(100% + 0.5rem);
}
.top-full{
  top: 100%;
}
.isolate{
  isolation: isolate;
}
.z-0{
  z-index: 0;
}
.z-10{
  z-index: 10;
}
.z-20{
  z-index: 20;
}
.z-30{
  z-index: 30;
}
.z-40{
  z-index: 40;
}
.z-50{
  z-index: 50;
}
.z-\\[100\\]{
  z-index: 100;
}
.z-\\[15\\]{
  z-index: 15;
}
.z-\\[16\\]{
  z-index: 16;
}
.z-\\[1\\]{
  z-index: 1;
}
.z-\\[200\\]{
  z-index: 200;
}
.z-\\[2\\]{
  z-index: 2;
}
.z-\\[300\\]{
  z-index: 300;
}
.z-\\[3\\]{
  z-index: 3;
}
.z-\\[5\\]{
  z-index: 5;
}
.z-\\[60\\]{
  z-index: 60;
}
.z-\\[65\\]{
  z-index: 65;
}
.z-\\[70\\]{
  z-index: 70;
}
.z-\\[80\\]{
  z-index: 80;
}
.z-\\[90\\]{
  z-index: 90;
}
.z-\\[9990\\]{
  z-index: 9990;
}
.z-\\[9998\\]{
  z-index: 9998;
}
.z-\\[999999\\]{
  z-index: 999999;
}
.z-\\[9999\\]{
  z-index: 9999;
}
.z-\\[999\\]{
  z-index: 999;
}
.col-span-2{
  grid-column: span 2 / span 2;
}
.-m-4{
  margin: -1rem;
}
.m-0{
  margin: 0px;
}
.m-5{
  margin: 1.25rem;
}
.m-auto{
  margin: auto;
}
.-mx-1{
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}
.mx-0\\.5{
  margin-left: 0.125rem;
  margin-right: 0.125rem;
}
.mx-1{
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-1\\.5{
  margin-left: 0.375rem;
  margin-right: 0.375rem;
}
.mx-2{
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-4{
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.my-0\\.5{
  margin-top: 0.125rem;
  margin-bottom: 0.125rem;
}
.my-1{
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-1\\.5{
  margin-top: 0.375rem;
  margin-bottom: 0.375rem;
}
.my-2{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-3{
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.my-4{
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-6{
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.my-8{
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.my-auto{
  margin-top: auto;
  margin-bottom: auto;
}
.\\!mb-0{
  margin-bottom: 0px !important;
}
.\\!mt-0{
  margin-top: 0px !important;
}
.-mt-2{
  margin-top: -0.5rem;
}
.mb-0\\.5{
  margin-bottom: 0.125rem;
}
.mb-1{
  margin-bottom: 0.25rem;
}
.mb-1\\.5{
  margin-bottom: 0.375rem;
}
.mb-10{
  margin-bottom: 2.5rem;
}
.mb-16{
  margin-bottom: 4rem;
}
.mb-2{
  margin-bottom: 0.5rem;
}
.mb-2\\.5{
  margin-bottom: 0.625rem;
}
.mb-3{
  margin-bottom: 0.75rem;
}
.mb-3\\.5{
  margin-bottom: 0.875rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.mb-5{
  margin-bottom: 1.25rem;
}
.mb-6{
  margin-bottom: 1.5rem;
}
.mb-8{
  margin-bottom: 2rem;
}
.mb-\\[2\\.5vw\\]{
  margin-bottom: 2.5vw;
}
.mb-\\[2px\\]{
  margin-bottom: 2px;
}
.ml-0\\.5{
  margin-left: 0.125rem;
}
.ml-1{
  margin-left: 0.25rem;
}
.ml-1\\.5{
  margin-left: 0.375rem;
}
.ml-2{
  margin-left: 0.5rem;
}
.ml-3{
  margin-left: 0.75rem;
}
.ml-4{
  margin-left: 1rem;
}
.ml-5{
  margin-left: 1.25rem;
}
.ml-6{
  margin-left: 1.5rem;
}
.ml-\\[-35vw\\]{
  margin-left: -35vw;
}
.ml-auto{
  margin-left: auto;
}
.mr-1{
  margin-right: 0.25rem;
}
.mr-2{
  margin-right: 0.5rem;
}
.mr-3{
  margin-right: 0.75rem;
}
.mr-4{
  margin-right: 1rem;
}
.mt-0{
  margin-top: 0px;
}
.mt-0\\.5{
  margin-top: 0.125rem;
}
.mt-1{
  margin-top: 0.25rem;
}
.mt-1\\.5{
  margin-top: 0.375rem;
}
.mt-10{
  margin-top: 2.5rem;
}
.mt-12{
  margin-top: 3rem;
}
.mt-16{
  margin-top: 4rem;
}
.mt-2{
  margin-top: 0.5rem;
}
.mt-2\\.5{
  margin-top: 0.625rem;
}
.mt-20{
  margin-top: 5rem;
}
.mt-3{
  margin-top: 0.75rem;
}
.mt-4{
  margin-top: 1rem;
}
.mt-5{
  margin-top: 1.25rem;
}
.mt-6{
  margin-top: 1.5rem;
}
.mt-8{
  margin-top: 2rem;
}
.mt-auto{
  margin-top: auto;
}
.box-border{
  box-sizing: border-box;
}
.line-clamp-1{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.line-clamp-2{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.block{
  display: block;
}
.inline-block{
  display: inline-block;
}
.inline{
  display: inline;
}
.flex{
  display: flex;
}
.inline-flex{
  display: inline-flex;
}
.\\!table{
  display: table !important;
}
.table{
  display: table;
}
.grid{
  display: grid;
}
.contents{
  display: contents;
}
.hidden{
  display: none;
}
.aspect-\\[3\\/4\\]{
  aspect-ratio: 3/4;
}
.aspect-\\[4\\/3\\.3\\]{
  aspect-ratio: 4/3.3;
}
.aspect-\\[4\\/3\\]{
  aspect-ratio: 4/3;
}
.aspect-square{
  aspect-ratio: 1 / 1;
}
.aspect-video{
  aspect-ratio: 16 / 9;
}
.h-0\\.5{
  height: 0.125rem;
}
.h-1{
  height: 0.25rem;
}
.h-1\\.5{
  height: 0.375rem;
}
.h-10{
  height: 2.5rem;
}
.h-11{
  height: 2.75rem;
}
.h-12{
  height: 3rem;
}
.h-14{
  height: 3.5rem;
}
.h-16{
  height: 4rem;
}
.h-2{
  height: 0.5rem;
}
.h-2\\.5{
  height: 0.625rem;
}
.h-20{
  height: 5rem;
}
.h-24{
  height: 6rem;
}
.h-3{
  height: 0.75rem;
}
.h-3\\.5{
  height: 0.875rem;
}
.h-32{
  height: 8rem;
}
.h-36{
  height: 9rem;
}
.h-4{
  height: 1rem;
}
.h-40{
  height: 10rem;
}
.h-48{
  height: 12rem;
}
.h-5{
  height: 1.25rem;
}
.h-56{
  height: 14rem;
}
.h-6{
  height: 1.5rem;
}
.h-60{
  height: 15rem;
}
.h-64{
  height: 16rem;
}
.h-7{
  height: 1.75rem;
}
.h-72{
  height: 18rem;
}
.h-8{
  height: 2rem;
}
.h-80{
  height: 20rem;
}
.h-9{
  height: 2.25rem;
}
.h-96{
  height: 24rem;
}
.h-\\[1\\.15rem\\]{
  height: 1.15rem;
}
.h-\\[1\\.1rem\\]{
  height: 1.1rem;
}
.h-\\[100dvh\\]{
  height: 100dvh;
}
.h-\\[110px\\]{
  height: 110px;
}
.h-\\[116px\\]{
  height: 116px;
}
.h-\\[13px\\]{
  height: 13px;
}
.h-\\[15px\\]{
  height: 15px;
}
.h-\\[15vh\\]{
  height: 15vh;
}
.h-\\[160px\\]{
  height: 160px;
}
.h-\\[18px\\]{
  height: 18px;
}
.h-\\[19px\\]{
  height: 19px;
}
.h-\\[200px\\]{
  height: 200px;
}
.h-\\[22px\\]{
  height: 22px;
}
.h-\\[26px\\]{
  height: 26px;
}
.h-\\[280px\\]{
  height: 280px;
}
.h-\\[30vh\\]{
  height: 30vh;
}
.h-\\[340px\\]{
  height: 340px;
}
.h-\\[34px\\]{
  height: 34px;
}
.h-\\[36vh\\]{
  height: 36vh;
}
.h-\\[42px\\]{
  height: 42px;
}
.h-\\[42vh\\]{
  height: 42vh;
}
.h-\\[45vh\\]{
  height: 45vh;
}
.h-\\[46px\\]{
  height: 46px;
}
.h-\\[480px\\]{
  height: 480px;
}
.h-\\[4px\\]{
  height: 4px;
}
.h-\\[500px\\]{
  height: 500px;
}
.h-\\[50vh\\]{
  height: 50vh;
}
.h-\\[54px\\]{
  height: 54px;
}
.h-\\[600px\\]{
  height: 600px;
}
.h-\\[60vh\\]{
  height: 60vh;
}
.h-\\[72px\\]{
  height: 72px;
}
.h-\\[80\\%\\]{
  height: 80%;
}
.h-\\[90vh\\]{
  height: 90vh;
}
.h-\\[92vh\\]{
  height: 92vh;
}
.h-\\[calc\\(100vh-260px\\)\\]{
  height: calc(100vh - 260px);
}
.h-\\[min\\(58vh\\2c 520px\\)\\]{
  height: min(58vh,520px);
}
.h-\\[min\\(70vh\\2c 640px\\)\\]{
  height: min(70vh,640px);
}
.h-\\[min\\(74vh\\2c 780px\\)\\]{
  height: min(74vh,780px);
}
.h-\\[min\\(96vh\\2c 980px\\)\\]{
  height: min(96vh,980px);
}
.h-auto{
  height: auto;
}
.h-fit{
  height: -moz-fit-content;
  height: fit-content;
}
.h-full{
  height: 100%;
}
.h-px{
  height: 1px;
}
.h-screen{
  height: 100vh;
}
.max-h-32{
  max-height: 8rem;
}
.max-h-40{
  max-height: 10rem;
}
.max-h-44{
  max-height: 11rem;
}
.max-h-48{
  max-height: 12rem;
}
.max-h-52{
  max-height: 13rem;
}
.max-h-56{
  max-height: 14rem;
}
.max-h-64{
  max-height: 16rem;
}
.max-h-72{
  max-height: 18rem;
}
.max-h-\\[200px\\]{
  max-height: 200px;
}
.max-h-\\[220px\\]{
  max-height: 220px;
}
.max-h-\\[240px\\]{
  max-height: 240px;
}
.max-h-\\[280px\\]{
  max-height: 280px;
}
.max-h-\\[34vh\\]{
  max-height: 34vh;
}
.max-h-\\[380px\\]{
  max-height: 380px;
}
.max-h-\\[400px\\]{
  max-height: 400px;
}
.max-h-\\[420px\\]{
  max-height: 420px;
}
.max-h-\\[480px\\]{
  max-height: 480px;
}
.max-h-\\[70vh\\]{
  max-height: 70vh;
}
.max-h-\\[75vh\\]{
  max-height: 75vh;
}
.max-h-\\[85vh\\]{
  max-height: 85vh;
}
.max-h-\\[90vh\\]{
  max-height: 90vh;
}
.max-h-\\[92vh\\]{
  max-height: 92vh;
}
.max-h-\\[calc\\(100vh-7rem\\)\\]{
  max-height: calc(100vh - 7rem);
}
.max-h-full{
  max-height: 100%;
}
.min-h-0{
  min-height: 0px;
}
.min-h-11{
  min-height: 2.75rem;
}
.min-h-4{
  min-height: 1rem;
}
.min-h-\\[100px\\]{
  min-height: 100px;
}
.min-h-\\[110px\\]{
  min-height: 110px;
}
.min-h-\\[120px\\]{
  min-height: 120px;
}
.min-h-\\[140px\\]{
  min-height: 140px;
}
.min-h-\\[170px\\]{
  min-height: 170px;
}
.min-h-\\[2\\.75rem\\]{
  min-height: 2.75rem;
}
.min-h-\\[200px\\]{
  min-height: 200px;
}
.min-h-\\[220px\\]{
  min-height: 220px;
}
.min-h-\\[240px\\]{
  min-height: 240px;
}
.min-h-\\[260px\\]{
  min-height: 260px;
}
.min-h-\\[280px\\]{
  min-height: 280px;
}
.min-h-\\[3\\.25rem\\]{
  min-height: 3.25rem;
}
.min-h-\\[300px\\]{
  min-height: 300px;
}
.min-h-\\[30vh\\]{
  min-height: 30vh;
}
.min-h-\\[320px\\]{
  min-height: 320px;
}
.min-h-\\[40vh\\]{
  min-height: 40vh;
}
.min-h-\\[45vh\\]{
  min-height: 45vh;
}
.min-h-\\[5\\.5rem\\]{
  min-height: 5.5rem;
}
.min-h-\\[50vh\\]{
  min-height: 50vh;
}
.min-h-\\[60vh\\]{
  min-height: 60vh;
}
.min-h-\\[64px\\]{
  min-height: 64px;
}
.min-h-\\[70px\\]{
  min-height: 70px;
}
.min-h-\\[70vh\\]{
  min-height: 70vh;
}
.min-h-\\[72px\\]{
  min-height: 72px;
}
.min-h-\\[calc\\(100dvh-10\\.5rem\\)\\]{
  min-height: calc(100dvh - 10.5rem);
}
.min-h-\\[min\\(70vh\\2c 720px\\)\\]{
  min-height: min(70vh,720px);
}
.min-h-full{
  min-height: 100%;
}
.min-h-screen{
  min-height: 100vh;
}
.w-0{
  width: 0px;
}
.w-1{
  width: 0.25rem;
}
.w-1\\.5{
  width: 0.375rem;
}
.w-1\\/2{
  width: 50%;
}
.w-10{
  width: 2.5rem;
}
.w-11{
  width: 2.75rem;
}
.w-12{
  width: 3rem;
}
.w-14{
  width: 3.5rem;
}
.w-16{
  width: 4rem;
}
.w-2{
  width: 0.5rem;
}
.w-2\\.5{
  width: 0.625rem;
}
.w-20{
  width: 5rem;
}
.w-24{
  width: 6rem;
}
.w-28{
  width: 7rem;
}
.w-3{
  width: 0.75rem;
}
.w-3\\.5{
  width: 0.875rem;
}
.w-32{
  width: 8rem;
}
.w-4{
  width: 1rem;
}
.w-40{
  width: 10rem;
}
.w-48{
  width: 12rem;
}
.w-5{
  width: 1.25rem;
}
.w-52{
  width: 13rem;
}
.w-6{
  width: 1.5rem;
}
.w-60{
  width: 15rem;
}
.w-64{
  width: 16rem;
}
.w-7{
  width: 1.75rem;
}
.w-72{
  width: 18rem;
}
.w-8{
  width: 2rem;
}
.w-80{
  width: 20rem;
}
.w-9{
  width: 2.25rem;
}
.w-96{
  width: 24rem;
}
.w-\\[10\\%\\]{
  width: 10%;
}
.w-\\[100\\%\\]{
  width: 100%;
}
.w-\\[100px\\]{
  width: 100px;
}
.w-\\[12\\%\\]{
  width: 12%;
}
.w-\\[13\\%\\]{
  width: 13%;
}
.w-\\[13px\\]{
  width: 13px;
}
.w-\\[14\\%\\]{
  width: 14%;
}
.w-\\[140px\\]{
  width: 140px;
}
.w-\\[15\\%\\]{
  width: 15%;
}
.w-\\[15px\\]{
  width: 15px;
}
.w-\\[16\\%\\]{
  width: 16%;
}
.w-\\[180px\\]{
  width: 180px;
}
.w-\\[18px\\]{
  width: 18px;
}
.w-\\[19px\\]{
  width: 19px;
}
.w-\\[220px\\]{
  width: 220px;
}
.w-\\[22px\\]{
  width: 22px;
}
.w-\\[22rem\\]{
  width: 22rem;
}
.w-\\[25vh\\]{
  width: 25vh;
}
.w-\\[260px\\]{
  width: 260px;
}
.w-\\[26px\\]{
  width: 26px;
}
.w-\\[2px\\]{
  width: 2px;
}
.w-\\[30\\%\\]{
  width: 30%;
}
.w-\\[31\\.5\\%\\]{
  width: 31.5%;
}
.w-\\[320px\\]{
  width: 320px;
}
.w-\\[34px\\]{
  width: 34px;
}
.w-\\[35\\%\\]{
  width: 35%;
}
.w-\\[35vw\\]{
  width: 35vw;
}
.w-\\[36\\%\\]{
  width: 36%;
}
.w-\\[36\\.5\\%\\]{
  width: 36.5%;
}
.w-\\[360px\\]{
  width: 360px;
}
.w-\\[3px\\]{
  width: 3px;
}
.w-\\[4\\%\\]{
  width: 4%;
}
.w-\\[4\\.75rem\\]{
  width: 4.75rem;
}
.w-\\[40\\%\\]{
  width: 40%;
}
.w-\\[46px\\]{
  width: 46px;
}
.w-\\[5\\%\\]{
  width: 5%;
}
.w-\\[500px\\]{
  width: 500px;
}
.w-\\[55\\.5\\%\\]{
  width: 55.5%;
}
.w-\\[6\\%\\]{
  width: 6%;
}
.w-\\[60\\%\\]{
  width: 60%;
}
.w-\\[600px\\]{
  width: 600px;
}
.w-\\[65\\%\\]{
  width: 65%;
}
.w-\\[7\\%\\]{
  width: 7%;
}
.w-\\[70\\%\\]{
  width: 70%;
}
.w-\\[8\\%\\]{
  width: 8%;
}
.w-\\[9\\%\\]{
  width: 9%;
}
.w-\\[90\\%\\]{
  width: 90%;
}
.w-\\[95\\%\\]{
  width: 95%;
}
.w-\\[95vw\\]{
  width: 95vw;
}
.w-\\[96px\\]{
  width: 96px;
}
.w-\\[min\\(100\\%\\2c 17rem\\)\\]{
  width: min(100%,17rem);
}
.w-\\[min\\(100\\%\\2c 20\\.5rem\\)\\]{
  width: min(100%,20.5rem);
}
.w-\\[min\\(80\\%\\2c 18rem\\)\\]{
  width: min(80%,18rem);
}
.w-\\[min\\(92\\%\\2c 22rem\\)\\]{
  width: min(92%,22rem);
}
.w-\\[min\\(98\\%\\2c 52rem\\)\\]{
  width: min(98%,52rem);
}
.w-auto{
  width: auto;
}
.w-fit{
  width: -moz-fit-content;
  width: fit-content;
}
.w-full{
  width: 100%;
}
.w-max{
  width: -moz-max-content;
  width: max-content;
}
.w-px{
  width: 1px;
}
.w-screen{
  width: 100vw;
}
.min-w-0{
  min-width: 0px;
}
.min-w-40{
  min-width: 10rem;
}
.min-w-5{
  min-width: 1.25rem;
}
.min-w-\\[1\\.15rem\\]{
  min-width: 1.15rem;
}
.min-w-\\[1\\.1rem\\]{
  min-width: 1.1rem;
}
.min-w-\\[1\\.75rem\\]{
  min-width: 1.75rem;
}
.min-w-\\[100px\\]{
  min-width: 100px;
}
.min-w-\\[1080px\\]{
  min-width: 1080px;
}
.min-w-\\[10vw\\]{
  min-width: 10vw;
}
.min-w-\\[1100px\\]{
  min-width: 1100px;
}
.min-w-\\[12\\.5rem\\]{
  min-width: 12.5rem;
}
.min-w-\\[1200px\\]{
  min-width: 1200px;
}
.min-w-\\[120px\\]{
  min-width: 120px;
}
.min-w-\\[1280px\\]{
  min-width: 1280px;
}
.min-w-\\[1400px\\]{
  min-width: 1400px;
}
.min-w-\\[140px\\]{
  min-width: 140px;
}
.min-w-\\[160px\\]{
  min-width: 160px;
}
.min-w-\\[16px\\]{
  min-width: 16px;
}
.min-w-\\[180px\\]{
  min-width: 180px;
}
.min-w-\\[18px\\]{
  min-width: 18px;
}
.min-w-\\[200px\\]{
  min-width: 200px;
}
.min-w-\\[220px\\]{
  min-width: 220px;
}
.min-w-\\[240px\\]{
  min-width: 240px;
}
.min-w-\\[280px\\]{
  min-width: 280px;
}
.min-w-\\[30vw\\]{
  min-width: 30vw;
}
.min-w-\\[38px\\]{
  min-width: 38px;
}
.min-w-\\[480px\\]{
  min-width: 480px;
}
.min-w-\\[5\\.5rem\\]{
  min-width: 5.5rem;
}
.min-w-\\[520px\\]{
  min-width: 520px;
}
.min-w-\\[5vw\\]{
  min-width: 5vw;
}
.min-w-\\[640px\\]{
  min-width: 640px;
}
.min-w-\\[680px\\]{
  min-width: 680px;
}
.min-w-\\[720px\\]{
  min-width: 720px;
}
.min-w-\\[72px\\]{
  min-width: 72px;
}
.min-w-\\[760px\\]{
  min-width: 760px;
}
.min-w-\\[7rem\\]{
  min-width: 7rem;
}
.min-w-\\[800px\\]{
  min-width: 800px;
}
.min-w-\\[880px\\]{
  min-width: 880px;
}
.min-w-\\[88px\\]{
  min-width: 88px;
}
.min-w-\\[900px\\]{
  min-width: 900px;
}
.min-w-\\[960px\\]{
  min-width: 960px;
}
.min-w-\\[980px\\]{
  min-width: 980px;
}
.min-w-full{
  min-width: 100%;
}
.min-w-max{
  min-width: -moz-max-content;
  min-width: max-content;
}
.max-w-2xl{
  max-width: 42rem;
}
.max-w-3xl{
  max-width: 48rem;
}
.max-w-4xl{
  max-width: 56rem;
}
.max-w-5xl{
  max-width: 64rem;
}
.max-w-6xl{
  max-width: 72rem;
}
.max-w-7xl{
  max-width: 80rem;
}
.max-w-\\[10vw\\]{
  max-width: 10vw;
}
.max-w-\\[12rem\\]{
  max-width: 12rem;
}
.max-w-\\[1376px\\]{
  max-width: 1376px;
}
.max-w-\\[148px\\]{
  max-width: 148px;
}
.max-w-\\[14rem\\]{
  max-width: 14rem;
}
.max-w-\\[1600px\\]{
  max-width: 1600px;
}
.max-w-\\[160px\\]{
  max-width: 160px;
}
.max-w-\\[16rem\\]{
  max-width: 16rem;
}
.max-w-\\[18rem\\]{
  max-width: 18rem;
}
.max-w-\\[200px\\]{
  max-width: 200px;
}
.max-w-\\[20vw\\]{
  max-width: 20vw;
}
.max-w-\\[220px\\]{
  max-width: 220px;
}
.max-w-\\[22rem\\]{
  max-width: 22rem;
}
.max-w-\\[260px\\]{
  max-width: 260px;
}
.max-w-\\[45\\%\\]{
  max-width: 45%;
}
.max-w-\\[500px\\]{
  max-width: 500px;
}
.max-w-\\[55\\%\\]{
  max-width: 55%;
}
.max-w-\\[70\\%\\]{
  max-width: 70%;
}
.max-w-\\[76\\.8rem\\]{
  max-width: 76.8rem;
}
.max-w-\\[800px\\]{
  max-width: 800px;
}
.max-w-\\[88px\\]{
  max-width: 88px;
}
.max-w-\\[90\\%\\]{
  max-width: 90%;
}
.max-w-\\[calc\\(100\\%-0\\.75rem\\)\\]{
  max-width: calc(100% - 0.75rem);
}
.max-w-\\[calc\\(100\\%-2\\.5rem\\)\\]{
  max-width: calc(100% - 2.5rem);
}
.max-w-\\[calc\\(100\\%-5rem\\)\\]{
  max-width: calc(100% - 5rem);
}
.max-w-\\[calc\\(100vw-2rem\\)\\]{
  max-width: calc(100vw - 2rem);
}
.max-w-\\[min\\(98vw\\2c 1600px\\)\\]{
  max-width: min(98vw,1600px);
}
.max-w-\\[min\\(98vw\\2c 1680px\\)\\]{
  max-width: min(98vw,1680px);
}
.max-w-full{
  max-width: 100%;
}
.max-w-lg{
  max-width: 32rem;
}
.max-w-md{
  max-width: 28rem;
}
.max-w-none{
  max-width: none;
}
.max-w-sm{
  max-width: 24rem;
}
.max-w-xl{
  max-width: 36rem;
}
.max-w-xs{
  max-width: 20rem;
}
.flex-1{
  flex: 1 1 0%;
}
.flex-shrink-0{
  flex-shrink: 0;
}
.shrink{
  flex-shrink: 1;
}
.shrink-0{
  flex-shrink: 0;
}
.grow{
  flex-grow: 1;
}
.table-auto{
  table-layout: auto;
}
.table-fixed{
  table-layout: fixed;
}
.border-collapse{
  border-collapse: collapse;
}
.border-separate{
  border-collapse: separate;
}
.border-spacing-0{
  --tw-border-spacing-x: 0px;
  --tw-border-spacing-y: 0px;
  border-spacing: var(--tw-border-spacing-x) var(--tw-border-spacing-y);
}
.border-spacing-y-1\\.5{
  --tw-border-spacing-y: 0.375rem;
  border-spacing: var(--tw-border-spacing-x) var(--tw-border-spacing-y);
}
.border-spacing-y-2{
  --tw-border-spacing-y: 0.5rem;
  border-spacing: var(--tw-border-spacing-x) var(--tw-border-spacing-y);
}
.origin-top-left{
  transform-origin: top left;
}
.-translate-x-1\\/2{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-full{
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0\\.5{
  --tw-translate-x: 0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-4{
  --tw-translate-x: 1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[22px\\]{
  --tw-translate-x: 22px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[2px\\]{
  --tw-translate-x: 2px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-12{
  --tw-rotate: 12deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-\\[-2deg\\]{
  --tw-rotate: -2deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-110{
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-125{
  --tw-scale-x: 1.25;
  --tw-scale-y: 1.25;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-\\[0\\.35\\]{
  --tw-scale-x: 0.35;
  --tw-scale-y: 0.35;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-x-\\[-1\\]{
  --tw-scale-x: -1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.animate-\\[flickerSlide_4s_ease-in-out_infinite\\]{
  animation: flickerSlide 4s ease-in-out infinite;
}
.animate-\\[punchPop_0\\.35s_ease-out\\]{
  animation: punchPop 0.35s ease-out;
}
@keyframes pulse{

  50%{
    opacity: .5;
  }
}
.animate-pulse{
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin{

  to{
    transform: rotate(360deg);
  }
}
.animate-spin{
  animation: spin 1s linear infinite;
}
.cursor-default{
  cursor: default;
}
.cursor-ew-resize{
  cursor: ew-resize;
}
.cursor-grab{
  cursor: grab;
}
.cursor-grabbing{
  cursor: grabbing;
}
.cursor-move{
  cursor: move;
}
.cursor-nesw-resize{
  cursor: nesw-resize;
}
.cursor-not-allowed{
  cursor: not-allowed;
}
.cursor-ns-resize{
  cursor: ns-resize;
}
.cursor-nwse-resize{
  cursor: nwse-resize;
}
.cursor-pointer{
  cursor: pointer;
}
.cursor-wait{
  cursor: wait;
}
.touch-none{
  touch-action: none;
}
.select-none{
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}
.resize-none{
  resize: none;
}
.resize-y{
  resize: vertical;
}
.resize{
  resize: both;
}
.scroll-mt-20{
  scroll-margin-top: 5rem;
}
.list-inside{
  list-style-position: inside;
}
.list-outside{
  list-style-position: outside;
}
.list-decimal{
  list-style-type: decimal;
}
.list-disc{
  list-style-type: disc;
}
.list-none{
  list-style-type: none;
}
.appearance-none{
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
}
.grid-cols-1{
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3{
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-4{
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.grid-cols-7{
  grid-template-columns: repeat(7, minmax(0, 1fr));
}
.grid-cols-8{
  grid-template-columns: repeat(8, minmax(0, 1fr));
}
.grid-cols-\\[1\\.4fr_0\\.8fr\\]{
  grid-template-columns: 1.4fr 0.8fr;
}
.grid-cols-\\[52px_minmax\\(0\\2c 1fr\\)_1px_minmax\\(0\\2c 1fr\\)\\]{
  grid-template-columns: 52px minmax(0,1fr) 1px minmax(0,1fr);
}
.grid-cols-\\[6\\.1rem_minmax\\(0\\2c 1fr\\)\\]{
  grid-template-columns: 6.1rem minmax(0,1fr);
}
.flex-row{
  flex-direction: row;
}
.flex-col{
  flex-direction: column;
}
.flex-col-reverse{
  flex-direction: column-reverse;
}
.flex-wrap{
  flex-wrap: wrap;
}
.content-start{
  align-content: flex-start;
}
.items-start{
  align-items: flex-start;
}
.items-end{
  align-items: flex-end;
}
.items-center{
  align-items: center;
}
.items-baseline{
  align-items: baseline;
}
.items-stretch{
  align-items: stretch;
}
.justify-start{
  justify-content: flex-start;
}
.justify-end{
  justify-content: flex-end;
}
.justify-center{
  justify-content: center;
}
.justify-between{
  justify-content: space-between;
}
.justify-evenly{
  justify-content: space-evenly;
}
.gap-0\\.5{
  gap: 0.125rem;
}
.gap-1{
  gap: 0.25rem;
}
.gap-1\\.5{
  gap: 0.375rem;
}
.gap-10{
  gap: 2.5rem;
}
.gap-12{
  gap: 3rem;
}
.gap-2{
  gap: 0.5rem;
}
.gap-2\\.5{
  gap: 0.625rem;
}
.gap-3{
  gap: 0.75rem;
}
.gap-3\\.5{
  gap: 0.875rem;
}
.gap-4{
  gap: 1rem;
}
.gap-5{
  gap: 1.25rem;
}
.gap-6{
  gap: 1.5rem;
}
.gap-8{
  gap: 2rem;
}
.gap-\\[2vw\\]{
  gap: 2vw;
}
.gap-\\[3vw\\]{
  gap: 3vw;
}
.gap-px{
  gap: 1px;
}
.gap-x-1{
  -moz-column-gap: 0.25rem;
       column-gap: 0.25rem;
}
.gap-x-10{
  -moz-column-gap: 2.5rem;
       column-gap: 2.5rem;
}
.gap-x-2{
  -moz-column-gap: 0.5rem;
       column-gap: 0.5rem;
}
.gap-x-3{
  -moz-column-gap: 0.75rem;
       column-gap: 0.75rem;
}
.gap-x-4{
  -moz-column-gap: 1rem;
       column-gap: 1rem;
}
.gap-x-8{
  -moz-column-gap: 2rem;
       column-gap: 2rem;
}
.gap-y-0\\.5{
  row-gap: 0.125rem;
}
.gap-y-1{
  row-gap: 0.25rem;
}
.gap-y-2{
  row-gap: 0.5rem;
}
.gap-y-3{
  row-gap: 0.75rem;
}
.gap-y-4{
  row-gap: 1rem;
}
.space-x-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-10 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(2.5rem * var(--tw-space-x-reverse));
  margin-left: calc(2.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-0\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.125rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.125rem * var(--tw-space-y-reverse));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-2\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.625rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.625rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.divide-y > :not([hidden]) ~ :not([hidden]){
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-\\[\\#F0F0EC\\] > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(240 240 236 / var(--tw-divide-opacity, 1));
}
.self-start{
  align-self: flex-start;
}
.self-center{
  align-self: center;
}
.self-stretch{
  align-self: stretch;
}
.overflow-auto{
  overflow: auto;
}
.overflow-hidden{
  overflow: hidden;
}
.overflow-visible{
  overflow: visible;
}
.overflow-x-auto{
  overflow-x: auto;
}
.overflow-y-auto{
  overflow-y: auto;
}
.overflow-x-hidden{
  overflow-x: hidden;
}
.overflow-y-hidden{
  overflow-y: hidden;
}
.overscroll-contain{
  overscroll-behavior: contain;
}
.truncate{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-normal{
  white-space: normal;
}
.whitespace-nowrap{
  white-space: nowrap;
}
.whitespace-pre-wrap{
  white-space: pre-wrap;
}
.text-balance{
  text-wrap: balance;
}
.break-words{
  overflow-wrap: break-word;
}
.break-all{
  word-break: break-all;
}
.rounded{
  border-radius: 0.25rem;
}
.rounded-2xl{
  border-radius: 1rem;
}
.rounded-3xl{
  border-radius: 1.5rem;
}
.rounded-\\[10px\\]{
  border-radius: 10px;
}
.rounded-\\[11px\\]{
  border-radius: 11px;
}
.rounded-\\[14px\\]{
  border-radius: 14px;
}
.rounded-\\[17\\.5vw\\]{
  border-radius: 17.5vw;
}
.rounded-\\[1vw\\]{
  border-radius: 1vw;
}
.rounded-\\[24px\\]{
  border-radius: 24px;
}
.rounded-\\[28px\\]{
  border-radius: 28px;
}
.rounded-\\[32px\\]{
  border-radius: 32px;
}
.rounded-\\[4px\\]{
  border-radius: 4px;
}
.rounded-\\[5px\\]{
  border-radius: 5px;
}
.rounded-\\[7px\\]{
  border-radius: 7px;
}
.rounded-\\[9px\\]{
  border-radius: 9px;
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-lg{
  border-radius: 0.5rem;
}
.rounded-md{
  border-radius: 0.375rem;
}
.rounded-none{
  border-radius: 0px;
}
.rounded-sm{
  border-radius: 0.125rem;
}
.rounded-xl{
  border-radius: 0.75rem;
}
.rounded-b-2xl{
  border-bottom-right-radius: 1rem;
  border-bottom-left-radius: 1rem;
}
.rounded-l-\\[10px\\]{
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}
.rounded-l-lg{
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.rounded-l-xl{
  border-top-left-radius: 0.75rem;
  border-bottom-left-radius: 0.75rem;
}
.rounded-r-\\[10px\\]{
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}
.rounded-r-lg{
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}
.rounded-r-sm{
  border-top-right-radius: 0.125rem;
  border-bottom-right-radius: 0.125rem;
}
.rounded-r-xl{
  border-top-right-radius: 0.75rem;
  border-bottom-right-radius: 0.75rem;
}
.rounded-t-2xl{
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
}
.rounded-t-\\[32px\\]{
  border-top-left-radius: 32px;
  border-top-right-radius: 32px;
}
.\\!border{
  border-width: 1px !important;
}
.border{
  border-width: 1px;
}
.border-0{
  border-width: 0px;
}
.border-2{
  border-width: 2px;
}
.border-4{
  border-width: 4px;
}
.border-8{
  border-width: 8px;
}
.border-\\[0\\.2vw\\]{
  border-width: 0.2vw;
}
.border-\\[1\\.5px\\]{
  border-width: 1.5px;
}
.border-x-4{
  border-left-width: 4px;
  border-right-width: 4px;
}
.border-y{
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.border-b{
  border-bottom-width: 1px;
}
.border-b-2{
  border-bottom-width: 2px;
}
.border-b-4{
  border-bottom-width: 4px;
}
.border-l{
  border-left-width: 1px;
}
.border-l-2{
  border-left-width: 2px;
}
.border-l-4{
  border-left-width: 4px;
}
.border-r{
  border-right-width: 1px;
}
.border-r-2{
  border-right-width: 2px;
}
.border-t{
  border-top-width: 1px;
}
.border-t-2{
  border-top-width: 2px;
}
.border-t-\\[0\\.2vw\\]{
  border-top-width: 0.2vw;
}
.border-t-\\[3px\\]{
  border-top-width: 3px;
}
.border-t-\\[5px\\]{
  border-top-width: 5px;
}
.border-dashed{
  border-style: dashed;
}
.\\!border-\\[\\#2e3036\\]{
  --tw-border-opacity: 1 !important;
  border-color: rgb(46 48 54 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-\\[\\#3a3c42\\]{
  --tw-border-opacity: 1 !important;
  border-color: rgb(58 60 66 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-white{
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1)) !important;
}
.border-\\[\\#1DA8C6\\]{
  --tw-border-opacity: 1;
  border-color: rgb(29 168 198 / var(--tw-border-opacity, 1));
}
.border-\\[\\#1DA8C6\\]\\/40{
  border-color: rgb(29 168 198 / 0.4);
}
.border-\\[\\#1DA8C6\\]\\/70{
  border-color: rgb(29 168 198 / 0.7);
}
.border-\\[\\#1F1F1C\\]{
  --tw-border-opacity: 1;
  border-color: rgb(31 31 28 / var(--tw-border-opacity, 1));
}
.border-\\[\\#1d1e21\\]{
  --tw-border-opacity: 1;
  border-color: rgb(29 30 33 / var(--tw-border-opacity, 1));
}
.border-\\[\\#1f2221\\]{
  --tw-border-opacity: 1;
  border-color: rgb(31 34 33 / var(--tw-border-opacity, 1));
}
.border-\\[\\#26272b\\]{
  --tw-border-opacity: 1;
  border-color: rgb(38 39 43 / var(--tw-border-opacity, 1));
}
.border-\\[\\#262928\\]{
  --tw-border-opacity: 1;
  border-color: rgb(38 41 40 / var(--tw-border-opacity, 1));
}
.border-\\[\\#2a2b30\\]{
  --tw-border-opacity: 1;
  border-color: rgb(42 43 48 / var(--tw-border-opacity, 1));
}
.border-\\[\\#2a2b31\\]{
  --tw-border-opacity: 1;
  border-color: rgb(42 43 49 / var(--tw-border-opacity, 1));
}
.border-\\[\\#2a2d2c\\]{
  --tw-border-opacity: 1;
  border-color: rgb(42 45 44 / var(--tw-border-opacity, 1));
}
.border-\\[\\#2a2e2c\\]{
  --tw-border-opacity: 1;
  border-color: rgb(42 46 44 / var(--tw-border-opacity, 1));
}
.border-\\[\\#2e2f34\\]{
  --tw-border-opacity: 1;
  border-color: rgb(46 47 52 / var(--tw-border-opacity, 1));
}
.border-\\[\\#2e3036\\]{
  --tw-border-opacity: 1;
  border-color: rgb(46 48 54 / var(--tw-border-opacity, 1));
}
.border-\\[\\#2fa9bf\\]{
  --tw-border-opacity: 1;
  border-color: rgb(47 169 191 / var(--tw-border-opacity, 1));
}
.border-\\[\\#2fa9bf\\]\\/20{
  border-color: rgb(47 169 191 / 0.2);
}
.border-\\[\\#2fa9bf\\]\\/25{
  border-color: rgb(47 169 191 / 0.25);
}
.border-\\[\\#2fa9bf\\]\\/30{
  border-color: rgb(47 169 191 / 0.3);
}
.border-\\[\\#2fa9bf\\]\\/35{
  border-color: rgb(47 169 191 / 0.35);
}
.border-\\[\\#2fa9bf\\]\\/40{
  border-color: rgb(47 169 191 / 0.4);
}
.border-\\[\\#2fa9bf\\]\\/45{
  border-color: rgb(47 169 191 / 0.45);
}
.border-\\[\\#2fa9bf\\]\\/50{
  border-color: rgb(47 169 191 / 0.5);
}
.border-\\[\\#2fa9bf\\]\\/60{
  border-color: rgb(47 169 191 / 0.6);
}
.border-\\[\\#303136\\]{
  --tw-border-opacity: 1;
  border-color: rgb(48 49 54 / var(--tw-border-opacity, 1));
}
.border-\\[\\#345952\\]{
  --tw-border-opacity: 1;
  border-color: rgb(52 89 82 / var(--tw-border-opacity, 1));
}
.border-\\[\\#37383e\\]{
  --tw-border-opacity: 1;
  border-color: rgb(55 56 62 / var(--tw-border-opacity, 1));
}
.border-\\[\\#3a3b41\\]{
  --tw-border-opacity: 1;
  border-color: rgb(58 59 65 / var(--tw-border-opacity, 1));
}
.border-\\[\\#3a3c42\\]{
  --tw-border-opacity: 1;
  border-color: rgb(58 60 66 / var(--tw-border-opacity, 1));
}
.border-\\[\\#3d3e44\\]{
  --tw-border-opacity: 1;
  border-color: rgb(61 62 68 / var(--tw-border-opacity, 1));
}
.border-\\[\\#55565c\\]{
  --tw-border-opacity: 1;
  border-color: rgb(85 86 92 / var(--tw-border-opacity, 1));
}
.border-\\[\\#6b2430\\]{
  --tw-border-opacity: 1;
  border-color: rgb(107 36 48 / var(--tw-border-opacity, 1));
}
.border-\\[\\#7ECAD8\\]{
  --tw-border-opacity: 1;
  border-color: rgb(126 202 216 / var(--tw-border-opacity, 1));
}
.border-\\[\\#8B7355\\]{
  --tw-border-opacity: 1;
  border-color: rgb(139 115 85 / var(--tw-border-opacity, 1));
}
.border-\\[\\#8FB98F\\]{
  --tw-border-opacity: 1;
  border-color: rgb(143 185 143 / var(--tw-border-opacity, 1));
}
.border-\\[\\#93B9AD\\]{
  --tw-border-opacity: 1;
  border-color: rgb(147 185 173 / var(--tw-border-opacity, 1));
}
.border-\\[\\#B5D4F0\\]{
  --tw-border-opacity: 1;
  border-color: rgb(181 212 240 / var(--tw-border-opacity, 1));
}
.border-\\[\\#B8D9C0\\]{
  --tw-border-opacity: 1;
  border-color: rgb(184 217 192 / var(--tw-border-opacity, 1));
}
.border-\\[\\#BF1E2E\\]{
  --tw-border-opacity: 1;
  border-color: rgb(191 30 46 / var(--tw-border-opacity, 1));
}
.border-\\[\\#C8C8C3\\]{
  --tw-border-opacity: 1;
  border-color: rgb(200 200 195 / var(--tw-border-opacity, 1));
}
.border-\\[\\#C8C8C8\\]{
  --tw-border-opacity: 1;
  border-color: rgb(200 200 200 / var(--tw-border-opacity, 1));
}
.border-\\[\\#C9D4D6\\]{
  --tw-border-opacity: 1;
  border-color: rgb(201 212 214 / var(--tw-border-opacity, 1));
}
.border-\\[\\#D4C4A8\\]{
  --tw-border-opacity: 1;
  border-color: rgb(212 196 168 / var(--tw-border-opacity, 1));
}
.border-\\[\\#D4EBEF\\]{
  --tw-border-opacity: 1;
  border-color: rgb(212 235 239 / var(--tw-border-opacity, 1));
}
.border-\\[\\#DDDDD8\\]{
  --tw-border-opacity: 1;
  border-color: rgb(221 221 216 / var(--tw-border-opacity, 1));
}
.border-\\[\\#DDDDDD\\]{
  --tw-border-opacity: 1;
  border-color: rgb(221 221 221 / var(--tw-border-opacity, 1));
}
.border-\\[\\#E0E0E0\\]{
  --tw-border-opacity: 1;
  border-color: rgb(224 224 224 / var(--tw-border-opacity, 1));
}
.border-\\[\\#E3E8E8\\]{
  --tw-border-opacity: 1;
  border-color: rgb(227 232 232 / var(--tw-border-opacity, 1));
}
.border-\\[\\#E5E5E0\\]{
  --tw-border-opacity: 1;
  border-color: rgb(229 229 224 / var(--tw-border-opacity, 1));
}
.border-\\[\\#E8BEBC\\]{
  --tw-border-opacity: 1;
  border-color: rgb(232 190 188 / var(--tw-border-opacity, 1));
}
.border-\\[\\#E8D9C4\\]{
  --tw-border-opacity: 1;
  border-color: rgb(232 217 196 / var(--tw-border-opacity, 1));
}
.border-\\[\\#E8E0D8\\]{
  --tw-border-opacity: 1;
  border-color: rgb(232 224 216 / var(--tw-border-opacity, 1));
}
.border-\\[\\#E8E8E3\\]{
  --tw-border-opacity: 1;
  border-color: rgb(232 232 227 / var(--tw-border-opacity, 1));
}
.border-\\[\\#E8E8E4\\]{
  --tw-border-opacity: 1;
  border-color: rgb(232 232 228 / var(--tw-border-opacity, 1));
}
.border-\\[\\#EFE6DA\\]{
  --tw-border-opacity: 1;
  border-color: rgb(239 230 218 / var(--tw-border-opacity, 1));
}
.border-\\[\\#F0D4A0\\]{
  --tw-border-opacity: 1;
  border-color: rgb(240 212 160 / var(--tw-border-opacity, 1));
}
.border-\\[\\#F0F0EB\\]{
  --tw-border-opacity: 1;
  border-color: rgb(240 240 235 / var(--tw-border-opacity, 1));
}
.border-\\[\\#F0F0EC\\]{
  --tw-border-opacity: 1;
  border-color: rgb(240 240 236 / var(--tw-border-opacity, 1));
}
.border-\\[\\#F3F3F0\\]{
  --tw-border-opacity: 1;
  border-color: rgb(243 243 240 / var(--tw-border-opacity, 1));
}
.border-\\[\\#FCF2E5\\]{
  --tw-border-opacity: 1;
  border-color: rgb(252 242 229 / var(--tw-border-opacity, 1));
}
.border-\\[\\#b8e8f0\\]{
  --tw-border-opacity: 1;
  border-color: rgb(184 232 240 / var(--tw-border-opacity, 1));
}
.border-\\[\\#c31c30\\]{
  --tw-border-opacity: 1;
  border-color: rgb(195 28 48 / var(--tw-border-opacity, 1));
}
.border-\\[rgba\\(191\\2c 30\\2c 46\\2c 0\\.6\\)\\]{
  border-color: rgba(191,30,46,0.6);
}
.border-\\[rgba\\(229\\2c 164\\2c 67\\2c 0\\.55\\)\\]{
  border-color: rgba(229,164,67,0.55);
}
.border-\\[rgba\\(29\\2c 168\\2c 198\\2c 0\\.2\\)\\]{
  border-color: rgba(29,168,198,0.2);
}
.border-\\[rgba\\(29\\2c 168\\2c 198\\2c 0\\.25\\)\\]{
  border-color: rgba(29,168,198,0.25);
}
.border-\\[rgba\\(29\\2c 168\\2c 198\\2c 0\\.35\\)\\]{
  border-color: rgba(29,168,198,0.35);
}
.border-\\[rgba\\(29\\2c 168\\2c 198\\2c 0\\.45\\)\\]{
  border-color: rgba(29,168,198,0.45);
}
.border-\\[rgba\\(8\\2c 21\\2c 26\\2c 0\\.3\\)\\]{
  border-color: rgba(8,21,26,0.3);
}
.border-\\[var\\(--cu-accent\\)\\]{
  border-color: var(--cu-accent);
}
.border-\\[var\\(--cu-border\\)\\]{
  border-color: var(--cu-border);
}
.border-\\[var\\(--cu-border-hover\\)\\]{
  border-color: var(--cu-border-hover);
}
.border-\\[var\\(--cu-danger\\)\\]{
  border-color: var(--cu-danger);
}
.border-amber-200{
  --tw-border-opacity: 1;
  border-color: rgb(253 230 138 / var(--tw-border-opacity, 1));
}
.border-amber-300{
  --tw-border-opacity: 1;
  border-color: rgb(252 211 77 / var(--tw-border-opacity, 1));
}
.border-amber-400{
  --tw-border-opacity: 1;
  border-color: rgb(251 191 36 / var(--tw-border-opacity, 1));
}
.border-amber-400\\/20{
  border-color: rgb(251 191 36 / 0.2);
}
.border-amber-400\\/25{
  border-color: rgb(251 191 36 / 0.25);
}
.border-amber-400\\/40{
  border-color: rgb(251 191 36 / 0.4);
}
.border-amber-500{
  --tw-border-opacity: 1;
  border-color: rgb(245 158 11 / var(--tw-border-opacity, 1));
}
.border-amber-500\\/15{
  border-color: rgb(245 158 11 / 0.15);
}
.border-amber-500\\/20{
  border-color: rgb(245 158 11 / 0.2);
}
.border-amber-500\\/25{
  border-color: rgb(245 158 11 / 0.25);
}
.border-amber-500\\/30{
  border-color: rgb(245 158 11 / 0.3);
}
.border-black\\/30{
  border-color: rgb(0 0 0 / 0.3);
}
.border-blue-500{
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}
.border-blue-500\\/20{
  border-color: rgb(59 130 246 / 0.2);
}
.border-blue-500\\/30{
  border-color: rgb(59 130 246 / 0.3);
}
.border-blue-600{
  --tw-border-opacity: 1;
  border-color: rgb(37 99 235 / var(--tw-border-opacity, 1));
}
.border-blue-700{
  --tw-border-opacity: 1;
  border-color: rgb(29 78 216 / var(--tw-border-opacity, 1));
}
.border-cyan-500{
  --tw-border-opacity: 1;
  border-color: rgb(6 182 212 / var(--tw-border-opacity, 1));
}
.border-cyan-500\\/20{
  border-color: rgb(6 182 212 / 0.2);
}
.border-cyan-500\\/30{
  border-color: rgb(6 182 212 / 0.3);
}
.border-emerald-200{
  --tw-border-opacity: 1;
  border-color: rgb(167 243 208 / var(--tw-border-opacity, 1));
}
.border-emerald-300{
  --tw-border-opacity: 1;
  border-color: rgb(110 231 183 / var(--tw-border-opacity, 1));
}
.border-emerald-400\\/20{
  border-color: rgb(52 211 153 / 0.2);
}
.border-emerald-500{
  --tw-border-opacity: 1;
  border-color: rgb(16 185 129 / var(--tw-border-opacity, 1));
}
.border-emerald-500\\/25{
  border-color: rgb(16 185 129 / 0.25);
}
.border-emerald-500\\/30{
  border-color: rgb(16 185 129 / 0.3);
}
.border-emerald-500\\/35{
  border-color: rgb(16 185 129 / 0.35);
}
.border-emerald-500\\/40{
  border-color: rgb(16 185 129 / 0.4);
}
.border-emerald-500\\/50{
  border-color: rgb(16 185 129 / 0.5);
}
.border-gray-100{
  --tw-border-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-border-opacity, 1));
}
.border-gray-200{
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}
.border-gray-300{
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}
.border-gray-400{
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity, 1));
}
.border-gray-500{
  --tw-border-opacity: 1;
  border-color: rgb(107 114 128 / var(--tw-border-opacity, 1));
}
.border-gray-600{
  --tw-border-opacity: 1;
  border-color: rgb(75 85 99 / var(--tw-border-opacity, 1));
}
.border-gray-700{
  --tw-border-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-border-opacity, 1));
}
.border-gray-800{
  --tw-border-opacity: 1;
  border-color: rgb(31 41 55 / var(--tw-border-opacity, 1));
}
.border-green-200{
  --tw-border-opacity: 1;
  border-color: rgb(187 247 208 / var(--tw-border-opacity, 1));
}
.border-green-300{
  --tw-border-opacity: 1;
  border-color: rgb(134 239 172 / var(--tw-border-opacity, 1));
}
.border-green-500{
  --tw-border-opacity: 1;
  border-color: rgb(34 197 94 / var(--tw-border-opacity, 1));
}
.border-green-500\\/20{
  border-color: rgb(34 197 94 / 0.2);
}
.border-green-500\\/30{
  border-color: rgb(34 197 94 / 0.3);
}
.border-green-600{
  --tw-border-opacity: 1;
  border-color: rgb(22 163 74 / var(--tw-border-opacity, 1));
}
.border-orange-100{
  --tw-border-opacity: 1;
  border-color: rgb(255 237 213 / var(--tw-border-opacity, 1));
}
.border-orange-500\\/20{
  border-color: rgb(249 115 22 / 0.2);
}
.border-purple-200{
  --tw-border-opacity: 1;
  border-color: rgb(233 213 255 / var(--tw-border-opacity, 1));
}
.border-purple-400\\/40{
  border-color: rgb(192 132 252 / 0.4);
}
.border-purple-500\\/20{
  border-color: rgb(168 85 247 / 0.2);
}
.border-red-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
}
.border-red-300{
  --tw-border-opacity: 1;
  border-color: rgb(252 165 165 / var(--tw-border-opacity, 1));
}
.border-red-500{
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}
.border-red-500\\/15{
  border-color: rgb(239 68 68 / 0.15);
}
.border-red-500\\/20{
  border-color: rgb(239 68 68 / 0.2);
}
.border-red-500\\/25{
  border-color: rgb(239 68 68 / 0.25);
}
.border-red-500\\/30{
  border-color: rgb(239 68 68 / 0.3);
}
.border-red-500\\/40{
  border-color: rgb(239 68 68 / 0.4);
}
.border-red-500\\/50{
  border-color: rgb(239 68 68 / 0.5);
}
.border-rose-100{
  --tw-border-opacity: 1;
  border-color: rgb(255 228 230 / var(--tw-border-opacity, 1));
}
.border-rose-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 205 211 / var(--tw-border-opacity, 1));
}
.border-rose-500\\/25{
  border-color: rgb(244 63 94 / 0.25);
}
.border-rose-500\\/30{
  border-color: rgb(244 63 94 / 0.3);
}
.border-rose-500\\/40{
  border-color: rgb(244 63 94 / 0.4);
}
.border-sky-200{
  --tw-border-opacity: 1;
  border-color: rgb(186 230 253 / var(--tw-border-opacity, 1));
}
.border-slate-100{
  --tw-border-opacity: 1;
  border-color: rgb(241 245 249 / var(--tw-border-opacity, 1));
}
.border-slate-200{
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
}
.border-slate-300{
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity, 1));
}
.border-teal-200{
  --tw-border-opacity: 1;
  border-color: rgb(153 246 228 / var(--tw-border-opacity, 1));
}
.border-transparent{
  border-color: transparent;
}
.border-violet-200{
  --tw-border-opacity: 1;
  border-color: rgb(221 214 254 / var(--tw-border-opacity, 1));
}
.border-violet-300{
  --tw-border-opacity: 1;
  border-color: rgb(196 181 253 / var(--tw-border-opacity, 1));
}
.border-violet-400\\/20{
  border-color: rgb(167 139 250 / 0.2);
}
.border-violet-500\\/25{
  border-color: rgb(139 92 246 / 0.25);
}
.border-violet-500\\/50{
  border-color: rgb(139 92 246 / 0.5);
}
.border-violet-600{
  --tw-border-opacity: 1;
  border-color: rgb(124 58 237 / var(--tw-border-opacity, 1));
}
.border-violet-700{
  --tw-border-opacity: 1;
  border-color: rgb(109 40 217 / var(--tw-border-opacity, 1));
}
.border-white{
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-white\\/10{
  border-color: rgb(255 255 255 / 0.1);
}
.border-white\\/15{
  border-color: rgb(255 255 255 / 0.15);
}
.border-white\\/20{
  border-color: rgb(255 255 255 / 0.2);
}
.border-white\\/25{
  border-color: rgb(255 255 255 / 0.25);
}
.border-white\\/30{
  border-color: rgb(255 255 255 / 0.3);
}
.border-white\\/40{
  border-color: rgb(255 255 255 / 0.4);
}
.border-white\\/5{
  border-color: rgb(255 255 255 / 0.05);
}
.border-white\\/\\[0\\.07\\]{
  border-color: rgb(255 255 255 / 0.07);
}
.border-white\\/\\[0\\.14\\]{
  border-color: rgb(255 255 255 / 0.14);
}
.border-yellow-400{
  --tw-border-opacity: 1;
  border-color: rgb(250 204 21 / var(--tw-border-opacity, 1));
}
.border-yellow-500\\/20{
  border-color: rgb(234 179 8 / 0.2);
}
.border-x-transparent{
  border-left-color: transparent;
  border-right-color: transparent;
}
.border-t-\\[\\#08151A\\]{
  --tw-border-opacity: 1;
  border-top-color: rgb(8 21 26 / var(--tw-border-opacity, 1));
}
.border-t-\\[\\#2fa9bf\\]{
  --tw-border-opacity: 1;
  border-top-color: rgb(47 169 191 / var(--tw-border-opacity, 1));
}
.border-t-\\[\\#8A8A85\\]{
  --tw-border-opacity: 1;
  border-top-color: rgb(138 138 133 / var(--tw-border-opacity, 1));
}
.border-t-\\[\\#BF1E2E\\]{
  --tw-border-opacity: 1;
  border-top-color: rgb(191 30 46 / var(--tw-border-opacity, 1));
}
.border-t-amber-400{
  --tw-border-opacity: 1;
  border-top-color: rgb(251 191 36 / var(--tw-border-opacity, 1));
}
.border-t-black{
  --tw-border-opacity: 1;
  border-top-color: rgb(0 0 0 / var(--tw-border-opacity, 1));
}
.border-t-emerald-400{
  --tw-border-opacity: 1;
  border-top-color: rgb(52 211 153 / var(--tw-border-opacity, 1));
}
.border-t-transparent{
  border-top-color: transparent;
}
.border-t-violet-400{
  --tw-border-opacity: 1;
  border-top-color: rgb(167 139 250 / var(--tw-border-opacity, 1));
}
.border-t-white{
  --tw-border-opacity: 1;
  border-top-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.\\!bg-\\[\\#141517\\]{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(20 21 23 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-\\[\\#1a1b1f\\]{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(26 27 31 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-\\[\\#F8F8F6\\]{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(248 248 246 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-white{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#050505\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(5 5 5 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#050608\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(5 6 8 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#070b14\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(7 11 20 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#080808\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(8 8 8 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#080808\\]\\/95{
  background-color: rgb(8 8 8 / 0.95);
}
.bg-\\[\\#0D0E10\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(13 14 16 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0E0F11\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(14 15 17 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0b1220\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(11 18 32 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0b1220\\]\\/90{
  background-color: rgb(11 18 32 / 0.9);
}
.bg-\\[\\#0b1220\\]\\/95{
  background-color: rgb(11 18 32 / 0.95);
}
.bg-\\[\\#0c0d0e\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(12 13 14 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0c1220\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(12 18 32 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0d0d0d\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(13 13 13 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0d0f0e\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(13 15 14 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#101010\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(16 16 16 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#101211\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(16 18 17 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#101211\\]\\/90{
  background-color: rgb(16 18 17 / 0.9);
}
.bg-\\[\\#111111\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(17 17 17 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#121314\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(18 19 20 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#12151a\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(18 21 26 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#141516\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(20 21 22 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#141517\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(20 21 23 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#141716\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(20 23 22 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#16171A\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(22 23 26 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#16171a\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(22 23 26 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#161917\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(22 25 23 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#161b22\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(22 27 34 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#163226\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(22 50 38 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#181818\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(24 24 24 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#181818\\]\\/90{
  background-color: rgb(24 24 24 / 0.9);
}
.bg-\\[\\#18191d\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(24 25 29 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1A1A18\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(26 26 24 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1A3038\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(26 48 56 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1C1D20\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(28 29 32 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1C1D20\\]\\/95{
  background-color: rgb(28 29 32 / 0.95);
}
.bg-\\[\\#1DA8C6\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(29 168 198 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1DA8C6\\]\\/10{
  background-color: rgb(29 168 198 / 0.1);
}
.bg-\\[\\#1DA8C6\\]\\/15{
  background-color: rgb(29 168 198 / 0.15);
}
.bg-\\[\\#1DA8C6\\]\\/20{
  background-color: rgb(29 168 198 / 0.2);
}
.bg-\\[\\#1E1E1E\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(30 30 30 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1a1a1a\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(26 26 26 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1a1b1e\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(26 27 30 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1a1b1f\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(26 27 31 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1a1d1c\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(26 29 28 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1a1f27\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(26 31 39 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1d1e21\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(29 30 33 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1d1e22\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(29 30 34 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1f2221\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(31 34 33 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#212226\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(33 34 38 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#221c20\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(34 28 32 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#222\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(34 34 34 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#242424\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(36 36 36 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#24252a\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(36 37 42 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#26222a\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(38 34 42 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#262626\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(38 38 38 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#26272b\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(38 39 43 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#26282C\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(38 40 44 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#26282C\\]\\/50{
  background-color: rgb(38 40 44 / 0.5);
}
.bg-\\[\\#29a3b4\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(41 163 180 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#2C2C2C\\]\\/70{
  background-color: rgb(44 44 44 / 0.7);
}
.bg-\\[\\#2a1810\\]\\/90{
  background-color: rgb(42 24 16 / 0.9);
}
.bg-\\[\\#2a2b31\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(42 43 49 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#2b9fb4\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(43 159 180 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#2e2f34\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(46 47 52 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#2fa9bf\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(47 169 191 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#2fa9bf\\]\\/10{
  background-color: rgb(47 169 191 / 0.1);
}
.bg-\\[\\#2fa9bf\\]\\/15{
  background-color: rgb(47 169 191 / 0.15);
}
.bg-\\[\\#2fa9bf\\]\\/20{
  background-color: rgb(47 169 191 / 0.2);
}
.bg-\\[\\#2fa9bf\\]\\/25{
  background-color: rgb(47 169 191 / 0.25);
}
.bg-\\[\\#2fa9bf\\]\\/35{
  background-color: rgb(47 169 191 / 0.35);
}
.bg-\\[\\#2fa9bf\\]\\/40{
  background-color: rgb(47 169 191 / 0.4);
}
.bg-\\[\\#303030\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(48 48 48 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#333735\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(51 55 53 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#345952\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(52 89 82 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#345952\\]\\/10{
  background-color: rgb(52 89 82 / 0.1);
}
.bg-\\[\\#345952\\]\\/5{
  background-color: rgb(52 89 82 / 0.05);
}
.bg-\\[\\#37383e\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(55 56 62 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#3a1520\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(58 21 32 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#3a2e14\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(58 46 20 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#3f3f3f\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(63 63 63 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#424242\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(66 66 66 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#494949\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(73 73 73 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#4ADE80\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(74 222 128 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#545454\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(84 84 84 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#7ECAD8\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(126 202 216 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#80C584\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(128 197 132 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#8fd3a8\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(143 211 168 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#B9DDB9\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(185 221 185 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#BF1E2E\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(191 30 46 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#C1C1C3\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(193 193 195 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#C5EAF0\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(197 234 240 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#C8E6CA\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(200 230 202 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#CCE4F8\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(204 228 248 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#CED8DF\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(206 216 223 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#D4C4A8\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(212 196 168 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#D8F0E6\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(216 240 230 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#D9E8F5\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(217 232 245 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E3EFFB\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(227 239 251 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E5A443\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(229 164 67 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E7F4EA\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(231 244 234 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E7F6F8\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(231 246 248 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E8D9C4\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(232 217 196 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E8E0F5\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(232 224 245 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E8E8E4\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(232 232 228 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E8E8E8\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(232 232 232 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E8F0EE\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(232 240 238 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E8F3EF\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(232 243 239 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E8F6F8\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(232 246 248 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E8F6F9\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(232 246 249 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#EAF2F8\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(234 242 248 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#EDB766\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(237 183 102 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F06A74\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(240 106 116 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F0ECF8\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(240 236 248 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F0F0EB\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(240 240 235 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F0F0EC\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(240 240 236 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F0F7F8\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(240 247 248 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F3E6D8\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(243 230 216 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F3EEE8\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(243 238 232 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F3F7F6\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(243 247 246 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F3FBFC\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(243 251 252 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F4F4F1\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(244 244 241 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F4F4F2\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(244 244 242 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F4F6F5\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(244 246 245 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F4FAF8\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(244 250 248 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F5F5F0\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 240 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F5F5F2\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 242 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F7FBFC\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(247 251 252 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F8D0D1\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(248 208 209 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F8DADA\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(248 218 218 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F8EAEA\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(248 234 234 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F8F8F6\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(248 248 246 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F8F8F6\\]\\/80{
  background-color: rgb(248 248 246 / 0.8);
}
.bg-\\[\\#F9F1EB\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(249 241 235 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FAFAF8\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 248 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FBFBF9\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(251 251 249 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FCE1B4\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(252 225 180 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FCE8E7\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(252 232 231 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FCF2E5\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(252 242 229 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FDE9C8\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(253 233 200 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FDFBF2\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(253 251 242 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FDFBF2\\]\\/60{
  background-color: rgb(253 251 242 / 0.6);
}
.bg-\\[\\#FFF7EB\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 247 235 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#b4b4b4\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(180 180 180 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#b6d7a8\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(182 215 168 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#c31c30\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(195 28 48 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#d6d4d5\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(214 212 213 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#d9d9d9\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(217 217 217 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#e11d2e\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(225 29 46 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#eaf6f8\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(234 246 248 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#eef9fc\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(238 249 252 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f97316\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(249 115 22 / var(--tw-bg-opacity, 1));
}
.bg-\\[rgba\\(10\\2c 11\\2c 13\\2c 0\\.7\\)\\]{
  background-color: rgba(10,11,13,0.7);
}
.bg-\\[rgba\\(10\\2c 11\\2c 13\\2c 0\\.75\\)\\]{
  background-color: rgba(10,11,13,0.75);
}
.bg-\\[rgba\\(10\\2c 11\\2c 13\\2c 0\\.85\\)\\]{
  background-color: rgba(10,11,13,0.85);
}
.bg-\\[rgba\\(127\\2c 199\\2c 154\\2c 0\\.12\\)\\]{
  background-color: rgba(127,199,154,0.12);
}
.bg-\\[rgba\\(156\\2c 154\\2c 155\\2c 0\\.16\\)\\]{
  background-color: rgba(156,154,155,0.16);
}
.bg-\\[rgba\\(191\\2c 30\\2c 46\\2c 0\\.12\\)\\]{
  background-color: rgba(191,30,46,0.12);
}
.bg-\\[rgba\\(191\\2c 30\\2c 46\\2c 0\\.15\\)\\]{
  background-color: rgba(191,30,46,0.15);
}
.bg-\\[rgba\\(191\\2c 30\\2c 46\\2c 0\\.16\\)\\]{
  background-color: rgba(191,30,46,0.16);
}
.bg-\\[rgba\\(191\\2c 30\\2c 46\\2c 0\\.2\\)\\]{
  background-color: rgba(191,30,46,0.2);
}
.bg-\\[rgba\\(191\\2c 30\\2c 46\\2c 0\\.22\\)\\]{
  background-color: rgba(191,30,46,0.22);
}
.bg-\\[rgba\\(229\\2c 164\\2c 67\\2c 0\\.13\\)\\]{
  background-color: rgba(229,164,67,0.13);
}
.bg-\\[rgba\\(229\\2c 164\\2c 67\\2c 0\\.16\\)\\]{
  background-color: rgba(229,164,67,0.16);
}
.bg-\\[rgba\\(29\\2c 168\\2c 198\\2c 0\\.08\\)\\]{
  background-color: rgba(29,168,198,0.08);
}
.bg-\\[rgba\\(29\\2c 168\\2c 198\\2c 0\\.14\\)\\]{
  background-color: rgba(29,168,198,0.14);
}
.bg-\\[rgba\\(29\\2c 168\\2c 198\\2c 0\\.16\\)\\]{
  background-color: rgba(29,168,198,0.16);
}
.bg-\\[rgba\\(29\\2c 168\\2c 198\\2c 0\\.18\\)\\]{
  background-color: rgba(29,168,198,0.18);
}
.bg-\\[var\\(--cu-accent\\)\\]{
  background-color: var(--cu-accent);
}
.bg-\\[var\\(--cu-accent-soft\\)\\]{
  background-color: var(--cu-accent-soft);
}
.bg-\\[var\\(--cu-bg\\)\\]{
  background-color: var(--cu-bg);
}
.bg-\\[var\\(--cu-border\\)\\]{
  background-color: var(--cu-border);
}
.bg-\\[var\\(--cu-chip\\)\\]{
  background-color: var(--cu-chip);
}
.bg-\\[var\\(--cu-elevated\\)\\]{
  background-color: var(--cu-elevated);
}
.bg-\\[var\\(--cu-input\\)\\]{
  background-color: var(--cu-input);
}
.bg-\\[var\\(--cu-surface\\)\\]{
  background-color: var(--cu-surface);
}
.bg-amber-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity, 1));
}
.bg-amber-200{
  --tw-bg-opacity: 1;
  background-color: rgb(253 230 138 / var(--tw-bg-opacity, 1));
}
.bg-amber-400{
  --tw-bg-opacity: 1;
  background-color: rgb(251 191 36 / var(--tw-bg-opacity, 1));
}
.bg-amber-400\\/10{
  background-color: rgb(251 191 36 / 0.1);
}
.bg-amber-50{
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
}
.bg-amber-50\\/40{
  background-color: rgb(255 251 235 / 0.4);
}
.bg-amber-50\\/60{
  background-color: rgb(255 251 235 / 0.6);
}
.bg-amber-500{
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity, 1));
}
.bg-amber-500\\/10{
  background-color: rgb(245 158 11 / 0.1);
}
.bg-amber-500\\/20{
  background-color: rgb(245 158 11 / 0.2);
}
.bg-amber-500\\/25{
  background-color: rgb(245 158 11 / 0.25);
}
.bg-amber-500\\/5{
  background-color: rgb(245 158 11 / 0.05);
}
.bg-amber-500\\/90{
  background-color: rgb(245 158 11 / 0.9);
}
.bg-amber-600{
  --tw-bg-opacity: 1;
  background-color: rgb(217 119 6 / var(--tw-bg-opacity, 1));
}
.bg-amber-950\\/20{
  background-color: rgb(69 26 3 / 0.2);
}
.bg-amber-950\\/30{
  background-color: rgb(69 26 3 / 0.3);
}
.bg-amber-950\\/40{
  background-color: rgb(69 26 3 / 0.4);
}
.bg-amber-950\\/80{
  background-color: rgb(69 26 3 / 0.8);
}
.bg-amber-950\\/85{
  background-color: rgb(69 26 3 / 0.85);
}
.bg-black{
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-black\\/0{
  background-color: rgb(0 0 0 / 0);
}
.bg-black\\/30{
  background-color: rgb(0 0 0 / 0.3);
}
.bg-black\\/35{
  background-color: rgb(0 0 0 / 0.35);
}
.bg-black\\/40{
  background-color: rgb(0 0 0 / 0.4);
}
.bg-black\\/45{
  background-color: rgb(0 0 0 / 0.45);
}
.bg-black\\/50{
  background-color: rgb(0 0 0 / 0.5);
}
.bg-black\\/55{
  background-color: rgb(0 0 0 / 0.55);
}
.bg-black\\/60{
  background-color: rgb(0 0 0 / 0.6);
}
.bg-black\\/65{
  background-color: rgb(0 0 0 / 0.65);
}
.bg-black\\/70{
  background-color: rgb(0 0 0 / 0.7);
}
.bg-black\\/80{
  background-color: rgb(0 0 0 / 0.8);
}
.bg-black\\/90{
  background-color: rgb(0 0 0 / 0.9);
}
.bg-blue-300{
  --tw-bg-opacity: 1;
  background-color: rgb(147 197 253 / var(--tw-bg-opacity, 1));
}
.bg-blue-400{
  --tw-bg-opacity: 1;
  background-color: rgb(96 165 250 / var(--tw-bg-opacity, 1));
}
.bg-blue-50{
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.bg-blue-500{
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}
.bg-blue-500\\/10{
  background-color: rgb(59 130 246 / 0.1);
}
.bg-blue-600{
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.bg-blue-600\\/40{
  background-color: rgb(37 99 235 / 0.4);
}
.bg-cyan-400{
  --tw-bg-opacity: 1;
  background-color: rgb(34 211 238 / var(--tw-bg-opacity, 1));
}
.bg-cyan-50{
  --tw-bg-opacity: 1;
  background-color: rgb(236 254 255 / var(--tw-bg-opacity, 1));
}
.bg-cyan-500{
  --tw-bg-opacity: 1;
  background-color: rgb(6 182 212 / var(--tw-bg-opacity, 1));
}
.bg-cyan-500\\/10{
  background-color: rgb(6 182 212 / 0.1);
}
.bg-cyan-500\\/15{
  background-color: rgb(6 182 212 / 0.15);
}
.bg-cyan-500\\/5{
  background-color: rgb(6 182 212 / 0.05);
}
.bg-cyan-600{
  --tw-bg-opacity: 1;
  background-color: rgb(8 145 178 / var(--tw-bg-opacity, 1));
}
.bg-cyan-950\\/20{
  background-color: rgb(8 51 68 / 0.2);
}
.bg-emerald-100{
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity, 1));
}
.bg-emerald-400{
  --tw-bg-opacity: 1;
  background-color: rgb(52 211 153 / var(--tw-bg-opacity, 1));
}
.bg-emerald-50{
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity, 1));
}
.bg-emerald-50\\/40{
  background-color: rgb(236 253 245 / 0.4);
}
.bg-emerald-500{
  --tw-bg-opacity: 1;
  background-color: rgb(16 185 129 / var(--tw-bg-opacity, 1));
}
.bg-emerald-500\\/15{
  background-color: rgb(16 185 129 / 0.15);
}
.bg-emerald-500\\/90{
  background-color: rgb(16 185 129 / 0.9);
}
.bg-emerald-600{
  --tw-bg-opacity: 1;
  background-color: rgb(5 150 105 / var(--tw-bg-opacity, 1));
}
.bg-emerald-600\\/90{
  background-color: rgb(5 150 105 / 0.9);
}
.bg-emerald-950\\/30{
  background-color: rgb(2 44 34 / 0.3);
}
.bg-emerald-950\\/40{
  background-color: rgb(2 44 34 / 0.4);
}
.bg-emerald-950\\/85{
  background-color: rgb(2 44 34 / 0.85);
}
.bg-gray-100{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.bg-gray-200{
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.bg-gray-200\\/60{
  background-color: rgb(229 231 235 / 0.6);
}
.bg-gray-300{
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}
.bg-gray-400{
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity, 1));
}
.bg-gray-50{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.bg-gray-50\\/60{
  background-color: rgb(249 250 251 / 0.6);
}
.bg-gray-50\\/80{
  background-color: rgb(249 250 251 / 0.8);
}
.bg-gray-500{
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity, 1));
}
.bg-gray-600{
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}
.bg-gray-700{
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}
.bg-gray-800\\/70{
  background-color: rgb(31 41 55 / 0.7);
}
.bg-gray-900{
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity, 1));
}
.bg-green-100{
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));
}
.bg-green-50{
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity, 1));
}
.bg-green-500{
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1));
}
.bg-green-500\\/10{
  background-color: rgb(34 197 94 / 0.1);
}
.bg-green-500\\/15{
  background-color: rgb(34 197 94 / 0.15);
}
.bg-green-600{
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
}
.bg-indigo-50{
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 255 / var(--tw-bg-opacity, 1));
}
.bg-orange-200{
  --tw-bg-opacity: 1;
  background-color: rgb(254 215 170 / var(--tw-bg-opacity, 1));
}
.bg-orange-400{
  --tw-bg-opacity: 1;
  background-color: rgb(251 146 60 / var(--tw-bg-opacity, 1));
}
.bg-orange-50{
  --tw-bg-opacity: 1;
  background-color: rgb(255 247 237 / var(--tw-bg-opacity, 1));
}
.bg-orange-500{
  --tw-bg-opacity: 1;
  background-color: rgb(249 115 22 / var(--tw-bg-opacity, 1));
}
.bg-orange-500\\/10{
  background-color: rgb(249 115 22 / 0.1);
}
.bg-purple-300{
  --tw-bg-opacity: 1;
  background-color: rgb(216 180 254 / var(--tw-bg-opacity, 1));
}
.bg-purple-50{
  --tw-bg-opacity: 1;
  background-color: rgb(250 245 255 / var(--tw-bg-opacity, 1));
}
.bg-purple-500{
  --tw-bg-opacity: 1;
  background-color: rgb(168 85 247 / var(--tw-bg-opacity, 1));
}
.bg-purple-500\\/10{
  background-color: rgb(168 85 247 / 0.1);
}
.bg-purple-600{
  --tw-bg-opacity: 1;
  background-color: rgb(147 51 234 / var(--tw-bg-opacity, 1));
}
.bg-purple-600\\/30{
  background-color: rgb(147 51 234 / 0.3);
}
.bg-purple-950\\/80{
  background-color: rgb(59 7 100 / 0.8);
}
.bg-red-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}
.bg-red-300{
  --tw-bg-opacity: 1;
  background-color: rgb(252 165 165 / var(--tw-bg-opacity, 1));
}
.bg-red-400{
  --tw-bg-opacity: 1;
  background-color: rgb(248 113 113 / var(--tw-bg-opacity, 1));
}
.bg-red-50{
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.bg-red-500{
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.bg-red-500\\/10{
  background-color: rgb(239 68 68 / 0.1);
}
.bg-red-500\\/15{
  background-color: rgb(239 68 68 / 0.15);
}
.bg-red-500\\/5{
  background-color: rgb(239 68 68 / 0.05);
}
.bg-red-600{
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}
.bg-red-950\\/40{
  background-color: rgb(69 10 10 / 0.4);
}
.bg-rose-100{
  --tw-bg-opacity: 1;
  background-color: rgb(255 228 230 / var(--tw-bg-opacity, 1));
}
.bg-rose-400{
  --tw-bg-opacity: 1;
  background-color: rgb(251 113 133 / var(--tw-bg-opacity, 1));
}
.bg-rose-50{
  --tw-bg-opacity: 1;
  background-color: rgb(255 241 242 / var(--tw-bg-opacity, 1));
}
.bg-rose-50\\/70{
  background-color: rgb(255 241 242 / 0.7);
}
.bg-rose-950\\/30{
  background-color: rgb(76 5 25 / 0.3);
}
.bg-rose-950\\/40{
  background-color: rgb(76 5 25 / 0.4);
}
.bg-sky-100{
  --tw-bg-opacity: 1;
  background-color: rgb(224 242 254 / var(--tw-bg-opacity, 1));
}
.bg-sky-50{
  --tw-bg-opacity: 1;
  background-color: rgb(240 249 255 / var(--tw-bg-opacity, 1));
}
.bg-sky-50\\/30{
  background-color: rgb(240 249 255 / 0.3);
}
.bg-sky-50\\/70{
  background-color: rgb(240 249 255 / 0.7);
}
.bg-slate-100{
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}
.bg-slate-200{
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1));
}
.bg-slate-50{
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
.bg-slate-600{
  --tw-bg-opacity: 1;
  background-color: rgb(71 85 105 / var(--tw-bg-opacity, 1));
}
.bg-slate-900\\/50{
  background-color: rgb(15 23 42 / 0.5);
}
.bg-teal-200{
  --tw-bg-opacity: 1;
  background-color: rgb(153 246 228 / var(--tw-bg-opacity, 1));
}
.bg-teal-50{
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 250 / var(--tw-bg-opacity, 1));
}
.bg-teal-50\\/80{
  background-color: rgb(240 253 250 / 0.8);
}
.bg-transparent{
  background-color: transparent;
}
.bg-violet-100{
  --tw-bg-opacity: 1;
  background-color: rgb(237 233 254 / var(--tw-bg-opacity, 1));
}
.bg-violet-400{
  --tw-bg-opacity: 1;
  background-color: rgb(167 139 250 / var(--tw-bg-opacity, 1));
}
.bg-violet-50{
  --tw-bg-opacity: 1;
  background-color: rgb(245 243 255 / var(--tw-bg-opacity, 1));
}
.bg-violet-50\\/80{
  background-color: rgb(245 243 255 / 0.8);
}
.bg-violet-500{
  --tw-bg-opacity: 1;
  background-color: rgb(139 92 246 / var(--tw-bg-opacity, 1));
}
.bg-violet-500\\/90{
  background-color: rgb(139 92 246 / 0.9);
}
.bg-violet-600{
  --tw-bg-opacity: 1;
  background-color: rgb(124 58 237 / var(--tw-bg-opacity, 1));
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-white\\/10{
  background-color: rgb(255 255 255 / 0.1);
}
.bg-white\\/15{
  background-color: rgb(255 255 255 / 0.15);
}
.bg-white\\/20{
  background-color: rgb(255 255 255 / 0.2);
}
.bg-white\\/25{
  background-color: rgb(255 255 255 / 0.25);
}
.bg-white\\/30{
  background-color: rgb(255 255 255 / 0.3);
}
.bg-white\\/5{
  background-color: rgb(255 255 255 / 0.05);
}
.bg-white\\/60{
  background-color: rgb(255 255 255 / 0.6);
}
.bg-white\\/70{
  background-color: rgb(255 255 255 / 0.7);
}
.bg-white\\/80{
  background-color: rgb(255 255 255 / 0.8);
}
.bg-white\\/90{
  background-color: rgb(255 255 255 / 0.9);
}
.bg-white\\/\\[0\\.02\\]{
  background-color: rgb(255 255 255 / 0.02);
}
.bg-white\\/\\[0\\.03\\]{
  background-color: rgb(255 255 255 / 0.03);
}
.bg-white\\/\\[0\\.04\\]{
  background-color: rgb(255 255 255 / 0.04);
}
.bg-white\\/\\[0\\.07\\]{
  background-color: rgb(255 255 255 / 0.07);
}
.bg-yellow-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 249 195 / var(--tw-bg-opacity, 1));
}
.bg-yellow-200{
  --tw-bg-opacity: 1;
  background-color: rgb(254 240 138 / var(--tw-bg-opacity, 1));
}
.bg-yellow-400{
  --tw-bg-opacity: 1;
  background-color: rgb(250 204 21 / var(--tw-bg-opacity, 1));
}
.bg-yellow-500{
  --tw-bg-opacity: 1;
  background-color: rgb(234 179 8 / var(--tw-bg-opacity, 1));
}
.bg-yellow-500\\/10{
  background-color: rgb(234 179 8 / 0.1);
}
.bg-yellow-500\\/5{
  background-color: rgb(234 179 8 / 0.05);
}
.bg-zinc-950{
  --tw-bg-opacity: 1;
  background-color: rgb(9 9 11 / var(--tw-bg-opacity, 1));
}
.bg-opacity-40{
  --tw-bg-opacity: 0.4;
}
.bg-opacity-50{
  --tw-bg-opacity: 0.5;
}
.bg-gradient-to-b{
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}
.bg-gradient-to-br{
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.bg-gradient-to-r{
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.bg-gradient-to-tr{
  background-image: linear-gradient(to top right, var(--tw-gradient-stops));
}
.from-\\[\\#0a0d12\\]{
  --tw-gradient-from: #0a0d12 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(10 13 18 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#101211\\]{
  --tw-gradient-from: #101211 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(16 18 17 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#1DA8C6\\]{
  --tw-gradient-from: #1DA8C6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(29 168 198 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#1c3b41\\]{
  --tw-gradient-from: #1c3b41 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(28 59 65 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#2fa9bf\\]{
  --tw-gradient-from: #2fa9bf var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(47 169 191 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#2fa9bf\\]\\/10{
  --tw-gradient-from: rgb(47 169 191 / 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(47 169 191 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-black{
  --tw-gradient-from: #000 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-400{
  --tw-gradient-from: #60a5fa var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(96 165 250 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-500{
  --tw-gradient-from: #3b82f6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(59 130 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-500\\/20{
  --tw-gradient-from: rgb(59 130 246 / 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(59 130 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-500\\/5{
  --tw-gradient-from: rgb(59 130 246 / 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(59 130 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-600{
  --tw-gradient-from: #2563eb var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(37 99 235 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-cyan-400{
  --tw-gradient-from: #22d3ee var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(34 211 238 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-cyan-500{
  --tw-gradient-from: #06b6d4 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(6 182 212 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-gray-50{
  --tw-gradient-from: #f9fafb var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(249 250 251 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-gray-950{
  --tw-gradient-from: #030712 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(3 7 18 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-900\\/40{
  --tw-gradient-from: rgb(15 23 42 / 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(15 23 42 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-white\\/10{
  --tw-gradient-from: rgb(255 255 255 / 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-\\[\\#07090c\\]{
  --tw-gradient-to: rgb(7 9 12 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #07090c var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#134851\\]{
  --tw-gradient-to: rgb(19 72 81 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #134851 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-gray-900{
  --tw-gradient-to: rgb(17 24 39 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #111827 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-purple-500{
  --tw-gradient-to: rgb(168 85 247 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #a855f7 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-slate-900\\/20{
  --tw-gradient-to: rgb(15 23 42 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(15 23 42 / 0.2) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-transparent{
  --tw-gradient-to: rgb(0 0 0 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), transparent var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-\\[\\#14879f\\]{
  --tw-gradient-to: #14879f var(--tw-gradient-to-position);
}
.to-\\[\\#151716\\]{
  --tw-gradient-to: #151716 var(--tw-gradient-to-position);
}
.to-\\[\\#2b9fb4\\]{
  --tw-gradient-to: #2b9fb4 var(--tw-gradient-to-position);
}
.to-\\[\\#345952\\]{
  --tw-gradient-to: #345952 var(--tw-gradient-to-position);
}
.to-\\[\\#6fd3e3\\]{
  --tw-gradient-to: #6fd3e3 var(--tw-gradient-to-position);
}
.to-\\[\\#6fd3e3\\]\\/10{
  --tw-gradient-to: rgb(111 211 227 / 0.1) var(--tw-gradient-to-position);
}
.to-black{
  --tw-gradient-to: #000 var(--tw-gradient-to-position);
}
.to-black\\/50{
  --tw-gradient-to: rgb(0 0 0 / 0.5) var(--tw-gradient-to-position);
}
.to-blue-300{
  --tw-gradient-to: #93c5fd var(--tw-gradient-to-position);
}
.to-blue-500{
  --tw-gradient-to: #3b82f6 var(--tw-gradient-to-position);
}
.to-blue-500\\/10{
  --tw-gradient-to: rgb(59 130 246 / 0.1) var(--tw-gradient-to-position);
}
.to-blue-600{
  --tw-gradient-to: #2563eb var(--tw-gradient-to-position);
}
.to-cyan-300{
  --tw-gradient-to: #67e8f9 var(--tw-gradient-to-position);
}
.to-cyan-400{
  --tw-gradient-to: #22d3ee var(--tw-gradient-to-position);
}
.to-emerald-400{
  --tw-gradient-to: #34d399 var(--tw-gradient-to-position);
}
.to-gray-800{
  --tw-gradient-to: #1f2937 var(--tw-gradient-to-position);
}
.to-transparent{
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}
.to-white{
  --tw-gradient-to: #fff var(--tw-gradient-to-position);
}
.bg-clip-text{
  -webkit-background-clip: text;
          background-clip: text;
}
.stroke-\\[3\\]{
  stroke-width: 3;
}
.object-contain{
  -o-object-fit: contain;
     object-fit: contain;
}
.object-cover{
  -o-object-fit: cover;
     object-fit: cover;
}
.object-fill{
  -o-object-fit: fill;
     object-fit: fill;
}
.object-center{
  -o-object-position: center;
     object-position: center;
}
.p-0{
  padding: 0px;
}
.p-0\\.5{
  padding: 0.125rem;
}
.p-1{
  padding: 0.25rem;
}
.p-1\\.5{
  padding: 0.375rem;
}
.p-10{
  padding: 2.5rem;
}
.p-12{
  padding: 3rem;
}
.p-2{
  padding: 0.5rem;
}
.p-2\\.5{
  padding: 0.625rem;
}
.p-3{
  padding: 0.75rem;
}
.p-3\\.5{
  padding: 0.875rem;
}
.p-4{
  padding: 1rem;
}
.p-5{
  padding: 1.25rem;
}
.p-6{
  padding: 1.5rem;
}
.p-7{
  padding: 1.75rem;
}
.p-8{
  padding: 2rem;
}
.\\!px-6{
  padding-left: 1.5rem !important;
  padding-right: 1.5rem !important;
}
.\\!py-1\\.5{
  padding-top: 0.375rem !important;
  padding-bottom: 0.375rem !important;
}
.\\!py-2\\.5{
  padding-top: 0.625rem !important;
  padding-bottom: 0.625rem !important;
}
.px-0{
  padding-left: 0px;
  padding-right: 0px;
}
.px-0\\.5{
  padding-left: 0.125rem;
  padding-right: 0.125rem;
}
.px-1{
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5{
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-12{
  padding-left: 3rem;
  padding-right: 3rem;
}
.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5{
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-3\\.5{
  padding-left: 0.875rem;
  padding-right: 0.875rem;
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5{
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8{
  padding-left: 2rem;
  padding-right: 2rem;
}
.px-\\[11px\\]{
  padding-left: 11px;
  padding-right: 11px;
}
.px-\\[18px\\]{
  padding-left: 18px;
  padding-right: 18px;
}
.px-\\[1vw\\]{
  padding-left: 1vw;
  padding-right: 1vw;
}
.px-\\[22px\\]{
  padding-left: 22px;
  padding-right: 22px;
}
.px-\\[4\\%\\]{
  padding-left: 4%;
  padding-right: 4%;
}
.px-\\[5vw\\]{
  padding-left: 5vw;
  padding-right: 5vw;
}
.px-\\[9px\\]{
  padding-left: 9px;
  padding-right: 9px;
}
.py-0{
  padding-top: 0px;
  padding-bottom: 0px;
}
.py-0\\.5{
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-10{
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-12{
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-14{
  padding-top: 3.5rem;
  padding-bottom: 3.5rem;
}
.py-16{
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5{
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-20{
  padding-top: 5rem;
  padding-bottom: 5rem;
}
.py-24{
  padding-top: 6rem;
  padding-bottom: 6rem;
}
.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-3\\.5{
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}
.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5{
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6{
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-8{
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.py-\\[0\\.25vw\\]{
  padding-top: 0.25vw;
  padding-bottom: 0.25vw;
}
.py-\\[18px\\]{
  padding-top: 18px;
  padding-bottom: 18px;
}
.py-\\[26px\\]{
  padding-top: 26px;
  padding-bottom: 26px;
}
.py-\\[3px\\]{
  padding-top: 3px;
  padding-bottom: 3px;
}
.py-\\[3vw\\]{
  padding-top: 3vw;
  padding-bottom: 3vw;
}
.py-\\[4px\\]{
  padding-top: 4px;
  padding-bottom: 4px;
}
.py-\\[5px\\]{
  padding-top: 5px;
  padding-bottom: 5px;
}
.pb-1{
  padding-bottom: 0.25rem;
}
.pb-12{
  padding-bottom: 3rem;
}
.pb-2{
  padding-bottom: 0.5rem;
}
.pb-24{
  padding-bottom: 6rem;
}
.pb-3{
  padding-bottom: 0.75rem;
}
.pb-3\\.5{
  padding-bottom: 0.875rem;
}
.pb-4{
  padding-bottom: 1rem;
}
.pb-5{
  padding-bottom: 1.25rem;
}
.pb-6{
  padding-bottom: 1.5rem;
}
.pb-8{
  padding-bottom: 2rem;
}
.pb-\\[max\\(0\\.75rem\\2c env\\(safe-area-inset-bottom\\)\\)\\]{
  padding-bottom: max(0.75rem,env(safe-area-inset-bottom));
}
.pb-\\[max\\(1\\.25rem\\2c env\\(safe-area-inset-bottom\\)\\)\\]{
  padding-bottom: max(1.25rem,env(safe-area-inset-bottom));
}
.pb-\\[max\\(1rem\\2c env\\(safe-area-inset-bottom\\)\\)\\]{
  padding-bottom: max(1rem,env(safe-area-inset-bottom));
}
.pl-10{
  padding-left: 2.5rem;
}
.pl-11{
  padding-left: 2.75rem;
}
.pl-12{
  padding-left: 3rem;
}
.pl-2{
  padding-left: 0.5rem;
}
.pl-3{
  padding-left: 0.75rem;
}
.pl-4{
  padding-left: 1rem;
}
.pl-5{
  padding-left: 1.25rem;
}
.pl-6{
  padding-left: 1.5rem;
}
.pl-8{
  padding-left: 2rem;
}
.pl-9{
  padding-left: 2.25rem;
}
.pl-\\[34px\\]{
  padding-left: 34px;
}
.pl-\\[3vw\\]{
  padding-left: 3vw;
}
.pl-\\[62px\\]{
  padding-left: 62px;
}
.pr-1{
  padding-right: 0.25rem;
}
.pr-10{
  padding-right: 2.5rem;
}
.pr-2{
  padding-right: 0.5rem;
}
.pr-3{
  padding-right: 0.75rem;
}
.pr-4{
  padding-right: 1rem;
}
.pr-5{
  padding-right: 1.25rem;
}
.pr-6{
  padding-right: 1.5rem;
}
.pr-8{
  padding-right: 2rem;
}
.pr-9{
  padding-right: 2.25rem;
}
.pr-\\[17\\.5\\%\\]{
  padding-right: 17.5%;
}
.pt-0{
  padding-top: 0px;
}
.pt-0\\.5{
  padding-top: 0.125rem;
}
.pt-1{
  padding-top: 0.25rem;
}
.pt-1\\.5{
  padding-top: 0.375rem;
}
.pt-16{
  padding-top: 4rem;
}
.pt-2{
  padding-top: 0.5rem;
}
.pt-2\\.5{
  padding-top: 0.625rem;
}
.pt-3{
  padding-top: 0.75rem;
}
.pt-4{
  padding-top: 1rem;
}
.pt-5{
  padding-top: 1.25rem;
}
.pt-7{
  padding-top: 1.75rem;
}
.pt-8{
  padding-top: 2rem;
}
.pt-\\[18px\\]{
  padding-top: 18px;
}
.pt-\\[4\\.25rem\\]{
  padding-top: 4.25rem;
}
.text-left{
  text-align: left;
}
.text-center{
  text-align: center;
}
.text-right{
  text-align: right;
}
.text-justify{
  text-align: justify;
}
.text-start{
  text-align: start;
}
.align-top{
  vertical-align: top;
}
.align-middle{
  vertical-align: middle;
}
.align-bottom{
  vertical-align: bottom;
}
.font-\\[Montserrat\\2c sans-serif\\]{
  font-family: Montserrat,sans-serif;
}
.font-\\[Poppins\\]{
  font-family: Poppins;
}
.font-mono{
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.\\!text-sm{
  font-size: 0.875rem !important;
  line-height: 1.25rem !important;
}
.text-2xl{
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl{
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl{
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-5xl{
  font-size: 3rem;
  line-height: 1;
}
.text-6xl{
  font-size: 3.75rem;
  line-height: 1;
}
.text-\\[0\\.65rem\\]{
  font-size: 0.65rem;
}
.text-\\[0\\.7rem\\]{
  font-size: 0.7rem;
}
.text-\\[0\\.8vw\\]{
  font-size: 0.8vw;
}
.text-\\[1\\.05rem\\]{
  font-size: 1.05rem;
}
.text-\\[1\\.1vw\\]{
  font-size: 1.1vw;
}
.text-\\[1\\.2rem\\]{
  font-size: 1.2rem;
}
.text-\\[10\\.5px\\]{
  font-size: 10.5px;
}
.text-\\[10px\\]{
  font-size: 10px;
}
.text-\\[11\\.5px\\]{
  font-size: 11.5px;
}
.text-\\[11px\\]{
  font-size: 11px;
}
.text-\\[12\\.5px\\]{
  font-size: 12.5px;
}
.text-\\[12px\\]{
  font-size: 12px;
}
.text-\\[13\\.5px\\]{
  font-size: 13.5px;
}
.text-\\[13px\\]{
  font-size: 13px;
}
.text-\\[14px\\]{
  font-size: 14px;
}
.text-\\[15px\\]{
  font-size: 15px;
}
.text-\\[16px\\]{
  font-size: 16px;
}
.text-\\[17px\\]{
  font-size: 17px;
}
.text-\\[18px\\]{
  font-size: 18px;
}
.text-\\[28px\\]{
  font-size: 28px;
}
.text-\\[4\\.375vw\\]{
  font-size: 4.375vw;
}
.text-\\[4vw\\]{
  font-size: 4vw;
}
.text-\\[5vw\\]{
  font-size: 5vw;
}
.text-\\[6px\\]{
  font-size: 6px;
}
.text-\\[90\\%\\]{
  font-size: 90%;
}
.text-\\[9px\\]{
  font-size: 9px;
}
.text-\\[clamp\\(22px\\2c 3vw\\2c 32px\\)\\]{
  font-size: clamp(22px,3vw,32px);
}
.text-\\[clamp\\(28px\\2c 4vw\\2c 48px\\)\\]{
  font-size: clamp(28px,4vw,48px);
}
.text-base{
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg{
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl{
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs{
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-\\[DM_Sans\\2c sans-serif\\]{
  font-weight: DM Sans,sans-serif;
}
.font-black{
  font-weight: 900;
}
.font-bold{
  font-weight: 700;
}
.font-extrabold{
  font-weight: 800;
}
.font-medium{
  font-weight: 500;
}
.font-normal{
  font-weight: 400;
}
.font-semibold{
  font-weight: 600;
}
.uppercase{
  text-transform: uppercase;
}
.capitalize{
  text-transform: capitalize;
}
.normal-case{
  text-transform: none;
}
.italic{
  font-style: italic;
}
.tabular-nums{
  --tw-numeric-spacing: tabular-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.leading-4{
  line-height: 1rem;
}
.leading-5{
  line-height: 1.25rem;
}
.leading-6{
  line-height: 1.5rem;
}
.leading-7{
  line-height: 1.75rem;
}
.leading-none{
  line-height: 1;
}
.leading-relaxed{
  line-height: 1.625;
}
.leading-snug{
  line-height: 1.375;
}
.leading-tight{
  line-height: 1.25;
}
.tracking-\\[0\\.08em\\]{
  letter-spacing: 0.08em;
}
.tracking-\\[0\\.12em\\]{
  letter-spacing: 0.12em;
}
.tracking-\\[0\\.14em\\]{
  letter-spacing: 0.14em;
}
.tracking-\\[0\\.18em\\]{
  letter-spacing: 0.18em;
}
.tracking-normal{
  letter-spacing: 0em;
}
.tracking-tight{
  letter-spacing: -0.025em;
}
.tracking-wide{
  letter-spacing: 0.025em;
}
.tracking-wider{
  letter-spacing: 0.05em;
}
.tracking-widest{
  letter-spacing: 0.1em;
}
.\\!text-\\[\\#2fa9bf\\]{
  --tw-text-opacity: 1 !important;
  color: rgb(47 169 191 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-\\[\\#8b8d93\\]{
  --tw-text-opacity: 1 !important;
  color: rgb(139 141 147 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-\\[\\#c5c7cc\\]{
  --tw-text-opacity: 1 !important;
  color: rgb(197 199 204 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-white{
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#08151A\\]{
  --tw-text-opacity: 1;
  color: rgb(8 21 26 / var(--tw-text-opacity, 1));
}
.text-\\[\\#0A5A70\\]{
  --tw-text-opacity: 1;
  color: rgb(10 90 112 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1A1A18\\]{
  --tw-text-opacity: 1;
  color: rgb(26 26 24 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1A1A1A\\]{
  --tw-text-opacity: 1;
  color: rgb(26 26 26 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1A6B78\\]{
  --tw-text-opacity: 1;
  color: rgb(26 107 120 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1A7A86\\]{
  --tw-text-opacity: 1;
  color: rgb(26 122 134 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1DA8C6\\]{
  --tw-text-opacity: 1;
  color: rgb(29 168 198 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1F1F1C\\]{
  --tw-text-opacity: 1;
  color: rgb(31 31 28 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1F5C24\\]{
  --tw-text-opacity: 1;
  color: rgb(31 92 36 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1F6B52\\]{
  --tw-text-opacity: 1;
  color: rgb(31 107 82 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1F6F7A\\]{
  --tw-text-opacity: 1;
  color: rgb(31 111 122 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1F6F7C\\]{
  --tw-text-opacity: 1;
  color: rgb(31 111 124 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1a1a1a\\]{
  --tw-text-opacity: 1;
  color: rgb(26 26 26 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1a1b1e\\]{
  --tw-text-opacity: 1;
  color: rgb(26 27 30 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1e99af\\]{
  --tw-text-opacity: 1;
  color: rgb(30 153 175 / var(--tw-text-opacity, 1));
}
.text-\\[\\#29a3b4\\]{
  --tw-text-opacity: 1;
  color: rgb(41 163 180 / var(--tw-text-opacity, 1));
}
.text-\\[\\#2A2A28\\]{
  --tw-text-opacity: 1;
  color: rgb(42 42 40 / var(--tw-text-opacity, 1));
}
.text-\\[\\#2C2C2A\\]{
  --tw-text-opacity: 1;
  color: rgb(44 44 42 / var(--tw-text-opacity, 1));
}
.text-\\[\\#2C2C2C\\]{
  --tw-text-opacity: 1;
  color: rgb(44 44 44 / var(--tw-text-opacity, 1));
}
.text-\\[\\#2E6A9E\\]{
  --tw-text-opacity: 1;
  color: rgb(46 106 158 / var(--tw-text-opacity, 1));
}
.text-\\[\\#2a7d8c\\]{
  --tw-text-opacity: 1;
  color: rgb(42 125 140 / var(--tw-text-opacity, 1));
}
.text-\\[\\#2fa9bf\\]{
  --tw-text-opacity: 1;
  color: rgb(47 169 191 / var(--tw-text-opacity, 1));
}
.text-\\[\\#2fa9bf\\]\\/20{
  color: rgb(47 169 191 / 0.2);
}
.text-\\[\\#333333\\]{
  --tw-text-opacity: 1;
  color: rgb(51 51 51 / var(--tw-text-opacity, 1));
}
.text-\\[\\#345952\\]{
  --tw-text-opacity: 1;
  color: rgb(52 89 82 / var(--tw-text-opacity, 1));
}
.text-\\[\\#3A2E14\\]{
  --tw-text-opacity: 1;
  color: rgb(58 46 20 / var(--tw-text-opacity, 1));
}
.text-\\[\\#3A3A38\\]{
  --tw-text-opacity: 1;
  color: rgb(58 58 56 / var(--tw-text-opacity, 1));
}
.text-\\[\\#3B6B9B\\]{
  --tw-text-opacity: 1;
  color: rgb(59 107 155 / var(--tw-text-opacity, 1));
}
.text-\\[\\#3D7A45\\]{
  --tw-text-opacity: 1;
  color: rgb(61 122 69 / var(--tw-text-opacity, 1));
}
.text-\\[\\#3a3d3c\\]{
  --tw-text-opacity: 1;
  color: rgb(58 61 60 / var(--tw-text-opacity, 1));
}
.text-\\[\\#4A4A48\\]{
  --tw-text-opacity: 1;
  color: rgb(74 74 72 / var(--tw-text-opacity, 1));
}
.text-\\[\\#4A5D68\\]{
  --tw-text-opacity: 1;
  color: rgb(74 93 104 / var(--tw-text-opacity, 1));
}
.text-\\[\\#4ADE80\\]{
  --tw-text-opacity: 1;
  color: rgb(74 222 128 / var(--tw-text-opacity, 1));
}
.text-\\[\\#555552\\]{
  --tw-text-opacity: 1;
  color: rgb(85 85 82 / var(--tw-text-opacity, 1));
}
.text-\\[\\#555555\\]{
  --tw-text-opacity: 1;
  color: rgb(85 85 85 / var(--tw-text-opacity, 1));
}
.text-\\[\\#5A4A28\\]{
  --tw-text-opacity: 1;
  color: rgb(90 74 40 / var(--tw-text-opacity, 1));
}
.text-\\[\\#5B4A8A\\]{
  --tw-text-opacity: 1;
  color: rgb(91 74 138 / var(--tw-text-opacity, 1));
}
.text-\\[\\#5b605e\\]{
  --tw-text-opacity: 1;
  color: rgb(91 96 94 / var(--tw-text-opacity, 1));
}
.text-\\[\\#5c605e\\]{
  --tw-text-opacity: 1;
  color: rgb(92 96 94 / var(--tw-text-opacity, 1));
}
.text-\\[\\#5ec8e8\\]{
  --tw-text-opacity: 1;
  color: rgb(94 200 232 / var(--tw-text-opacity, 1));
}
.text-\\[\\#5f5d60\\]{
  --tw-text-opacity: 1;
  color: rgb(95 93 96 / var(--tw-text-opacity, 1));
}
.text-\\[\\#6A6A65\\]{
  --tw-text-opacity: 1;
  color: rgb(106 106 101 / var(--tw-text-opacity, 1));
}
.text-\\[\\#6B6B66\\]{
  --tw-text-opacity: 1;
  color: rgb(107 107 102 / var(--tw-text-opacity, 1));
}
.text-\\[\\#6B6C72\\]{
  --tw-text-opacity: 1;
  color: rgb(107 108 114 / var(--tw-text-opacity, 1));
}
.text-\\[\\#6b6f6d\\]{
  --tw-text-opacity: 1;
  color: rgb(107 111 109 / var(--tw-text-opacity, 1));
}
.text-\\[\\#6b7380\\]{
  --tw-text-opacity: 1;
  color: rgb(107 115 128 / var(--tw-text-opacity, 1));
}
.text-\\[\\#6d6f76\\]{
  --tw-text-opacity: 1;
  color: rgb(109 111 118 / var(--tw-text-opacity, 1));
}
.text-\\[\\#707070\\]{
  --tw-text-opacity: 1;
  color: rgb(112 112 112 / var(--tw-text-opacity, 1));
}
.text-\\[\\#77757a\\]{
  --tw-text-opacity: 1;
  color: rgb(119 117 122 / var(--tw-text-opacity, 1));
}
.text-\\[\\#7dd3e8\\]{
  --tw-text-opacity: 1;
  color: rgb(125 211 232 / var(--tw-text-opacity, 1));
}
.text-\\[\\#7dd3ea\\]{
  --tw-text-opacity: 1;
  color: rgb(125 211 234 / var(--tw-text-opacity, 1));
}
.text-\\[\\#7dffa8\\]{
  --tw-text-opacity: 1;
  color: rgb(125 255 168 / var(--tw-text-opacity, 1));
}
.text-\\[\\#888888\\]{
  --tw-text-opacity: 1;
  color: rgb(136 136 136 / var(--tw-text-opacity, 1));
}
.text-\\[\\#8A6A48\\]{
  --tw-text-opacity: 1;
  color: rgb(138 106 72 / var(--tw-text-opacity, 1));
}
.text-\\[\\#8A8A85\\]{
  --tw-text-opacity: 1;
  color: rgb(138 138 133 / var(--tw-text-opacity, 1));
}
.text-\\[\\#8a888b\\]{
  --tw-text-opacity: 1;
  color: rgb(138 136 139 / var(--tw-text-opacity, 1));
}
.text-\\[\\#8b8d93\\]{
  --tw-text-opacity: 1;
  color: rgb(139 141 147 / var(--tw-text-opacity, 1));
}
.text-\\[\\#8b8f8d\\]{
  --tw-text-opacity: 1;
  color: rgb(139 143 141 / var(--tw-text-opacity, 1));
}
.text-\\[\\#8fd3a8\\]{
  --tw-text-opacity: 1;
  color: rgb(143 211 168 / var(--tw-text-opacity, 1));
}
.text-\\[\\#9AD7E4\\]{
  --tw-text-opacity: 1;
  color: rgb(154 215 228 / var(--tw-text-opacity, 1));
}
.text-\\[\\#9B3B3B\\]{
  --tw-text-opacity: 1;
  color: rgb(155 59 59 / var(--tw-text-opacity, 1));
}
.text-\\[\\#9C9A9B\\]{
  --tw-text-opacity: 1;
  color: rgb(156 154 155 / var(--tw-text-opacity, 1));
}
.text-\\[\\#9a9ca3\\]{
  --tw-text-opacity: 1;
  color: rgb(154 156 163 / var(--tw-text-opacity, 1));
}
.text-\\[\\#9aa3b2\\]{
  --tw-text-opacity: 1;
  color: rgb(154 163 178 / var(--tw-text-opacity, 1));
}
.text-\\[\\#A5A6AC\\]{
  --tw-text-opacity: 1;
  color: rgb(165 166 172 / var(--tw-text-opacity, 1));
}
.text-\\[\\#A65D4A\\]{
  --tw-text-opacity: 1;
  color: rgb(166 93 74 / var(--tw-text-opacity, 1));
}
.text-\\[\\#A66B10\\]{
  --tw-text-opacity: 1;
  color: rgb(166 107 16 / var(--tw-text-opacity, 1));
}
.text-\\[\\#AAAAAA\\]{
  --tw-text-opacity: 1;
  color: rgb(170 170 170 / var(--tw-text-opacity, 1));
}
.text-\\[\\#B0484A\\]{
  --tw-text-opacity: 1;
  color: rgb(176 72 74 / var(--tw-text-opacity, 1));
}
.text-\\[\\#C0C0BA\\]{
  --tw-text-opacity: 1;
  color: rgb(192 192 186 / var(--tw-text-opacity, 1));
}
.text-\\[\\#C8C8C3\\]{
  --tw-text-opacity: 1;
  color: rgb(200 200 195 / var(--tw-text-opacity, 1));
}
.text-\\[\\#D0D0CB\\]{
  --tw-text-opacity: 1;
  color: rgb(208 208 203 / var(--tw-text-opacity, 1));
}
.text-\\[\\#DDDDD8\\]{
  --tw-text-opacity: 1;
  color: rgb(221 221 216 / var(--tw-text-opacity, 1));
}
.text-\\[\\#E5A443\\]{
  --tw-text-opacity: 1;
  color: rgb(229 164 67 / var(--tw-text-opacity, 1));
}
.text-\\[\\#E8503A\\]{
  --tw-text-opacity: 1;
  color: rgb(232 80 58 / var(--tw-text-opacity, 1));
}
.text-\\[\\#EDB766\\]{
  --tw-text-opacity: 1;
  color: rgb(237 183 102 / var(--tw-text-opacity, 1));
}
.text-\\[\\#F06A74\\]{
  --tw-text-opacity: 1;
  color: rgb(240 106 116 / var(--tw-text-opacity, 1));
}
.text-\\[\\#F1F0EA\\]{
  --tw-text-opacity: 1;
  color: rgb(241 240 234 / var(--tw-text-opacity, 1));
}
.text-\\[\\#F3A0A6\\]{
  --tw-text-opacity: 1;
  color: rgb(243 160 166 / var(--tw-text-opacity, 1));
}
.text-\\[\\#a7a9b0\\]{
  --tw-text-opacity: 1;
  color: rgb(167 169 176 / var(--tw-text-opacity, 1));
}
.text-\\[\\#a8acab\\]{
  --tw-text-opacity: 1;
  color: rgb(168 172 171 / var(--tw-text-opacity, 1));
}
.text-\\[\\#a9a7a8\\]{
  --tw-text-opacity: 1;
  color: rgb(169 167 168 / var(--tw-text-opacity, 1));
}
.text-\\[\\#b3b1b2\\]{
  --tw-text-opacity: 1;
  color: rgb(179 177 178 / var(--tw-text-opacity, 1));
}
.text-\\[\\#b7bab8\\]{
  --tw-text-opacity: 1;
  color: rgb(183 186 184 / var(--tw-text-opacity, 1));
}
.text-\\[\\#bdbbbc\\]{
  --tw-text-opacity: 1;
  color: rgb(189 187 188 / var(--tw-text-opacity, 1));
}
.text-\\[\\#c5c7cc\\]{
  --tw-text-opacity: 1;
  color: rgb(197 199 204 / var(--tw-text-opacity, 1));
}
.text-\\[\\#c7ccca\\]{
  --tw-text-opacity: 1;
  color: rgb(199 204 202 / var(--tw-text-opacity, 1));
}
.text-\\[\\#d0d2d8\\]{
  --tw-text-opacity: 1;
  color: rgb(208 210 216 / var(--tw-text-opacity, 1));
}
.text-\\[\\#d6d4d5\\]{
  --tw-text-opacity: 1;
  color: rgb(214 212 213 / var(--tw-text-opacity, 1));
}
.text-\\[\\#e8eaed\\]{
  --tw-text-opacity: 1;
  color: rgb(232 234 237 / var(--tw-text-opacity, 1));
}
.text-\\[\\#e9e7e8\\]{
  --tw-text-opacity: 1;
  color: rgb(233 231 232 / var(--tw-text-opacity, 1));
}
.text-\\[\\#eceaeb\\]{
  --tw-text-opacity: 1;
  color: rgb(236 234 235 / var(--tw-text-opacity, 1));
}
.text-\\[\\#f0c36a\\]{
  --tw-text-opacity: 1;
  color: rgb(240 195 106 / var(--tw-text-opacity, 1));
}
.text-\\[\\#f2f0f1\\]{
  --tw-text-opacity: 1;
  color: rgb(242 240 241 / var(--tw-text-opacity, 1));
}
.text-\\[\\#ff6b81\\]{
  --tw-text-opacity: 1;
  color: rgb(255 107 129 / var(--tw-text-opacity, 1));
}
.text-\\[\\#ff8b96\\]{
  --tw-text-opacity: 1;
  color: rgb(255 139 150 / var(--tw-text-opacity, 1));
}
.text-\\[var\\(--cu-accent\\)\\]{
  color: var(--cu-accent);
}
.text-\\[var\\(--cu-border-hover\\)\\]{
  color: var(--cu-border-hover);
}
.text-\\[var\\(--cu-danger\\)\\]{
  color: var(--cu-danger);
}
.text-\\[var\\(--cu-disabled-text\\)\\]{
  color: var(--cu-disabled-text);
}
.text-\\[var\\(--cu-heading\\)\\]{
  color: var(--cu-heading);
}
.text-\\[var\\(--cu-muted\\)\\]{
  color: var(--cu-muted);
}
.text-\\[var\\(--cu-subtle\\)\\]{
  color: var(--cu-subtle);
}
.text-\\[var\\(--cu-text\\)\\]{
  color: var(--cu-text);
}
.text-amber-100{
  --tw-text-opacity: 1;
  color: rgb(254 243 199 / var(--tw-text-opacity, 1));
}
.text-amber-200{
  --tw-text-opacity: 1;
  color: rgb(253 230 138 / var(--tw-text-opacity, 1));
}
.text-amber-200\\/70{
  color: rgb(253 230 138 / 0.7);
}
.text-amber-300{
  --tw-text-opacity: 1;
  color: rgb(252 211 77 / var(--tw-text-opacity, 1));
}
.text-amber-300\\/90{
  color: rgb(252 211 77 / 0.9);
}
.text-amber-400{
  --tw-text-opacity: 1;
  color: rgb(251 191 36 / var(--tw-text-opacity, 1));
}
.text-amber-400\\/80{
  color: rgb(251 191 36 / 0.8);
}
.text-amber-500{
  --tw-text-opacity: 1;
  color: rgb(245 158 11 / var(--tw-text-opacity, 1));
}
.text-amber-600{
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / var(--tw-text-opacity, 1));
}
.text-amber-700{
  --tw-text-opacity: 1;
  color: rgb(180 83 9 / var(--tw-text-opacity, 1));
}
.text-amber-800{
  --tw-text-opacity: 1;
  color: rgb(146 64 14 / var(--tw-text-opacity, 1));
}
.text-amber-900{
  --tw-text-opacity: 1;
  color: rgb(120 53 15 / var(--tw-text-opacity, 1));
}
.text-amber-900\\/70{
  color: rgb(120 53 15 / 0.7);
}
.text-amber-900\\/80{
  color: rgb(120 53 15 / 0.8);
}
.text-amber-950{
  --tw-text-opacity: 1;
  color: rgb(69 26 3 / var(--tw-text-opacity, 1));
}
.text-black{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.text-blue-400{
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity, 1));
}
.text-blue-500{
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity, 1));
}
.text-blue-600{
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.text-blue-700{
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}
.text-blue-900{
  --tw-text-opacity: 1;
  color: rgb(30 58 138 / var(--tw-text-opacity, 1));
}
.text-cyan-200{
  --tw-text-opacity: 1;
  color: rgb(165 243 252 / var(--tw-text-opacity, 1));
}
.text-cyan-400{
  --tw-text-opacity: 1;
  color: rgb(34 211 238 / var(--tw-text-opacity, 1));
}
.text-cyan-400\\/80{
  color: rgb(34 211 238 / 0.8);
}
.text-cyan-400\\/90{
  color: rgb(34 211 238 / 0.9);
}
.text-emerald-100{
  --tw-text-opacity: 1;
  color: rgb(209 250 229 / var(--tw-text-opacity, 1));
}
.text-emerald-200{
  --tw-text-opacity: 1;
  color: rgb(167 243 208 / var(--tw-text-opacity, 1));
}
.text-emerald-300{
  --tw-text-opacity: 1;
  color: rgb(110 231 183 / var(--tw-text-opacity, 1));
}
.text-emerald-400{
  --tw-text-opacity: 1;
  color: rgb(52 211 153 / var(--tw-text-opacity, 1));
}
.text-emerald-400\\/90{
  color: rgb(52 211 153 / 0.9);
}
.text-emerald-600{
  --tw-text-opacity: 1;
  color: rgb(5 150 105 / var(--tw-text-opacity, 1));
}
.text-emerald-700{
  --tw-text-opacity: 1;
  color: rgb(4 120 87 / var(--tw-text-opacity, 1));
}
.text-emerald-800{
  --tw-text-opacity: 1;
  color: rgb(6 95 70 / var(--tw-text-opacity, 1));
}
.text-gray-100{
  --tw-text-opacity: 1;
  color: rgb(243 244 246 / var(--tw-text-opacity, 1));
}
.text-gray-200{
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity, 1));
}
.text-gray-300{
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}
.text-gray-400{
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.text-gray-500{
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-gray-600{
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.text-gray-700{
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.text-gray-800{
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}
.text-gray-900{
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}
.text-green-400{
  --tw-text-opacity: 1;
  color: rgb(74 222 128 / var(--tw-text-opacity, 1));
}
.text-green-500{
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity, 1));
}
.text-green-600{
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity, 1));
}
.text-green-700{
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity, 1));
}
.text-green-800{
  --tw-text-opacity: 1;
  color: rgb(22 101 52 / var(--tw-text-opacity, 1));
}
.text-inherit{
  color: inherit;
}
.text-orange-400{
  --tw-text-opacity: 1;
  color: rgb(251 146 60 / var(--tw-text-opacity, 1));
}
.text-orange-500{
  --tw-text-opacity: 1;
  color: rgb(249 115 22 / var(--tw-text-opacity, 1));
}
.text-orange-700{
  --tw-text-opacity: 1;
  color: rgb(194 65 12 / var(--tw-text-opacity, 1));
}
.text-orange-800{
  --tw-text-opacity: 1;
  color: rgb(154 52 18 / var(--tw-text-opacity, 1));
}
.text-pink-500{
  --tw-text-opacity: 1;
  color: rgb(236 72 153 / var(--tw-text-opacity, 1));
}
.text-purple-200{
  --tw-text-opacity: 1;
  color: rgb(233 213 255 / var(--tw-text-opacity, 1));
}
.text-purple-400{
  --tw-text-opacity: 1;
  color: rgb(192 132 252 / var(--tw-text-opacity, 1));
}
.text-purple-500{
  --tw-text-opacity: 1;
  color: rgb(168 85 247 / var(--tw-text-opacity, 1));
}
.text-purple-700{
  --tw-text-opacity: 1;
  color: rgb(126 34 206 / var(--tw-text-opacity, 1));
}
.text-red-300{
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}
.text-red-300\\/90{
  color: rgb(252 165 165 / 0.9);
}
.text-red-400{
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}
.text-red-500{
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-red-600{
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.text-red-700{
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.text-red-800{
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity, 1));
}
.text-rose-200{
  --tw-text-opacity: 1;
  color: rgb(254 205 211 / var(--tw-text-opacity, 1));
}
.text-rose-300{
  --tw-text-opacity: 1;
  color: rgb(253 164 175 / var(--tw-text-opacity, 1));
}
.text-rose-500{
  --tw-text-opacity: 1;
  color: rgb(244 63 94 / var(--tw-text-opacity, 1));
}
.text-rose-600{
  --tw-text-opacity: 1;
  color: rgb(225 29 72 / var(--tw-text-opacity, 1));
}
.text-rose-700{
  --tw-text-opacity: 1;
  color: rgb(190 18 60 / var(--tw-text-opacity, 1));
}
.text-rose-800{
  --tw-text-opacity: 1;
  color: rgb(159 18 57 / var(--tw-text-opacity, 1));
}
.text-sky-700{
  --tw-text-opacity: 1;
  color: rgb(3 105 161 / var(--tw-text-opacity, 1));
}
.text-sky-800{
  --tw-text-opacity: 1;
  color: rgb(7 89 133 / var(--tw-text-opacity, 1));
}
.text-sky-900{
  --tw-text-opacity: 1;
  color: rgb(12 74 110 / var(--tw-text-opacity, 1));
}
.text-slate-100{
  --tw-text-opacity: 1;
  color: rgb(241 245 249 / var(--tw-text-opacity, 1));
}
.text-slate-200{
  --tw-text-opacity: 1;
  color: rgb(226 232 240 / var(--tw-text-opacity, 1));
}
.text-slate-300{
  --tw-text-opacity: 1;
  color: rgb(203 213 225 / var(--tw-text-opacity, 1));
}
.text-slate-400{
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}
.text-slate-500{
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}
.text-slate-600{
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
}
.text-slate-700{
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}
.text-slate-900{
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}
.text-stone-50{
  --tw-text-opacity: 1;
  color: rgb(250 250 249 / var(--tw-text-opacity, 1));
}
.text-teal-600{
  --tw-text-opacity: 1;
  color: rgb(13 148 136 / var(--tw-text-opacity, 1));
}
.text-teal-700{
  --tw-text-opacity: 1;
  color: rgb(15 118 110 / var(--tw-text-opacity, 1));
}
.text-transparent{
  color: transparent;
}
.text-violet-300{
  --tw-text-opacity: 1;
  color: rgb(196 181 253 / var(--tw-text-opacity, 1));
}
.text-violet-300\\/90{
  color: rgb(196 181 253 / 0.9);
}
.text-violet-600{
  --tw-text-opacity: 1;
  color: rgb(124 58 237 / var(--tw-text-opacity, 1));
}
.text-violet-700{
  --tw-text-opacity: 1;
  color: rgb(109 40 217 / var(--tw-text-opacity, 1));
}
.text-violet-800{
  --tw-text-opacity: 1;
  color: rgb(91 33 182 / var(--tw-text-opacity, 1));
}
.text-violet-900{
  --tw-text-opacity: 1;
  color: rgb(76 29 149 / var(--tw-text-opacity, 1));
}
.text-violet-950{
  --tw-text-opacity: 1;
  color: rgb(46 16 101 / var(--tw-text-opacity, 1));
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-white\\/30{
  color: rgb(255 255 255 / 0.3);
}
.text-white\\/50{
  color: rgb(255 255 255 / 0.5);
}
.text-white\\/60{
  color: rgb(255 255 255 / 0.6);
}
.text-white\\/70{
  color: rgb(255 255 255 / 0.7);
}
.text-white\\/75{
  color: rgb(255 255 255 / 0.75);
}
.text-white\\/80{
  color: rgb(255 255 255 / 0.8);
}
.text-white\\/85{
  color: rgb(255 255 255 / 0.85);
}
.text-white\\/90{
  color: rgb(255 255 255 / 0.9);
}
.text-yellow-200\\/90{
  color: rgb(254 240 138 / 0.9);
}
.text-yellow-400{
  --tw-text-opacity: 1;
  color: rgb(250 204 21 / var(--tw-text-opacity, 1));
}
.text-yellow-600{
  --tw-text-opacity: 1;
  color: rgb(202 138 4 / var(--tw-text-opacity, 1));
}
.underline{
  text-decoration-line: underline;
}
.no-underline{
  text-decoration-line: none;
}
.placeholder-\\[\\#5b605e\\]::-moz-placeholder{
  --tw-placeholder-opacity: 1;
  color: rgb(91 96 94 / var(--tw-placeholder-opacity, 1));
}
.placeholder-\\[\\#5b605e\\]::placeholder{
  --tw-placeholder-opacity: 1;
  color: rgb(91 96 94 / var(--tw-placeholder-opacity, 1));
}
.placeholder-gray-400::-moz-placeholder{
  --tw-placeholder-opacity: 1;
  color: rgb(156 163 175 / var(--tw-placeholder-opacity, 1));
}
.placeholder-gray-400::placeholder{
  --tw-placeholder-opacity: 1;
  color: rgb(156 163 175 / var(--tw-placeholder-opacity, 1));
}
.accent-\\[\\#1DA8C6\\]{
  accent-color: #1DA8C6;
}
.accent-\\[\\#2fa9bf\\]{
  accent-color: #2fa9bf;
}
.accent-\\[\\#BF1E2E\\]{
  accent-color: #BF1E2E;
}
.accent-\\[\\#c31c30\\]{
  accent-color: #c31c30;
}
.accent-\\[\\#e11d2e\\]{
  accent-color: #e11d2e;
}
.accent-cyan-500{
  accent-color: #06b6d4;
}
.opacity-0{
  opacity: 0;
}
.opacity-100{
  opacity: 1;
}
.opacity-20{
  opacity: 0.2;
}
.opacity-30{
  opacity: 0.3;
}
.opacity-40{
  opacity: 0.4;
}
.opacity-45{
  opacity: 0.45;
}
.opacity-50{
  opacity: 0.5;
}
.opacity-55{
  opacity: 0.55;
}
.opacity-60{
  opacity: 0.6;
}
.opacity-65{
  opacity: 0.65;
}
.opacity-70{
  opacity: 0.7;
}
.opacity-75{
  opacity: 0.75;
}
.opacity-80{
  opacity: 0.8;
}
.opacity-85{
  opacity: 0.85;
}
.opacity-90{
  opacity: 0.9;
}
.shadow{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-2xl{
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_-8px_30px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.45\\)\\]{
  --tw-shadow: 0 -8px 30px rgba(0,0,0,0.45);
  --tw-shadow-colored: 0 -8px 30px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_0_1px_\\#1DA8C6\\]{
  --tw-shadow: 0 0 0 1px #1DA8C6;
  --tw-shadow-colored: 0 0 0 1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_15px_rgba\\(47\\2c 169\\2c 191\\2c 0\\.12\\)\\]{
  --tw-shadow: 0 0 15px rgba(47,169,191,0.12);
  --tw-shadow-colored: 0 0 15px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_28px_rgba\\(6\\2c 182\\2c 212\\2c 0\\.12\\)\\]{
  --tw-shadow: 0 0 28px rgba(6,182,212,0.12);
  --tw-shadow-colored: 0 0 28px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_30px_rgba\\(47\\2c 169\\2c 191\\2c 0\\.08\\)\\]{
  --tw-shadow: 0 0 30px rgba(47,169,191,0.08);
  --tw-shadow-colored: 0 0 30px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_40px_rgba\\(239\\2c 68\\2c 68\\2c 0\\.12\\)\\]{
  --tw-shadow: 0 0 40px rgba(239,68,68,0.12);
  --tw-shadow-colored: 0 0 40px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_40px_rgba\\(245\\2c 158\\2c 11\\2c 0\\.1\\)\\]{
  --tw-shadow: 0 0 40px rgba(245,158,11,0.1);
  --tw-shadow-colored: 0 0 40px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_40px_rgba\\(6\\2c 182\\2c 212\\2c 0\\.15\\)\\]{
  --tw-shadow: 0 0 40px rgba(6,182,212,0.15);
  --tw-shadow-colored: 0 0 40px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_50px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.45\\)\\]{
  --tw-shadow: 0 0 50px rgba(0,0,0,0.45);
  --tw-shadow-colored: 0 0 50px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_20px_60px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.08\\)\\]{
  --tw-shadow: 0 20px 60px rgba(0,0,0,0.08);
  --tw-shadow-colored: 0 20px 60px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_20px_60px_rgba\\(47\\2c 169\\2c 191\\2c 0\\.35\\)\\]{
  --tw-shadow: 0 20px 60px rgba(47,169,191,0.35);
  --tw-shadow-colored: 0 20px 60px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_20px_60px_rgba\\(47\\2c 169\\2c 191\\2c 0\\.45\\)\\]{
  --tw-shadow: 0 20px 60px rgba(47,169,191,0.45);
  --tw-shadow-colored: 0 20px 60px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_40px_100px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.5\\)\\]{
  --tw-shadow: 0 40px 100px rgba(0,0,0,0.5);
  --tw-shadow-colored: 0 40px 100px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_40px_120px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.9\\)\\]{
  --tw-shadow: 0 40px 120px rgba(0,0,0,0.9);
  --tw-shadow-colored: 0 40px 120px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_60px_140px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.95\\)\\]{
  --tw-shadow: 0 60px 140px rgba(0,0,0,0.95);
  --tw-shadow-colored: 0 60px 140px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_6px_0_rgba\\(0\\2c 0\\2c 0\\2c 0\\.2\\)\\]{
  --tw-shadow: 0 6px 0 rgba(0,0,0,0.2);
  --tw-shadow-colored: 0 6px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_0_rgba\\(0\\2c 0\\2c 0\\2c 0\\.18\\)\\]{
  --tw-shadow: 0 8px 0 rgba(0,0,0,0.18);
  --tw-shadow-colored: 0 8px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_20px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.4\\)\\]{
  --tw-shadow: 0 8px 20px rgba(0,0,0,0.4);
  --tw-shadow-colored: 0 8px 20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_24px_-8px_rgba\\(47\\2c 169\\2c 191\\2c 0\\.65\\)\\]{
  --tw-shadow: 0 8px 24px -8px rgba(47,169,191,0.65);
  --tw-shadow-colored: 0 8px 24px -8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_24px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.35\\)\\]{
  --tw-shadow: 0 8px 24px rgba(0,0,0,0.35);
  --tw-shadow-colored: 0 8px 24px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[10px_10px_0_rgba\\(0\\2c 0\\2c 0\\2c 0\\.18\\)\\]{
  --tw-shadow: 10px 10px 0 rgba(0,0,0,0.18);
  --tw-shadow-colored: 10px 10px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[4px_4px_0_\\#1F1F1C\\]{
  --tw-shadow: 4px 4px 0 #1F1F1C;
  --tw-shadow-colored: 4px 4px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[inset_4px_0_0_0_\\#10b981\\]{
  --tw-shadow: inset 4px 0 0 0 #10b981;
  --tw-shadow-colored: inset 4px 0 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[inset_4px_0_0_0_\\#22d3ee\\]{
  --tw-shadow: inset 4px 0 0 0 #22d3ee;
  --tw-shadow-colored: inset 4px 0 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[inset_4px_0_0_0_\\#2fa9bf\\]{
  --tw-shadow: inset 4px 0 0 0 #2fa9bf;
  --tw-shadow-colored: inset 4px 0 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[inset_4px_0_0_0_\\#38bdf8\\]{
  --tw-shadow: inset 4px 0 0 0 #38bdf8;
  --tw-shadow-colored: inset 4px 0 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[inset_4px_0_0_0_\\#3b82f6\\]{
  --tw-shadow: inset 4px 0 0 0 #3b82f6;
  --tw-shadow-colored: inset 4px 0 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[inset_4px_0_0_0_\\#6366f1\\]{
  --tw-shadow: inset 4px 0 0 0 #6366f1;
  --tw-shadow-colored: inset 4px 0 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[inset_4px_0_0_0_\\#8b5cf6\\]{
  --tw-shadow: inset 4px 0 0 0 #8b5cf6;
  --tw-shadow-colored: inset 4px 0 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[inset_4px_0_0_0_\\#d6d6d0\\]{
  --tw-shadow: inset 4px 0 0 0 #d6d6d0;
  --tw-shadow-colored: inset 4px 0 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[inset_4px_0_0_0_\\#f43f5e\\]{
  --tw-shadow: inset 4px 0 0 0 #f43f5e;
  --tw-shadow-colored: inset 4px 0 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[inset_4px_0_0_0_\\#f59e0b\\]{
  --tw-shadow: inset 4px 0 0 0 #f59e0b;
  --tw-shadow-colored: inset 4px 0 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[inset_4px_0_0_0_\\#f97316\\]{
  --tw-shadow: inset 4px 0 0 0 #f97316;
  --tw-shadow-colored: inset 4px 0 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-none{
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-blue-400\\/50{
  --tw-shadow-color: rgb(96 165 250 / 0.5);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-red-900\\/20{
  --tw-shadow-color: rgb(127 29 29 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.outline-none{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline{
  outline-style: solid;
}
.ring{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-1{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-2{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-inset{
  --tw-ring-inset: inset;
}
.ring-\\[\\#1DA8C6\\]{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(29 168 198 / var(--tw-ring-opacity, 1));
}
.ring-\\[\\#1DA8C6\\]\\/50{
  --tw-ring-color: rgb(29 168 198 / 0.5);
}
.ring-\\[\\#2fa9bf\\]{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(47 169 191 / var(--tw-ring-opacity, 1));
}
.ring-\\[\\#2fa9bf\\]\\/10{
  --tw-ring-color: rgb(47 169 191 / 0.1);
}
.ring-\\[\\#2fa9bf\\]\\/15{
  --tw-ring-color: rgb(47 169 191 / 0.15);
}
.ring-\\[\\#2fa9bf\\]\\/30{
  --tw-ring-color: rgb(47 169 191 / 0.3);
}
.ring-\\[\\#2fa9bf\\]\\/40{
  --tw-ring-color: rgb(47 169 191 / 0.4);
}
.ring-\\[\\#345952\\]{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(52 89 82 / var(--tw-ring-opacity, 1));
}
.ring-\\[\\#345952\\]\\/20{
  --tw-ring-color: rgb(52 89 82 / 0.2);
}
.ring-\\[\\#7ECAD8\\]{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(126 202 216 / var(--tw-ring-opacity, 1));
}
.ring-\\[\\#93B9AD\\]\\/20{
  --tw-ring-color: rgb(147 185 173 / 0.2);
}
.ring-\\[\\#D4EBEF\\]{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(212 235 239 / var(--tw-ring-opacity, 1));
}
.ring-\\[\\#D8D8D2\\]{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(216 216 210 / var(--tw-ring-opacity, 1));
}
.ring-\\[\\#DDDDD8\\]{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(221 221 216 / var(--tw-ring-opacity, 1));
}
.ring-\\[\\#E8E8E4\\]{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(232 232 228 / var(--tw-ring-opacity, 1));
}
.ring-amber-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(253 230 138 / var(--tw-ring-opacity, 1));
}
.ring-amber-300{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(252 211 77 / var(--tw-ring-opacity, 1));
}
.ring-emerald-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(167 243 208 / var(--tw-ring-opacity, 1));
}
.ring-emerald-500\\/30{
  --tw-ring-color: rgb(16 185 129 / 0.3);
}
.ring-gray-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(229 231 235 / var(--tw-ring-opacity, 1));
}
.ring-gray-300{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(209 213 219 / var(--tw-ring-opacity, 1));
}
.ring-orange-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(254 215 170 / var(--tw-ring-opacity, 1));
}
.ring-red-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(254 202 202 / var(--tw-ring-opacity, 1));
}
.ring-rose-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(254 205 211 / var(--tw-ring-opacity, 1));
}
.ring-rose-400{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(251 113 133 / var(--tw-ring-opacity, 1));
}
.ring-sky-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(186 230 253 / var(--tw-ring-opacity, 1));
}
.ring-violet-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(221 214 254 / var(--tw-ring-opacity, 1));
}
.ring-white{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 255 255 / var(--tw-ring-opacity, 1));
}
.ring-white\\/20{
  --tw-ring-color: rgb(255 255 255 / 0.2);
}
.ring-white\\/80{
  --tw-ring-color: rgb(255 255 255 / 0.8);
}
.ring-offset-1{
  --tw-ring-offset-width: 1px;
}
.blur{
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-3xl{
  --tw-blur: blur(64px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-\\[100px\\]{
  --tw-blur: blur(100px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-\\[130px\\]{
  --tw-blur: blur(130px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-\\[200px\\]{
  --tw-blur: blur(200px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-\\[220px\\]{
  --tw-blur: blur(220px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow{
  --tw-drop-shadow: drop-shadow(0 1px 2px rgb(0 0 0 / 0.1)) drop-shadow(0 1px 1px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-2xl{
  --tw-drop-shadow: drop-shadow(0 25px 25px rgb(0 0 0 / 0.15));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.invert{
  --tw-invert: invert(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur{
  --tw-backdrop-blur: blur(8px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-2xl{
  --tw-backdrop-blur: blur(40px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-\\[2px\\]{
  --tw-backdrop-blur: blur(2px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-lg{
  --tw-backdrop-blur: blur(16px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-md{
  --tw-backdrop-blur: blur(12px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-sm{
  --tw-backdrop-blur: blur(4px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-xl{
  --tw-backdrop-blur: blur(24px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[width\\]{
  transition-property: width;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity{
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-shadow{
  transition-property: box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform{
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-150{
  transition-duration: 150ms;
}
.duration-200{
  transition-duration: 200ms;
}
.duration-300{
  transition-duration: 300ms;
}
.duration-500{
  transition-duration: 500ms;
}
.duration-75{
  transition-duration: 75ms;
}
.ease-in-out{
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.\\[color-scheme\\:dark\\]{
  color-scheme: dark;
}

/* Case upload form theme tokens */
.case-upload-theme {
  --cu-accent: #2fa9bf;
  --cu-accent-soft: rgba(47, 169, 191, 0.12);
  --cu-danger: #e07070;
  color: var(--cu-text);
  transition: background-color 0.25s ease, color 0.25s ease, border-color 0.25s ease;
}

.case-upload-theme[data-theme="dark"] {
  --cu-bg: #1a1f27;
  --cu-surface: #161b22;
  --cu-input: #12151a;
  --cu-elevated: #222831;
  --cu-border: #2a3140;
  --cu-border-hover: #3a4558;
  --cu-text: #e8eaed;
  --cu-heading: #ffffff;
  --cu-muted: #9aa3b2;
  --cu-subtle: #6b7380;
  --cu-placeholder: #5a6270;
  --cu-chip: #12151a;
  --cu-disabled-bg: #2a3140;
  --cu-disabled-text: #6b7380;
}

.case-upload-theme[data-theme="light"] {
  --cu-bg: #f7f8fa;
  --cu-surface: #ffffff;
  --cu-input: #ffffff;
  --cu-elevated: #f0f2f5;
  --cu-border: #e2e5ea;
  --cu-border-hover: #c8ced8;
  --cu-text: #1c1c1a;
  --cu-heading: #111827;
  --cu-muted: #5b6472;
  --cu-subtle: #8a93a0;
  --cu-placeholder: #a0a8b4;
  --cu-chip: #f3f4f6;
  --cu-disabled-bg: #e5e7eb;
  --cu-disabled-text: #9ca3af;
  --cu-danger: #dc5c5c;
  --cu-accent-soft: rgba(47, 169, 191, 0.1);
}

.case-upload-theme[data-brand="uris"] {
  --cu-accent: #c31c30;
  --cu-accent-soft: rgba(195, 28, 48, 0.16);
}

.case-upload-theme[data-brand="uris"][data-theme="dark"] {
  --cu-bg: #1a1b1f;
  --cu-surface: #1d1e22;
  --cu-input: #141517;
  --cu-elevated: #141517;
  --cu-border: #2e3036;
  --cu-border-hover: #c31c30;
}

/* PNG service icons: solid black in light, solid white in dark / selected */
.case-upload-theme[data-theme="light"] .cu-service-icon-mono {
  background-color: #000000;
}
.case-upload-theme[data-theme="dark"] .cu-service-icon-mono {
  background-color: #ffffff;
}
.case-upload-theme [aria-pressed="true"] .cu-service-icon-mono {
  background-color: #ffffff;
}

/* ── Velvet brand (lab token JU): cream replaces portal teal/blue ── */
html[data-brand="velvet"] {
  --cu-accent: #FCF2E5;
  --cu-accent-soft: rgba(252, 242, 229, 0.55);
  --ss-teal: #FCF2E5;
  --ss-teal-soft: rgba(252, 242, 229, 0.22);
}

html[data-brand="velvet"] body {
  background-color: #FCF2E5;
}

/* Main portal canvas gray → cream */
html[data-brand="velvet"] [class*="bg-[#F4F4F2]"] {
  background-color: #FCF2E5 !important;
}

html[data-brand="velvet"] .case-upload-theme,
html[data-brand="velvet"] .case-upload-theme[data-theme="light"],
html[data-brand="velvet"] .case-upload-theme[data-theme="dark"] {
  --cu-accent: #FCF2E5;
  --cu-accent-soft: rgba(252, 242, 229, 0.55);
}

html[data-brand="velvet"] .smile-studio {
  --ss-teal: #FCF2E5;
  --ss-teal-soft: rgba(252, 242, 229, 0.22);
}

/* Soft blue washes → cream */
html[data-brand="velvet"] [class*="bg-[#eef9fc]"],
html[data-brand="velvet"] [class*="bg-[#E5F4F7]"],
html[data-brand="velvet"] [class*="bg-[#F0F7F8]"],
html[data-brand="velvet"] [class*="bg-[#F3FBFC]"],
html[data-brand="velvet"] [class*="bg-[#D4EBEF]"] {
  background-color: #FCF2E5 !important;
}

/* Brand teal/cyan fills → cream (+ dark ink for former white-on-teal buttons) */
html[data-brand="velvet"] [class*="bg-[#2fa9bf]"],
html[data-brand="velvet"] [class*="bg-[#1DA8C6]"],
html[data-brand="velvet"] [class*="bg-[#1da8c6]"],
html[data-brand="velvet"] [class*="bg-[#2296aa]"],
html[data-brand="velvet"] [class*="bg-[#258ca0]"],
html[data-brand="velvet"] [class*="bg-[#36bfd8]"],
html[data-brand="velvet"] [class*="bg-[#14879f]"] {
  background-color: #FCF2E5 !important;
  color: #2C2C2C !important;
}

/* Gradient stops that used teal */
html[data-brand="velvet"] [class*="from-[#2fa9bf]"],
html[data-brand="velvet"] [class*="from-[#1DA8C6]"],
html[data-brand="velvet"] [class*="from-[#1da8c6]"] {
  --tw-gradient-from: #FCF2E5 !important;
  --tw-gradient-to: rgb(252 242 229 / 0) !important;
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to) !important;
}
html[data-brand="velvet"] [class*="to-[#2fa9bf]"],
html[data-brand="velvet"] [class*="to-[#1DA8C6]"],
html[data-brand="velvet"] [class*="to-[#14879f]"] {
  --tw-gradient-to: #FCF2E5 !important;
}

/* Borders / rings / accents */
html[data-brand="velvet"] [class*="border-[#2fa9bf]"],
html[data-brand="velvet"] [class*="border-[#1DA8C6]"],
html[data-brand="velvet"] [class*="border-[#1da8c6]"],
html[data-brand="velvet"] [class*="border-[#2296aa]"],
html[data-brand="velvet"] [class*="border-[#D4EBEF]"] {
  border-color: #FCF2E5 !important;
}
html[data-brand="velvet"] [class*="ring-[#2fa9bf]"],
html[data-brand="velvet"] [class*="ring-[#1DA8C6]"],
html[data-brand="velvet"] [class*="ring-[#D4EBEF]"] {
  --tw-ring-color: #FCF2E5 !important;
}
html[data-brand="velvet"] [class*="accent-[#2fa9bf]"],
html[data-brand="velvet"] [class*="accent-[#1DA8C6]"] {
  accent-color: #FCF2E5 !important;
}

/* Teal text / icons → velvet ink on light UIs; cream on dark smile studio */
html[data-brand="velvet"] [class*="text-[#2fa9bf]"],
html[data-brand="velvet"] [class*="text-[#1DA8C6]"],
html[data-brand="velvet"] [class*="text-[#1da8c6]"],
html[data-brand="velvet"] [class*="text-[#2296aa]"],
html[data-brand="velvet"] [class*="text-[#268a9c]"],
html[data-brand="velvet"] [class*="text-[#36bfd8]"],
html[data-brand="velvet"] [class*="text-[#7dd3e8]"],
html[data-brand="velvet"] [class*="text-[#7dd3ea]"] {
  color: #2C2C2C !important;
}

html[data-brand="velvet"] .smile-studio [class*="text-[#2fa9bf]"],
html[data-brand="velvet"] .smile-studio [class*="text-[#1DA8C6]"],
html[data-brand="velvet"] .smile-studio [class*="text-[#1da8c6]"],
html[data-brand="velvet"] .smile-studio [class*="text-[#2296aa]"],
html[data-brand="velvet"] .smile-studio [class*="text-[#268a9c]"],
html[data-brand="velvet"] .smile-studio [class*="text-[#36bfd8]"],
html[data-brand="velvet"] .smile-studio [class*="text-[#7dd3e8]"],
html[data-brand="velvet"] .smile-studio [class*="text-[#7dd3ea]"] {
  color: #FCF2E5 !important;
}

/* Spinner / border-t teal tricks */
html[data-brand="velvet"] [class*="border-t-[#2fa9bf]"],
html[data-brand="velvet"] [class*="border-t-[#1DA8C6]"] {
  border-top-color: #FCF2E5 !important;
}

/* Hardcoded teal in smileStudio.css */
html[data-brand="velvet"] .smile-filter-slide.is-selected::after {
  border-color: #FCF2E5 !important;
}
html[data-brand="velvet"] .smile-filter-slide.is-selected .smile-filter-slide-name {
  background: #FCF2E5 !important;
  color: #2C2C2C !important;
}

/* Sidebar uses class-based Velvet tan theme (see cases-dashboard/sidebar.tsx) */

/* My Cases + case details modal: catch page-specific teal hexes */
html[data-brand="velvet"] .velvet-cases-scope [class*="bg-[#29a3b4]"],
html[data-brand="velvet"] .velvet-cases-scope [class*="bg-[#208a99]"],
html[data-brand="velvet"] .velvet-cases-scope [class*="bg-[#1c98ad]"],
html[data-brand="velvet"] .velvet-cases-scope [class*="bg-[#0A5A70]"],
html[data-brand="velvet"] .velvet-cases-scope [class*="bg-[#1DA8C6]"],
html[data-brand="velvet"] .velvet-cases-scope [class*="bg-[#2fa9bf]"] {
  background-color: #FCF2E5 !important;
  color: #2C2C2C !important;
}
html[data-brand="velvet"] .velvet-cases-scope [class*="bg-[#E8F6F8]"],
html[data-brand="velvet"] .velvet-cases-scope [class*="bg-[#eef9fc]"],
html[data-brand="velvet"] .velvet-cases-scope [class*="bg-[#d9f2f7]"] {
  background-color: #FCF2E5 !important;
}
html[data-brand="velvet"] .velvet-cases-scope [class*="text-[#29a3b4]"],
html[data-brand="velvet"] .velvet-cases-scope [class*="text-[#1e8a96]"],
html[data-brand="velvet"] .velvet-cases-scope [class*="text-[#1A7A86]"],
html[data-brand="velvet"] .velvet-cases-scope [class*="text-[#2fa9bf]"],
html[data-brand="velvet"] .velvet-cases-scope [class*="text-[#268a9c]"],
html[data-brand="velvet"] .velvet-cases-scope [class*="text-[#1DA8C6]"] {
  color: #2C2C2C !important;
}
html[data-brand="velvet"] .velvet-cases-scope [class*="border-[#29a3b4]"],
html[data-brand="velvet"] .velvet-cases-scope [class*="border-[#2fa9bf]"],
html[data-brand="velvet"] .velvet-cases-scope [class*="border-[#b8e8f0]"],
html[data-brand="velvet"] .velvet-cases-scope [class*="border-[#1DA8C6]"] {
  border-color: #FCF2E5 !important;
}
html[data-brand="velvet"] .velvet-cases-scope [class*="ring-[#29a3b4]"],
html[data-brand="velvet"] .velvet-cases-scope [class*="ring-[#2fa9bf]"] {
  --tw-ring-color: #FCF2E5 !important;
}
html[data-brand="velvet"] .velvet-cases-scope [class*="border-t-[#2fa9bf]"] {
  border-top-color: #FCF2E5 !important;
}

/* Uris dash pages — Montserrat / DM Sans + brand palette from tempurisui */
.uris-scope {
  font-family: "DM Sans", system-ui, sans-serif;
  color: #eceaeb;
}
.uris-scope h1,
.uris-scope h2,
.uris-scope .uris-display {
  font-family: Montserrat, "DM Sans", system-ui, sans-serif;
}

/* Uris case details modal — dark surfaces, red accent. Scoped so other labs stay light. */
.uris-cases-scope .bg-white {
  background-color: #1d1e22 !important;
}
.uris-cases-scope .bg-gray-50,
.uris-cases-scope .bg-\\[\\#F8F8F6\\] {
  background-color: #1a1b1f !important;
}
.uris-cases-scope .bg-gray-100,
.uris-cases-scope .bg-gray-200 {
  background-color: #2a2b31 !important;
}
.uris-cases-scope .bg-red-50 {
  background-color: #3a1520 !important;
}
.uris-cases-scope .bg-green-50 {
  background-color: #163226 !important;
}
.uris-cases-scope .bg-\\[\\#eef9fc\\],
.uris-cases-scope .bg-\\[\\#d9f2f7\\],
.uris-cases-scope .bg-\\[\\#E8F6F8\\] {
  background-color: #3a1520 !important;
}
.uris-cases-scope .bg-\\[\\#2fa9bf\\],
.uris-cases-scope .bg-\\[\\#1DA8C6\\],
.uris-cases-scope .bg-\\[\\#0A5A70\\],
.uris-cases-scope .bg-\\[\\#29a3b4\\],
.uris-cases-scope .bg-blue-500 {
  background-color: #e11d2e !important;
  color: #fff !important;
}
.uris-cases-scope .text-gray-800,
.uris-cases-scope .text-gray-700 {
  color: #e8e9ed !important;
}
.uris-cases-scope .text-gray-600,
.uris-cases-scope .text-gray-500,
.uris-cases-scope .text-gray-400,
.uris-cases-scope .text-gray-300 {
  color: #9a9ca3 !important;
}
.uris-cases-scope .text-\\[\\#2fa9bf\\],
.uris-cases-scope .text-\\[\\#1DA8C6\\],
.uris-cases-scope .text-\\[\\#268a9c\\],
.uris-cases-scope .text-\\[\\#29a3b4\\],
.uris-cases-scope .text-blue-500,
.uris-cases-scope .text-red-600 {
  color: #ff8b96 !important;
}
.uris-cases-scope .text-green-600 {
  color: #7dffa8 !important;
}
.uris-cases-scope .border-\\[\\#DDDDD8\\],
.uris-cases-scope .border-\\[\\#E8E8E4\\],
.uris-cases-scope .border-gray-300 {
  border-color: #2e3036 !important;
}
.uris-cases-scope .border-\\[\\#2fa9bf\\],
.uris-cases-scope .border-\\[\\#b8e8f0\\],
.uris-cases-scope .border-\\[\\#1DA8C6\\],
.uris-cases-scope .border-red-200,
.uris-cases-scope .border-red-300 {
  border-color: #6b2430 !important;
}
.uris-cases-scope .border-green-200,
.uris-cases-scope .border-green-300 {
  border-color: #1f5c3a !important;
}
.uris-cases-scope .ring-\\[\\#DDDDD8\\] {
  --tw-ring-color: #3a3c42 !important;
}
.uris-cases-scope .border-t-\\[\\#2fa9bf\\] {
  border-top-color: #c31c30 !important;
}
.uris-cases-scope .hover\\:border-\\[\\#2fa9bf\\]:hover {
  border-color: #c31c30 !important;
}
.uris-cases-scope .hover\\:bg-\\[\\#eef9fc\\]:hover,
.uris-cases-scope .hover\\:bg-red-50:hover {
  background-color: #3a1520 !important;
}
.uris-cases-scope .hover\\:bg-green-50:hover {
  background-color: #163226 !important;
}
.uris-cases-scope .group:hover .group-hover\\:text-\\[\\#2fa9bf\\] {
  color: #ff8b96 !important;
}
.uris-cases-scope button:disabled {
  background-color: #2a2b31 !important;
  color: #6d6f76 !important;
}
.uris-cases-scope input,
.uris-cases-scope textarea,
.uris-cases-scope select {
  background-color: #141517;
  color: #fff;
  border-color: #3a3c42;
}
.uris-cases-scope .ql-toolbar.ql-snow,
.uris-cases-scope .ql-container.ql-snow {
  border-color: #2e3036 !important;
  background: #141517;
}
.uris-cases-scope .ql-editor {
  color: #fff;
}
.uris-cases-scope .ql-editor.ql-blank::before {
  color: #8b8d93;
}
.uris-cases-scope .ql-snow .ql-stroke {
  stroke: #c5c7cc;
}
.uris-cases-scope .ql-snow .ql-fill {
  fill: #c5c7cc;
}
.uris-cases-scope .ql-snow .ql-picker {
  color: #c5c7cc;
}
.uris-cases-scope .text-\\[\\#4A4A48\\],
.uris-cases-scope .text-\\[\\#1A1A1A\\],
.uris-cases-scope .text-\\[\\#555552\\] {
  color: #e8e9ed !important;
}
.uris-cases-scope .text-\\[\\#8A8A85\\],
.uris-cases-scope .text-\\[\\#AAAAAA\\] {
  color: #9a9ca3 !important;
}
.uris-cases-scope .bg-\\[\\#FAFAF8\\],
.uris-cases-scope .bg-\\[\\#FDFBF2\\],
.uris-cases-scope .bg-\\[\\#F4F4F2\\] {
  background-color: #1a1b1f !important;
}
.uris-cases-scope .border-\\[\\#F0F0EC\\] {
  border-color: #2e3036 !important;
}
 

@media (max-width: 768px) {
  .relative {
    --mobile-width: 80vw;
    --mobile-height: 60vw;
    --mobile-corner-radius: 4vw;
  }
}



@keyframes flickerSlide {
  /* Flicker twice (0–0.5s) */
  0%   { opacity: 1; transform: scale(1) translateX(0); }
  2.5%  { opacity: 1; }
  5%  { opacity: 1; }
  7.5%  { opacity: 1; }
  10%  { opacity: 1; }

  /* Scale to 0 */
  12.5% {
    transform: scale(0) translateX(0);
    opacity: 1;
  }

  /* Come from right */
  15% {
    transform: scale(0) translateX(120px);
    opacity: 1;
  }

  /* Full scale at center */
  25% {
    transform: scale(1.1) translateX(0);
    opacity: 1;
  }

  /* Flicker again */
  50% { opacity: 1; }
  60% { opacity: 1; }
  70% { opacity: 1; }
  80% { opacity: 1; }
  90% { opacity: 1; }
  100% { opacity: 1; }
}



@keyframes blinkRed {
  0%, 100% { opacity: 0.8; }
  50% { opacity: 0.5; }
}

.blink-expired {
  animation: blinkRed 2s infinite;
}

@keyframes blinkNewCase {
  0%, 100% { background-color: #ffffff; }
  50% { background-color: #f9a8d4; }
}

.blink-new-case {
  animation: blinkNewCase 0.5s ease-in-out 4;
}




/* History panel scroll */
.history-scroll {
  scroll-behavior: smooth;
  scrollbar-width: thin;
  scrollbar-color: rgba(47, 169, 191, 0.5) rgba(255, 255, 255, 0.08);
}

.history-scroll::-webkit-scrollbar {
  width: 6px;
}

.history-scroll::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.06);
  border-radius: 999px;
  margin-block: 6px;
}

.history-scroll::-webkit-scrollbar-thumb {
  background: linear-gradient(
    180deg,
    rgba(47, 169, 191, 0.55),
    rgba(47, 169, 191, 0.35)
  );
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.history-scroll-x {
  scroll-behavior: smooth;
  scrollbar-width: thin;
  scrollbar-color: rgba(47, 169, 191, 0.45) transparent;
  -webkit-overflow-scrolling: touch;
}

.history-scroll-x::-webkit-scrollbar {
  height: 4px;
}

.history-scroll-x::-webkit-scrollbar-track {
  background: transparent;
}

.history-scroll-x::-webkit-scrollbar-thumb {
  background: rgba(47, 169, 191, 0.45);
  border-radius: 999px;
}

.history-scroll::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(
    180deg,
    rgba(54, 191, 216, 0.85),
    rgba(47, 169, 191, 0.65)
  );
}


/* Toolbar */
.custom-quill .ql-toolbar {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

/* Container */
.custom-quill .ql-container {
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  overflow: hidden;
}

/* Editor */
.custom-quill .ql-editor {
  min-height: 24px;
  max-height: 120px;

  overflow-y: auto;
  overflow-x: hidden;

  padding: 8px 12px;
  line-height: 1.5;

  white-space: pre-wrap;

  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;

  width: 100%;
  box-sizing: border-box;
}

/* Prevent long content stretching */
.custom-quill .ql-editor * {
  max-width: 100%;
  box-sizing: border-box;
}

/* Paragraph spacing */
.custom-quill .ql-editor p {
  margin: 0;
}

.compact-quill .ql-container {
  height: 42px !important;
}

.compact-quill .ql-editor {
  min-height: 42px !important;
  max-height: 42px !important;
  padding: 8px 12px;
}

/* Placeholder */
.custom-quill .ql-editor.ql-blank::before {
  font-style: normal;
  left: 12px;
  right: 12px;
}

/* Receiver side */
.message-content p {
  margin: 0;
}

.message-content ul,
.message-content ol {
  padding-left: 20px;
  margin: 4px 0;
}




/* Chat message wrapper */
.message-content {
  width: 100%;
  overflow: hidden;

  white-space: pre-wrap;
  word-wrap: break-word;
  overflow-wrap: anywhere;
  word-break: break-word;
}

/* All inner elements */
.message-content * {
  max-width: 100%;
  word-wrap: break-word;
  overflow-wrap: anywhere;
  word-break: break-word;
  box-sizing: border-box;
}

/* Paragraphs */
.message-content p {
  margin: 0;
}

/* Lists */
/* Ordered list */
.message-content ol {
  list-style-type: decimal;
  padding-left: 20px;
  margin: 4px 0;
}

/* Unordered list */
.message-content ul {
  list-style-type: disc;
  padding-left: 20px;
  margin: 4px 0;
}

/* List items */
.message-content li {
  margin: 2px 0;
}

/* Images */
.message-content img {
  max-width: 100%;
  height: auto;
}

/* Pre/code blocks */
.message-content pre,
.message-content code {
  white-space: pre-wrap;
  word-break: break-word;
}
.marker\\:content-none *::marker{
  --tw-content: none;
  content: var(--tw-content);
}
.marker\\:content-none::marker{
  --tw-content: none;
  content: var(--tw-content);
}
.selection\\:overflow-hidden *::-moz-selection{
  overflow: hidden;
}
.selection\\:overflow-hidden *::selection{
  overflow: hidden;
}
.selection\\:overflow-hidden::-moz-selection{
  overflow: hidden;
}
.selection\\:overflow-hidden::selection{
  overflow: hidden;
}
.file\\:mr-3::file-selector-button{
  margin-right: 0.75rem;
}
.file\\:rounded-lg::file-selector-button{
  border-radius: 0.5rem;
}
.file\\:border-0::file-selector-button{
  border-width: 0px;
}
.file\\:bg-\\[\\#F0F7F8\\]::file-selector-button{
  --tw-bg-opacity: 1;
  background-color: rgb(240 247 248 / var(--tw-bg-opacity, 1));
}
.file\\:px-3::file-selector-button{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.file\\:py-2::file-selector-button{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.file\\:text-xs::file-selector-button{
  font-size: 0.75rem;
  line-height: 1rem;
}
.file\\:font-medium::file-selector-button{
  font-weight: 500;
}
.file\\:text-\\[\\#2fa9bf\\]::file-selector-button{
  --tw-text-opacity: 1;
  color: rgb(47 169 191 / var(--tw-text-opacity, 1));
}
.placeholder\\:\\!text-\\[\\#8b8d93\\]::-moz-placeholder{
  --tw-text-opacity: 1 !important;
  color: rgb(139 141 147 / var(--tw-text-opacity, 1)) !important;
}
.placeholder\\:\\!text-\\[\\#8b8d93\\]::placeholder{
  --tw-text-opacity: 1 !important;
  color: rgb(139 141 147 / var(--tw-text-opacity, 1)) !important;
}
.placeholder\\:text-\\[\\#6b6f6d\\]::-moz-placeholder{
  --tw-text-opacity: 1;
  color: rgb(107 111 109 / var(--tw-text-opacity, 1));
}
.placeholder\\:text-\\[\\#6b6f6d\\]::placeholder{
  --tw-text-opacity: 1;
  color: rgb(107 111 109 / var(--tw-text-opacity, 1));
}
.placeholder\\:text-\\[\\#77757a\\]::-moz-placeholder{
  --tw-text-opacity: 1;
  color: rgb(119 117 122 / var(--tw-text-opacity, 1));
}
.placeholder\\:text-\\[\\#77757a\\]::placeholder{
  --tw-text-opacity: 1;
  color: rgb(119 117 122 / var(--tw-text-opacity, 1));
}
.placeholder\\:text-\\[\\#8A8A85\\]::-moz-placeholder{
  --tw-text-opacity: 1;
  color: rgb(138 138 133 / var(--tw-text-opacity, 1));
}
.placeholder\\:text-\\[\\#8A8A85\\]::placeholder{
  --tw-text-opacity: 1;
  color: rgb(138 138 133 / var(--tw-text-opacity, 1));
}
.placeholder\\:text-\\[var\\(--cu-placeholder\\)\\]::-moz-placeholder{
  color: var(--cu-placeholder);
}
.placeholder\\:text-\\[var\\(--cu-placeholder\\)\\]::placeholder{
  color: var(--cu-placeholder);
}
.placeholder\\:text-gray-500::-moz-placeholder{
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.placeholder\\:text-gray-500::placeholder{
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.first\\:rounded-l-xl:first-child{
  border-top-left-radius: 0.75rem;
  border-bottom-left-radius: 0.75rem;
}
.first\\:border-t-0:first-child{
  border-top-width: 0px;
}
.last\\:mb-0:last-child{
  margin-bottom: 0px;
}
.last\\:rounded-r-xl:last-child{
  border-top-right-radius: 0.75rem;
  border-bottom-right-radius: 0.75rem;
}
.last\\:border-0:last-child{
  border-width: 0px;
}
.last\\:border-none:last-child{
  border-style: none;
}
.hover\\:-translate-y-0\\.5:hover{
  --tw-translate-y: -0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:-translate-y-1:hover{
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:translate-x-0\\.5:hover{
  --tw-translate-x: 0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:translate-y-0\\.5:hover{
  --tw-translate-y: 0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:rotate-\\[360deg\\]:hover{
  --tw-rotate: 360deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-100:hover{
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-105:hover{
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-110:hover{
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-\\[1\\.02\\]:hover{
  --tw-scale-x: 1.02;
  --tw-scale-y: 1.02;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:border-\\[\\#1DA8C6\\]:hover{
  --tw-border-opacity: 1;
  border-color: rgb(29 168 198 / var(--tw-border-opacity, 1));
}
.hover\\:border-\\[\\#1DA8C6\\]\\/40:hover{
  border-color: rgb(29 168 198 / 0.4);
}
.hover\\:border-\\[\\#2fa9bf\\]:hover{
  --tw-border-opacity: 1;
  border-color: rgb(47 169 191 / var(--tw-border-opacity, 1));
}
.hover\\:border-\\[\\#2fa9bf\\]\\/30:hover{
  border-color: rgb(47 169 191 / 0.3);
}
.hover\\:border-\\[\\#2fa9bf\\]\\/35:hover{
  border-color: rgb(47 169 191 / 0.35);
}
.hover\\:border-\\[\\#2fa9bf\\]\\/40:hover{
  border-color: rgb(47 169 191 / 0.4);
}
.hover\\:border-\\[\\#2fa9bf\\]\\/50:hover{
  border-color: rgb(47 169 191 / 0.5);
}
.hover\\:border-\\[\\#345952\\]:hover{
  --tw-border-opacity: 1;
  border-color: rgb(52 89 82 / var(--tw-border-opacity, 1));
}
.hover\\:border-\\[\\#345952\\]\\/40:hover{
  border-color: rgb(52 89 82 / 0.4);
}
.hover\\:border-\\[\\#5a5b61\\]:hover{
  --tw-border-opacity: 1;
  border-color: rgb(90 91 97 / var(--tw-border-opacity, 1));
}
.hover\\:border-\\[\\#60a5fa\\]:hover{
  --tw-border-opacity: 1;
  border-color: rgb(96 165 250 / var(--tw-border-opacity, 1));
}
.hover\\:border-\\[\\#6a6b71\\]:hover{
  --tw-border-opacity: 1;
  border-color: rgb(106 107 113 / var(--tw-border-opacity, 1));
}
.hover\\:border-\\[\\#93B9AD\\]:hover{
  --tw-border-opacity: 1;
  border-color: rgb(147 185 173 / var(--tw-border-opacity, 1));
}
.hover\\:border-\\[\\#93B9AD\\]\\/50:hover{
  border-color: rgb(147 185 173 / 0.5);
}
.hover\\:border-\\[\\#93B9AD\\]\\/60:hover{
  border-color: rgb(147 185 173 / 0.6);
}
.hover\\:border-\\[\\#BF1E2E\\]:hover{
  --tw-border-opacity: 1;
  border-color: rgb(191 30 46 / var(--tw-border-opacity, 1));
}
.hover\\:border-\\[\\#E8E8E4\\]:hover{
  --tw-border-opacity: 1;
  border-color: rgb(232 232 228 / var(--tw-border-opacity, 1));
}
.hover\\:border-\\[\\#c31c30\\]:hover{
  --tw-border-opacity: 1;
  border-color: rgb(195 28 48 / var(--tw-border-opacity, 1));
}
.hover\\:border-\\[var\\(--cu-border-hover\\)\\]:hover{
  border-color: var(--cu-border-hover);
}
.hover\\:border-blue-400:hover{
  --tw-border-opacity: 1;
  border-color: rgb(96 165 250 / var(--tw-border-opacity, 1));
}
.hover\\:border-blue-500:hover{
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}
.hover\\:border-cyan-500\\/40:hover{
  border-color: rgb(6 182 212 / 0.4);
}
.hover\\:border-gray-400:hover{
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity, 1));
}
.hover\\:border-green-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(134 239 172 / var(--tw-border-opacity, 1));
}
.hover\\:border-red-200:hover{
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
}
.hover\\:border-red-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(252 165 165 / var(--tw-border-opacity, 1));
}
.hover\\:border-red-500\\/30:hover{
  border-color: rgb(239 68 68 / 0.3);
}
.hover\\:border-white\\/20:hover{
  border-color: rgb(255 255 255 / 0.2);
}
.hover\\:border-white\\/25:hover{
  border-color: rgb(255 255 255 / 0.25);
}
.hover\\:border-white\\/\\[0\\.14\\]:hover{
  border-color: rgb(255 255 255 / 0.14);
}
.hover\\:\\!bg-\\[\\#F8F8F6\\]:hover{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(248 248 246 / var(--tw-bg-opacity, 1)) !important;
}
.hover\\:\\!bg-white\\/90:hover{
  background-color: rgb(255 255 255 / 0.9) !important;
}
.hover\\:bg-\\[\\#0A5A70\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(10 90 112 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#0b859b\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(11 133 155 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#141716\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(20 23 22 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#151716\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(21 23 22 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#1897ad\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(24 151 173 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#1DA8C6\\]\\/15:hover{
  background-color: rgb(29 168 198 / 0.15);
}
.hover\\:bg-\\[\\#1DA8C6\\]\\/35:hover{
  background-color: rgb(29 168 198 / 0.35);
}
.hover\\:bg-\\[\\#1c98ad\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(28 152 173 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#1d1e22\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(29 30 34 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#1e3a44\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(30 58 68 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#1f2221\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(31 34 33 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#208a99\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(32 138 153 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#222327\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(34 35 39 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#2296aa\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(34 150 170 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#232625\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(35 38 37 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#24252a\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(36 37 42 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#258ca0\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(37 140 160 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#26272c\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(38 39 44 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#26282C\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(38 40 44 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#279eb3\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(39 158 179 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#2a2b31\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(42 43 49 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#2a2d2c\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(42 45 44 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#2b9fb4\\]\\/80:hover{
  background-color: rgb(43 159 180 / 0.8);
}
.hover\\:bg-\\[\\#2fa9bf\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(47 169 191 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#2fa9bf\\]\\/10:hover{
  background-color: rgb(47 169 191 / 0.1);
}
.hover\\:bg-\\[\\#2fa9bf\\]\\/15:hover{
  background-color: rgb(47 169 191 / 0.15);
}
.hover\\:bg-\\[\\#2fa9bf\\]\\/20:hover{
  background-color: rgb(47 169 191 / 0.2);
}
.hover\\:bg-\\[\\#2fa9bf\\]\\/25:hover{
  background-color: rgb(47 169 191 / 0.25);
}
.hover\\:bg-\\[\\#345952\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(52 89 82 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#345952\\]\\/20:hover{
  background-color: rgb(52 89 82 / 0.2);
}
.hover\\:bg-\\[\\#36bfd8\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(54 191 216 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#3a3a3a\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(58 58 58 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#93B9AD\\]\\/10:hover{
  background-color: rgb(147 185 173 / 0.1);
}
.hover\\:bg-\\[\\#9abe8b\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(154 190 139 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#B7E3EB\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(183 227 235 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#DCCDB8\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(220 205 184 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#DDDDD8\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(221 221 216 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#E4F3F6\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(228 243 246 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#E5F4F7\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(229 244 247 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#E8F0EE\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(232 240 238 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#F0E6D4\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(240 230 212 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#F0F0EC\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(240 240 236 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#F0F7F8\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(240 247 248 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#F3FBFC\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(243 251 252 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#F4F4F1\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(244 244 241 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#F4F4F2\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(244 244 242 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#F5F5F0\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 240 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#F5F5F2\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 242 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#F8F8F6\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(248 248 246 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#F9F1EB\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(249 241 235 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#FAFAF8\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 248 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#FBFBF9\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(251 251 249 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#FDFBF2\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(253 251 242 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#FFEEC9\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 238 201 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#a51927\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(165 25 39 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#c0b8b8\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(192 184 184 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#c31c30\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(195 28 48 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#d5eef2\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(213 238 242 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#d9f2f7\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(217 242 247 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#eef9fc\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(238 249 252 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[rgba\\(232\\2c 80\\2c 58\\2c 0\\.14\\)\\]:hover{
  background-color: rgba(232,80,58,0.14);
}
.hover\\:bg-\\[rgba\\(29\\2c 168\\2c 198\\2c 0\\.14\\)\\]:hover{
  background-color: rgba(29,168,198,0.14);
}
.hover\\:bg-\\[rgba\\(29\\2c 168\\2c 198\\2c 0\\.24\\)\\]:hover{
  background-color: rgba(29,168,198,0.24);
}
.hover\\:bg-\\[rgba\\(29\\2c 168\\2c 198\\2c 0\\.8\\)\\]:hover{
  background-color: rgba(29,168,198,0.8);
}
.hover\\:bg-\\[var\\(--cu-accent-soft\\)\\]:hover{
  background-color: var(--cu-accent-soft);
}
.hover\\:bg-\\[var\\(--cu-elevated\\)\\]:hover{
  background-color: var(--cu-elevated);
}
.hover\\:bg-amber-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-amber-100\\/80:hover{
  background-color: rgb(254 243 199 / 0.8);
}
.hover\\:bg-amber-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(253 230 138 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-amber-500\\/10:hover{
  background-color: rgb(245 158 11 / 0.1);
}
.hover\\:bg-amber-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(180 83 9 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-black:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-black\\/75:hover{
  background-color: rgb(0 0 0 / 0.75);
}
.hover\\:bg-blue-100\\/80:hover{
  background-color: rgb(219 234 254 / 0.8);
}
.hover\\:bg-blue-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-500\\/20:hover{
  background-color: rgb(59 130 246 / 0.2);
}
.hover\\:bg-blue-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-cyan-100\\/80:hover{
  background-color: rgb(207 250 254 / 0.8);
}
.hover\\:bg-cyan-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(14 116 144 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-emerald-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-emerald-100\\/80:hover{
  background-color: rgb(209 250 229 / 0.8);
}
.hover\\:bg-emerald-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-emerald-500\\/10:hover{
  background-color: rgb(16 185 129 / 0.1);
}
.hover\\:bg-emerald-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(5 150 105 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-emerald-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(4 120 87 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-emerald-900\\/40:hover{
  background-color: rgb(6 78 59 / 0.4);
}
.hover\\:bg-emerald-900\\/50:hover{
  background-color: rgb(6 78 59 / 0.5);
}
.hover\\:bg-emerald-950\\/40:hover{
  background-color: rgb(2 44 34 / 0.4);
}
.hover\\:bg-gray-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-400:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-green-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-green-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-green-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-green-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(21 128 61 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-indigo-100\\/80:hover{
  background-color: rgb(224 231 255 / 0.8);
}
.hover\\:bg-orange-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 237 213 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-orange-100\\/80:hover{
  background-color: rgb(255 237 213 / 0.8);
}
.hover\\:bg-orange-300:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(253 186 116 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-orange-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(234 88 12 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-purple-400:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(192 132 252 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-400:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(248 113 113 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-500\\/10:hover{
  background-color: rgb(239 68 68 / 0.1);
}
.hover\\:bg-red-500\\/20:hover{
  background-color: rgb(239 68 68 / 0.2);
}
.hover\\:bg-red-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-rose-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 228 230 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-rose-100\\/80:hover{
  background-color: rgb(255 228 230 / 0.8);
}
.hover\\:bg-rose-900\\/50:hover{
  background-color: rgb(136 19 55 / 0.5);
}
.hover\\:bg-rose-950\\/50:hover{
  background-color: rgb(76 5 25 / 0.5);
}
.hover\\:bg-sky-100\\/80:hover{
  background-color: rgb(224 242 254 / 0.8);
}
.hover\\:bg-sky-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(240 249 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-slate-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-slate-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(100 116 139 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-teal-100\\/80:hover{
  background-color: rgb(204 251 241 / 0.8);
}
.hover\\:bg-teal-300:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(94 234 212 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-violet-100\\/80:hover{
  background-color: rgb(237 233 254 / 0.8);
}
.hover\\:bg-violet-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(139 92 246 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-white:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-white\\/10:hover{
  background-color: rgb(255 255 255 / 0.1);
}
.hover\\:bg-white\\/15:hover{
  background-color: rgb(255 255 255 / 0.15);
}
.hover\\:bg-white\\/20:hover{
  background-color: rgb(255 255 255 / 0.2);
}
.hover\\:bg-white\\/25:hover{
  background-color: rgb(255 255 255 / 0.25);
}
.hover\\:bg-white\\/5:hover{
  background-color: rgb(255 255 255 / 0.05);
}
.hover\\:bg-white\\/80:hover{
  background-color: rgb(255 255 255 / 0.8);
}
.hover\\:bg-white\\/90:hover{
  background-color: rgb(255 255 255 / 0.9);
}
.hover\\:bg-white\\/\\[0\\.03\\]:hover{
  background-color: rgb(255 255 255 / 0.03);
}
.hover\\:bg-white\\/\\[0\\.06\\]:hover{
  background-color: rgb(255 255 255 / 0.06);
}
.hover\\:bg-yellow-300:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(253 224 71 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-yellow-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(234 179 8 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-yellow-500\\/20:hover{
  background-color: rgb(234 179 8 / 0.2);
}
.hover\\:from-blue-500:hover{
  --tw-gradient-from: #3b82f6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(59 130 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.hover\\:from-cyan-300:hover{
  --tw-gradient-from: #67e8f9 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(103 232 249 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.hover\\:from-cyan-400:hover{
  --tw-gradient-from: #22d3ee var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(34 211 238 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.hover\\:to-blue-400:hover{
  --tw-gradient-to: #60a5fa var(--tw-gradient-to-position);
}
.hover\\:\\!text-\\[\\#2296aa\\]:hover{
  --tw-text-opacity: 1 !important;
  color: rgb(34 150 170 / var(--tw-text-opacity, 1)) !important;
}
.hover\\:text-\\[\\#1DA8C6\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(29 168 198 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#1a1a1a\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(26 26 26 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#1a6d7c\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(26 109 124 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#1e8a96\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(30 138 150 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#2296aa\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(34 150 170 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#249aad\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(36 154 173 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#268a9c\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(38 138 156 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#2C2C2C\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(44 44 44 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#2fa9bf\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(47 169 191 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#345952\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(52 89 82 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#36bfd8\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(54 191 216 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#3cb6cc\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(60 182 204 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#41bacf\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(65 186 207 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#4A4A48\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(74 74 72 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#8B4A3A\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(139 74 58 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#8B7355\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(139 115 85 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#F06A74\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(240 106 116 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#F1F0EA\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(241 240 234 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#ff8b96\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(255 139 150 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#ffb0b8\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(255 176 184 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[var\\(--cu-danger\\)\\]:hover{
  color: var(--cu-danger);
}
.hover\\:text-\\[var\\(--cu-text\\)\\]:hover{
  color: var(--cu-text);
}
.hover\\:text-black:hover{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-300:hover{
  --tw-text-opacity: 1;
  color: rgb(147 197 253 / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-800:hover{
  --tw-text-opacity: 1;
  color: rgb(30 64 175 / var(--tw-text-opacity, 1));
}
.hover\\:text-cyan-300:hover{
  --tw-text-opacity: 1;
  color: rgb(103 232 249 / var(--tw-text-opacity, 1));
}
.hover\\:text-emerald-200:hover{
  --tw-text-opacity: 1;
  color: rgb(167 243 208 / var(--tw-text-opacity, 1));
}
.hover\\:text-gray-300:hover{
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}
.hover\\:text-gray-400:hover{
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.hover\\:text-gray-800:hover{
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}
.hover\\:text-gray-900:hover{
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}
.hover\\:text-red-300:hover{
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}
.hover\\:text-red-500:hover{
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.hover\\:text-red-600:hover{
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.hover\\:text-red-700:hover{
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.hover\\:text-red-800:hover{
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity, 1));
}
.hover\\:text-white:hover{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.hover\\:underline:hover{
  text-decoration-line: underline;
}
.hover\\:opacity-100:hover{
  opacity: 1;
}
.hover\\:opacity-75:hover{
  opacity: 0.75;
}
.hover\\:opacity-90:hover{
  opacity: 0.9;
}
.hover\\:shadow-\\[0_10px_28px_-8px_rgba\\(47\\2c 169\\2c 191\\2c 0\\.75\\)\\]:hover{
  --tw-shadow: 0 10px 28px -8px rgba(47,169,191,0.75);
  --tw-shadow-colored: 0 10px 28px -8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-\\[0_20px_60px_rgba\\(47\\2c 169\\2c 191\\2c 0\\.5\\)\\]:hover{
  --tw-shadow: 0 20px 60px rgba(47,169,191,0.5);
  --tw-shadow-colored: 0 20px 60px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-\\[2px_2px_0_\\#1F1F1C\\]:hover{
  --tw-shadow: 2px 2px 0 #1F1F1C;
  --tw-shadow-colored: 2px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-md:hover{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-blue-500\\/25:hover{
  --tw-shadow-color: rgb(59 130 246 / 0.25);
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:brightness-110:hover{
  --tw-brightness: brightness(1.1);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.hover\\:file\\:bg-\\[\\#E5F4F7\\]::file-selector-button:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(229 244 247 / var(--tw-bg-opacity, 1));
}
.focus\\:\\!border-\\[\\#c31c30\\]:focus{
  --tw-border-opacity: 1 !important;
  border-color: rgb(195 28 48 / var(--tw-border-opacity, 1)) !important;
}
.focus\\:border-\\[\\#2296aa\\]:focus{
  --tw-border-opacity: 1;
  border-color: rgb(34 150 170 / var(--tw-border-opacity, 1));
}
.focus\\:border-\\[\\#2fa9bf\\]:focus{
  --tw-border-opacity: 1;
  border-color: rgb(47 169 191 / var(--tw-border-opacity, 1));
}
.focus\\:border-\\[\\#2fa9bf\\]\\/40:focus{
  border-color: rgb(47 169 191 / 0.4);
}
.focus\\:border-\\[\\#345952\\]:focus{
  --tw-border-opacity: 1;
  border-color: rgb(52 89 82 / var(--tw-border-opacity, 1));
}
.focus\\:border-\\[\\#93B9AD\\]:focus{
  --tw-border-opacity: 1;
  border-color: rgb(147 185 173 / var(--tw-border-opacity, 1));
}
.focus\\:border-\\[\\#BF1E2E\\]:focus{
  --tw-border-opacity: 1;
  border-color: rgb(191 30 46 / var(--tw-border-opacity, 1));
}
.focus\\:border-\\[\\#D4C4A8\\]:focus{
  --tw-border-opacity: 1;
  border-color: rgb(212 196 168 / var(--tw-border-opacity, 1));
}
.focus\\:border-\\[\\#c31c30\\]:focus{
  --tw-border-opacity: 1;
  border-color: rgb(195 28 48 / var(--tw-border-opacity, 1));
}
.focus\\:border-amber-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(245 158 11 / var(--tw-border-opacity, 1));
}
.focus\\:border-blue-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}
.focus\\:border-cyan-400:focus{
  --tw-border-opacity: 1;
  border-color: rgb(34 211 238 / var(--tw-border-opacity, 1));
}
.focus\\:border-cyan-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(6 182 212 / var(--tw-border-opacity, 1));
}
.focus\\:border-gray-400:focus{
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity, 1));
}
.focus\\:border-transparent:focus{
  border-color: transparent;
}
.focus\\:bg-white:focus{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.focus\\:shadow-\\[0_0_0_3px_rgba\\(191\\2c 30\\2c 46\\2c 0\\.28\\)\\]:focus{
  --tw-shadow: 0 0 0 3px rgba(191,30,46,0.28);
  --tw-shadow-colored: 0 0 0 3px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.focus\\:outline-none:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus\\:ring-1:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-2:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:\\!ring-\\[\\#c31c30\\]\\/20:focus{
  --tw-ring-color: rgb(195 28 48 / 0.2) !important;
}
.focus\\:ring-\\[\\#29a3b4\\]:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(41 163 180 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-\\[\\#2fa9bf\\]:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(47 169 191 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-\\[\\#2fa9bf\\]\\/20:focus{
  --tw-ring-color: rgb(47 169 191 / 0.2);
}
.focus\\:ring-\\[\\#2fa9bf\\]\\/30:focus{
  --tw-ring-color: rgb(47 169 191 / 0.3);
}
.focus\\:ring-\\[\\#2fa9bf\\]\\/50:focus{
  --tw-ring-color: rgb(47 169 191 / 0.5);
}
.focus\\:ring-\\[\\#345952\\]\\/20:focus{
  --tw-ring-color: rgb(52 89 82 / 0.2);
}
.focus\\:ring-\\[\\#D4C4A8\\]:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(212 196 168 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-\\[\\#FCF2E5\\]:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(252 242 229 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-amber-300\\/40:focus{
  --tw-ring-color: rgb(252 211 77 / 0.4);
}
.focus\\:ring-blue-100:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(219 234 254 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-blue-300:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(147 197 253 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-blue-400:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(96 165 250 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-blue-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-cyan-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(6 182 212 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-cyan-500\\/30:focus{
  --tw-ring-color: rgb(6 182 212 / 0.3);
}
.focus\\:ring-gray-300:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(209 213 219 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-sky-400:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(56 189 248 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-white\\/70:focus{
  --tw-ring-color: rgb(255 255 255 / 0.7);
}
.active\\:translate-y-1:active{
  --tw-translate-y: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.active\\:scale-\\[0\\.98\\]:active{
  --tw-scale-x: 0.98;
  --tw-scale-y: 0.98;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.active\\:scale-\\[0\\.995\\]:active{
  --tw-scale-x: 0.995;
  --tw-scale-y: 0.995;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.active\\:scale-\\[0\\.99\\]:active{
  --tw-scale-x: 0.99;
  --tw-scale-y: 0.99;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.active\\:cursor-grabbing:active{
  cursor: grabbing;
}
.active\\:bg-\\[\\#2fa9bf\\]:active{
  --tw-bg-opacity: 1;
  background-color: rgb(47 169 191 / var(--tw-bg-opacity, 1));
}
.active\\:text-white:active{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.active\\:shadow-none:active{
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.enabled\\:hover\\:border-\\[\\#2fa9bf\\]:hover:enabled{
  --tw-border-opacity: 1;
  border-color: rgb(47 169 191 / var(--tw-border-opacity, 1));
}
.enabled\\:hover\\:border-\\[\\#345952\\]:hover:enabled{
  --tw-border-opacity: 1;
  border-color: rgb(52 89 82 / var(--tw-border-opacity, 1));
}
.enabled\\:hover\\:text-\\[\\#2fa9bf\\]:hover:enabled{
  --tw-text-opacity: 1;
  color: rgb(47 169 191 / var(--tw-text-opacity, 1));
}
.enabled\\:hover\\:text-\\[\\#345952\\]:hover:enabled{
  --tw-text-opacity: 1;
  color: rgb(52 89 82 / var(--tw-text-opacity, 1));
}
.disabled\\:cursor-not-allowed:disabled{
  cursor: not-allowed;
}
.disabled\\:bg-\\[\\#D8D8D2\\]:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(216 216 210 / var(--tw-bg-opacity, 1));
}
.disabled\\:bg-gray-200:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.disabled\\:bg-gray-300:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}
.disabled\\:bg-slate-50:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
.disabled\\:text-\\[\\#8A8A85\\]:disabled{
  --tw-text-opacity: 1;
  color: rgb(138 138 133 / var(--tw-text-opacity, 1));
}
.disabled\\:text-slate-500:disabled{
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}
.disabled\\:no-underline:disabled{
  text-decoration-line: none;
}
.disabled\\:opacity-100:disabled{
  opacity: 1;
}
.disabled\\:opacity-35:disabled{
  opacity: 0.35;
}
.disabled\\:opacity-40:disabled{
  opacity: 0.4;
}
.disabled\\:opacity-45:disabled{
  opacity: 0.45;
}
.disabled\\:opacity-50:disabled{
  opacity: 0.5;
}
.disabled\\:opacity-60:disabled{
  opacity: 0.6;
}
.disabled\\:opacity-70:disabled{
  opacity: 0.7;
}
.disabled\\:hover\\:scale-100:hover:disabled{
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:translate-x-1{
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:scale-105{
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:bg-\\[\\#26282C\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(38 40 44 / var(--tw-bg-opacity, 1));
}
.group:hover .group-hover\\:bg-\\[\\#292a2f\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(41 42 47 / var(--tw-bg-opacity, 1));
}
.group:hover .group-hover\\:bg-\\[rgba\\(232\\2c 80\\2c 58\\2c 0\\.14\\)\\]{
  background-color: rgba(232,80,58,0.14);
}
.group:hover .group-hover\\:bg-black\\/45{
  background-color: rgb(0 0 0 / 0.45);
}
.group:hover .group-hover\\:text-\\[\\#2fa9bf\\]{
  --tw-text-opacity: 1;
  color: rgb(47 169 191 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-\\[\\#E8503A\\]{
  --tw-text-opacity: 1;
  color: rgb(232 80 58 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-\\[\\#F1F0EA\\]{
  --tw-text-opacity: 1;
  color: rgb(241 240 234 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:opacity-100{
  opacity: 1;
}
.peer:checked ~ .peer-checked\\:translate-x-5{
  --tw-translate-x: 1.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.peer:checked ~ .peer-checked\\:bg-cyan-500{
  --tw-bg-opacity: 1;
  background-color: rgb(6 182 212 / var(--tw-bg-opacity, 1));
}
.peer:focus ~ .peer-focus\\:border-\\[\\#2fa9bf\\]{
  --tw-border-opacity: 1;
  border-color: rgb(47 169 191 / var(--tw-border-opacity, 1));
}
.peer:focus ~ .peer-focus\\:ring-2{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.peer:focus ~ .peer-focus\\:ring-\\[\\#2fa9bf\\]\\/20{
  --tw-ring-color: rgb(47 169 191 / 0.2);
}
@media (min-width: 640px){

  .sm\\:left-4{
    left: 1rem;
  }

  .sm\\:left-5{
    left: 1.25rem;
  }

  .sm\\:right-5{
    right: 1.25rem;
  }

  .sm\\:right-auto{
    right: auto;
  }

  .sm\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .sm\\:col-span-3{
    grid-column: span 3 / span 3;
  }

  .sm\\:mx-0{
    margin-left: 0px;
    margin-right: 0px;
  }

  .sm\\:mx-1{
    margin-left: 0.25rem;
    margin-right: 0.25rem;
  }

  .sm\\:mb-4{
    margin-bottom: 1rem;
  }

  .sm\\:mb-6{
    margin-bottom: 1.5rem;
  }

  .sm\\:mb-8{
    margin-bottom: 2rem;
  }

  .sm\\:mb-\\[22px\\]{
    margin-bottom: 22px;
  }

  .sm\\:mt-2{
    margin-top: 0.5rem;
  }

  .sm\\:mt-6{
    margin-top: 1.5rem;
  }

  .sm\\:block{
    display: block;
  }

  .sm\\:inline{
    display: inline;
  }

  .sm\\:flex{
    display: flex;
  }

  .sm\\:inline-flex{
    display: inline-flex;
  }

  .sm\\:hidden{
    display: none;
  }

  .sm\\:h-10{
    height: 2.5rem;
  }

  .sm\\:h-12{
    height: 3rem;
  }

  .sm\\:h-14{
    height: 3.5rem;
  }

  .sm\\:h-16{
    height: 4rem;
  }

  .sm\\:h-20{
    height: 5rem;
  }

  .sm\\:h-24{
    height: 6rem;
  }

  .sm\\:h-8{
    height: 2rem;
  }

  .sm\\:h-\\[260px\\]{
    height: 260px;
  }

  .sm\\:h-\\[420px\\]{
    height: 420px;
  }

  .sm\\:h-\\[88px\\]{
    height: 88px;
  }

  .sm\\:h-\\[min\\(52vh\\2c 480px\\)\\]{
    height: min(52vh,480px);
  }

  .sm\\:h-auto{
    height: auto;
  }

  .sm\\:max-h-\\[260px\\]{
    max-height: 260px;
  }

  .sm\\:max-h-\\[360px\\]{
    max-height: 360px;
  }

  .sm\\:max-h-\\[560px\\]{
    max-height: 560px;
  }

  .sm\\:min-h-0{
    min-height: 0px;
  }

  .sm\\:w-10{
    width: 2.5rem;
  }

  .sm\\:w-12{
    width: 3rem;
  }

  .sm\\:w-14{
    width: 3.5rem;
  }

  .sm\\:w-24{
    width: 6rem;
  }

  .sm\\:w-60{
    width: 15rem;
  }

  .sm\\:w-8{
    width: 2rem;
  }

  .sm\\:w-\\[130px\\]{
    width: 130px;
  }

  .sm\\:w-\\[150px\\]{
    width: 150px;
  }

  .sm\\:w-\\[160px\\]{
    width: 160px;
  }

  .sm\\:w-\\[180px\\]{
    width: 180px;
  }

  .sm\\:w-\\[200px\\]{
    width: 200px;
  }

  .sm\\:w-\\[220px\\]{
    width: 220px;
  }

  .sm\\:w-\\[240px\\]{
    width: 240px;
  }

  .sm\\:w-\\[260px\\]{
    width: 260px;
  }

  .sm\\:w-\\[280px\\]{
    width: 280px;
  }

  .sm\\:w-\\[300px\\]{
    width: 300px;
  }

  .sm\\:w-\\[320px\\]{
    width: 320px;
  }

  .sm\\:w-\\[38\\%\\]{
    width: 38%;
  }

  .sm\\:w-\\[62\\%\\]{
    width: 62%;
  }

  .sm\\:w-auto{
    width: auto;
  }

  .sm\\:w-px{
    width: 1px;
  }

  .sm\\:min-w-\\[180px\\]{
    min-width: 180px;
  }

  .sm\\:min-w-\\[200px\\]{
    min-width: 200px;
  }

  .sm\\:max-w-\\[200px\\]{
    max-width: 200px;
  }

  .sm\\:max-w-md{
    max-width: 28rem;
  }

  .sm\\:max-w-xs{
    max-width: 20rem;
  }

  .sm\\:flex-1{
    flex: 1 1 0%;
  }

  .sm\\:flex-none{
    flex: none;
  }

  .sm\\:grid-cols-1{
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .sm\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .sm\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .sm\\:flex-row{
    flex-direction: row;
  }

  .sm\\:items-start{
    align-items: flex-start;
  }

  .sm\\:items-end{
    align-items: flex-end;
  }

  .sm\\:items-center{
    align-items: center;
  }

  .sm\\:justify-end{
    justify-content: flex-end;
  }

  .sm\\:justify-between{
    justify-content: space-between;
  }

  .sm\\:gap-1{
    gap: 0.25rem;
  }

  .sm\\:gap-2{
    gap: 0.5rem;
  }

  .sm\\:gap-2\\.5{
    gap: 0.625rem;
  }

  .sm\\:gap-3{
    gap: 0.75rem;
  }

  .sm\\:gap-4{
    gap: 1rem;
  }

  .sm\\:gap-5{
    gap: 1.25rem;
  }

  .sm\\:gap-6{
    gap: 1.5rem;
  }

  .sm\\:space-y-6 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
  }

  .sm\\:truncate{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .sm\\:rounded-2xl{
    border-radius: 1rem;
  }

  .sm\\:rounded-3xl{
    border-radius: 1.5rem;
  }

  .sm\\:rounded-\\[24px\\]{
    border-radius: 24px;
  }

  .sm\\:rounded-xl{
    border-radius: 0.75rem;
  }

  .sm\\:p-12{
    padding: 3rem;
  }

  .sm\\:p-3{
    padding: 0.75rem;
  }

  .sm\\:p-4{
    padding: 1rem;
  }

  .sm\\:p-5{
    padding: 1.25rem;
  }

  .sm\\:p-6{
    padding: 1.5rem;
  }

  .sm\\:p-8{
    padding: 2rem;
  }

  .sm\\:px-2\\.5{
    padding-left: 0.625rem;
    padding-right: 0.625rem;
  }

  .sm\\:px-3{
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .sm\\:px-4{
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .sm\\:px-5{
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .sm\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:py-2{
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .sm\\:py-2\\.5{
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
  }

  .sm\\:py-20{
    padding-top: 5rem;
    padding-bottom: 5rem;
  }

  .sm\\:py-3{
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .sm\\:py-4{
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .sm\\:py-5{
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .sm\\:py-8{
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .sm\\:pb-3{
    padding-bottom: 0.75rem;
  }

  .sm\\:pb-6{
    padding-bottom: 1.5rem;
  }

  .sm\\:pl-12{
    padding-left: 3rem;
  }

  .sm\\:pl-\\[3\\.75rem\\]{
    padding-left: 3.75rem;
  }

  .sm\\:pt-16{
    padding-top: 4rem;
  }

  .sm\\:pt-\\[18px\\]{
    padding-top: 18px;
  }

  .sm\\:text-left{
    text-align: left;
  }

  .sm\\:text-2xl{
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .sm\\:text-3xl{
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .sm\\:text-4xl{
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .sm\\:text-5xl{
    font-size: 3rem;
    line-height: 1;
  }

  .sm\\:text-6xl{
    font-size: 3.75rem;
    line-height: 1;
  }

  .sm\\:text-\\[11px\\]{
    font-size: 11px;
  }

  .sm\\:text-\\[22px\\]{
    font-size: 22px;
  }

  .sm\\:text-base{
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .sm\\:text-lg{
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .sm\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .sm\\:text-xl{
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .sm\\:tracking-\\[0\\.14em\\]{
    letter-spacing: 0.14em;
  }
}
@media (min-width: 768px){

  .md\\:static{
    position: static;
  }

  .md\\:absolute{
    position: absolute;
  }

  .md\\:inset-y-0{
    top: 0px;
    bottom: 0px;
  }

  .md\\:left-0{
    left: 0px;
  }

  .md\\:left-4{
    left: 1rem;
  }

  .md\\:right-2{
    right: 0.5rem;
  }

  .md\\:right-4{
    right: 1rem;
  }

  .md\\:top-1{
    top: 0.25rem;
  }

  .md\\:z-auto{
    z-index: auto;
  }

  .md\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .md\\:-m-6{
    margin: -1.5rem;
  }

  .md\\:mx-0{
    margin-left: 0px;
    margin-right: 0px;
  }

  .md\\:mx-1\\.5{
    margin-left: 0.375rem;
    margin-right: 0.375rem;
  }

  .md\\:my-0{
    margin-top: 0px;
    margin-bottom: 0px;
  }

  .md\\:my-3{
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
  }

  .md\\:my-4{
    margin-top: 1rem;
    margin-bottom: 1rem;
  }

  .md\\:-mt-\\[0\\.25vw\\]{
    margin-top: -0.25vw;
  }

  .md\\:-mt-\\[0\\.5vw\\]{
    margin-top: -0.5vw;
  }

  .md\\:mb-0{
    margin-bottom: 0px;
  }

  .md\\:mb-1{
    margin-bottom: 0.25rem;
  }

  .md\\:mb-12{
    margin-bottom: 3rem;
  }

  .md\\:mb-2{
    margin-bottom: 0.5rem;
  }

  .md\\:mb-3{
    margin-bottom: 0.75rem;
  }

  .md\\:mb-4{
    margin-bottom: 1rem;
  }

  .md\\:ml-4{
    margin-left: 1rem;
  }

  .md\\:ml-\\[-10vw\\]{
    margin-left: -10vw;
  }

  .md\\:mt-0{
    margin-top: 0px;
  }

  .md\\:mt-2{
    margin-top: 0.5rem;
  }

  .md\\:mt-4{
    margin-top: 1rem;
  }

  .md\\:mt-\\[1\\.5vw\\]{
    margin-top: 1.5vw;
  }

  .md\\:mt-\\[1vw\\]{
    margin-top: 1vw;
  }

  .md\\:mt-\\[2\\.5vw\\]{
    margin-top: 2.5vw;
  }

  .md\\:mt-\\[2vw\\]{
    margin-top: 2vw;
  }

  .md\\:block{
    display: block;
  }

  .md\\:flex{
    display: flex;
  }

  .md\\:hidden{
    display: none;
  }

  .md\\:h-10{
    height: 2.5rem;
  }

  .md\\:h-16{
    height: 4rem;
  }

  .md\\:h-20{
    height: 5rem;
  }

  .md\\:h-24{
    height: 6rem;
  }

  .md\\:h-32{
    height: 8rem;
  }

  .md\\:h-6{
    height: 1.5rem;
  }

  .md\\:h-7{
    height: 1.75rem;
  }

  .md\\:h-8{
    height: 2rem;
  }

  .md\\:h-9{
    height: 2.25rem;
  }

  .md\\:h-\\[1\\.4vw\\]{
    height: 1.4vw;
  }

  .md\\:h-\\[1\\.6vw\\]{
    height: 1.6vw;
  }

  .md\\:h-\\[10vw\\]{
    height: 10vw;
  }

  .md\\:h-\\[15vw\\]{
    height: 15vw;
  }

  .md\\:h-\\[16vw\\]{
    height: 16vw;
  }

  .md\\:h-\\[18vw\\]{
    height: 18vw;
  }

  .md\\:h-\\[3\\.5vw\\]{
    height: 3.5vw;
  }

  .md\\:h-\\[3vw\\]{
    height: 3vw;
  }

  .md\\:h-\\[4vw\\]{
    height: 4vw;
  }

  .md\\:h-\\[5vw\\]{
    height: 5vw;
  }

  .md\\:h-\\[83vh\\]{
    height: 83vh;
  }

  .md\\:h-\\[8vw\\]{
    height: 8vw;
  }

  .md\\:h-auto{
    height: auto;
  }

  .md\\:h-full{
    height: 100%;
  }

  .md\\:min-h-0{
    min-height: 0px;
  }

  .md\\:min-h-\\[15vw\\]{
    min-height: 15vw;
  }

  .md\\:w-1\\.5{
    width: 0.375rem;
  }

  .md\\:w-1\\/2{
    width: 50%;
  }

  .md\\:w-1\\/3{
    width: 33.333333%;
  }

  .md\\:w-16{
    width: 4rem;
  }

  .md\\:w-2\\/3{
    width: 66.666667%;
  }

  .md\\:w-20{
    width: 5rem;
  }

  .md\\:w-24{
    width: 6rem;
  }

  .md\\:w-32{
    width: 8rem;
  }

  .md\\:w-36{
    width: 9rem;
  }

  .md\\:w-6{
    width: 1.5rem;
  }

  .md\\:w-7{
    width: 1.75rem;
  }

  .md\\:w-8{
    width: 2rem;
  }

  .md\\:w-\\[1\\.4vw\\]{
    width: 1.4vw;
  }

  .md\\:w-\\[1\\.6vw\\]{
    width: 1.6vw;
  }

  .md\\:w-\\[10vw\\]{
    width: 10vw;
  }

  .md\\:w-\\[12vw\\]{
    width: 12vw;
  }

  .md\\:w-\\[14vw\\]{
    width: 14vw;
  }

  .md\\:w-\\[15\\%\\]{
    width: 15%;
  }

  .md\\:w-\\[22vw\\]{
    width: 22vw;
  }

  .md\\:w-\\[3\\.5vw\\]{
    width: 3.5vw;
  }

  .md\\:w-\\[30\\%\\]{
    width: 30%;
  }

  .md\\:w-\\[31\\.5\\%\\]{
    width: 31.5%;
  }

  .md\\:w-\\[32\\%\\]{
    width: 32%;
  }

  .md\\:w-\\[35\\%\\]{
    width: 35%;
  }

  .md\\:w-\\[3vw\\]{
    width: 3vw;
  }

  .md\\:w-\\[4\\.75rem\\]{
    width: 4.75rem;
  }

  .md\\:w-\\[40\\%\\]{
    width: 40%;
  }

  .md\\:w-\\[50\\%\\]{
    width: 50%;
  }

  .md\\:w-\\[5vw\\]{
    width: 5vw;
  }

  .md\\:w-\\[60\\%\\]{
    width: 60%;
  }

  .md\\:w-\\[80\\%\\]{
    width: 80%;
  }

  .md\\:w-\\[88\\%\\]{
    width: 88%;
  }

  .md\\:w-\\[90\\%\\]{
    width: 90%;
  }

  .md\\:w-auto{
    width: auto;
  }

  .md\\:w-full{
    width: 100%;
  }

  .md\\:w-px{
    width: 1px;
  }

  .md\\:min-w-\\[14vw\\]{
    min-width: 14vw;
  }

  .md\\:min-w-\\[25vw\\]{
    min-width: 25vw;
  }

  .md\\:translate-x-0{
    --tw-translate-x: 0px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .md\\:scale-100{
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .md\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .md\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .md\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_minmax\\(0\\2c 2fr\\)\\]{
    grid-template-columns: minmax(0,1fr) minmax(0,2fr);
  }

  .md\\:flex-row{
    flex-direction: row;
  }

  .md\\:flex-row-reverse{
    flex-direction: row-reverse;
  }

  .md\\:items-start{
    align-items: flex-start;
  }

  .md\\:items-end{
    align-items: flex-end;
  }

  .md\\:items-center{
    align-items: center;
  }

  .md\\:justify-between{
    justify-content: space-between;
  }

  .md\\:gap-1{
    gap: 0.25rem;
  }

  .md\\:gap-2{
    gap: 0.5rem;
  }

  .md\\:gap-2\\.5{
    gap: 0.625rem;
  }

  .md\\:gap-4{
    gap: 1rem;
  }

  .md\\:gap-7{
    gap: 1.75rem;
  }

  .md\\:gap-\\[0\\.5vw\\]{
    gap: 0.5vw;
  }

  .md\\:gap-\\[1\\.5vw\\]{
    gap: 1.5vw;
  }

  .md\\:gap-\\[10vw\\]{
    gap: 10vw;
  }

  .md\\:gap-\\[1vw\\]{
    gap: 1vw;
  }

  .md\\:gap-\\[2vw\\]{
    gap: 2vw;
  }

  .md\\:gap-\\[3vw\\]{
    gap: 3vw;
  }

  .md\\:gap-\\[4vw\\]{
    gap: 4vw;
  }

  .md\\:gap-\\[5vw\\]{
    gap: 5vw;
  }

  .md\\:gap-\\[7vw\\]{
    gap: 7vw;
  }

  .md\\:gap-\\[8vw\\]{
    gap: 8vw;
  }

  .md\\:space-y-4 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1rem * var(--tw-space-y-reverse));
  }

  .md\\:overflow-hidden{
    overflow: hidden;
  }

  .md\\:overflow-x-hidden{
    overflow-x: hidden;
  }

  .md\\:rounded-\\[1vw\\]{
    border-radius: 1vw;
  }

  .md\\:rounded-\\[2vw\\]{
    border-radius: 2vw;
  }

  .md\\:rounded-\\[5vw\\]{
    border-radius: 5vw;
  }

  .md\\:border-\\[0\\.25vw\\]{
    border-width: 0.25vw;
  }

  .md\\:border-l-\\[0\\.2vw\\]{
    border-left-width: 0.2vw;
  }

  .md\\:border-r{
    border-right-width: 1px;
  }

  .md\\:border-r-\\[0\\.2vw\\]{
    border-right-width: 0.2vw;
  }

  .md\\:border-t-0{
    border-top-width: 0px;
  }

  .md\\:bg-\\[\\#141517\\]{
    --tw-bg-opacity: 1;
    background-color: rgb(20 21 23 / var(--tw-bg-opacity, 1));
  }

  .md\\:bg-\\[\\#262626\\]{
    --tw-bg-opacity: 1;
    background-color: rgb(38 38 38 / var(--tw-bg-opacity, 1));
  }

  .md\\:bg-\\[\\#E8D9C4\\]{
    --tw-bg-opacity: 1;
    background-color: rgb(232 217 196 / var(--tw-bg-opacity, 1));
  }

  .md\\:p-0{
    padding: 0px;
  }

  .md\\:p-10{
    padding: 2.5rem;
  }

  .md\\:p-2{
    padding: 0.5rem;
  }

  .md\\:p-3{
    padding: 0.75rem;
  }

  .md\\:p-4{
    padding: 1rem;
  }

  .md\\:p-5{
    padding: 1.25rem;
  }

  .md\\:p-6{
    padding: 1.5rem;
  }

  .md\\:p-8{
    padding: 2rem;
  }

  .md\\:p-\\[1vw\\]{
    padding: 1vw;
  }

  .md\\:p-\\[2vw\\]{
    padding: 2vw;
  }

  .md\\:p-\\[5vw\\]{
    padding: 5vw;
  }

  .md\\:px-0{
    padding-left: 0px;
    padding-right: 0px;
  }

  .md\\:px-10{
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .md\\:px-16{
    padding-left: 4rem;
    padding-right: 4rem;
  }

  .md\\:px-2{
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .md\\:px-4{
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .md\\:px-5{
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .md\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .md\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .md\\:px-\\[2\\%\\]{
    padding-left: 2%;
    padding-right: 2%;
  }

  .md\\:px-\\[2vw\\]{
    padding-left: 2vw;
    padding-right: 2vw;
  }

  .md\\:px-\\[5vw\\]{
    padding-left: 5vw;
    padding-right: 5vw;
  }

  .md\\:px-\\[8vw\\]{
    padding-left: 8vw;
    padding-right: 8vw;
  }

  .md\\:py-0{
    padding-top: 0px;
    padding-bottom: 0px;
  }

  .md\\:py-2{
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .md\\:py-2\\.5{
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
  }

  .md\\:py-4{
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .md\\:py-5{
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .md\\:py-6{
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .md\\:py-8{
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .md\\:py-\\[0\\.5vw\\]{
    padding-top: 0.5vw;
    padding-bottom: 0.5vw;
  }

  .md\\:py-\\[1vw\\]{
    padding-top: 1vw;
    padding-bottom: 1vw;
  }

  .md\\:py-\\[26px\\]{
    padding-top: 26px;
    padding-bottom: 26px;
  }

  .md\\:py-\\[2vw\\]{
    padding-top: 2vw;
    padding-bottom: 2vw;
  }

  .md\\:py-\\[3vw\\]{
    padding-top: 3vw;
    padding-bottom: 3vw;
  }

  .md\\:py-\\[4vw\\]{
    padding-top: 4vw;
    padding-bottom: 4vw;
  }

  .md\\:py-\\[5vw\\]{
    padding-top: 5vw;
    padding-bottom: 5vw;
  }

  .md\\:py-\\[8vw\\]{
    padding-top: 8vw;
    padding-bottom: 8vw;
  }

  .md\\:pb-\\[5vw\\]{
    padding-bottom: 5vw;
  }

  .md\\:pl-0{
    padding-left: 0px;
  }

  .md\\:pl-\\[1vw\\]{
    padding-left: 1vw;
  }

  .md\\:pl-\\[2vw\\]{
    padding-left: 2vw;
  }

  .md\\:pl-\\[3vw\\]{
    padding-left: 3vw;
  }

  .md\\:pl-\\[4vw\\]{
    padding-left: 4vw;
  }

  .md\\:pl-\\[5vw\\]{
    padding-left: 5vw;
  }

  .md\\:pr-12{
    padding-right: 3rem;
  }

  .md\\:pr-\\[1vw\\]{
    padding-right: 1vw;
  }

  .md\\:pr-\\[2vw\\]{
    padding-right: 2vw;
  }

  .md\\:pr-\\[5\\%\\]{
    padding-right: 5%;
  }

  .md\\:pt-1{
    padding-top: 0.25rem;
  }

  .md\\:pt-5{
    padding-top: 1.25rem;
  }

  .md\\:pt-6{
    padding-top: 1.5rem;
  }

  .md\\:text-left{
    text-align: left;
  }

  .md\\:text-right{
    text-align: right;
  }

  .md\\:text-start{
    text-align: start;
  }

  .md\\:text-2xl{
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .md\\:text-3xl{
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .md\\:text-4xl{
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .md\\:text-5xl{
    font-size: 3rem;
    line-height: 1;
  }

  .md\\:text-\\[1\\.25vw\\]{
    font-size: 1.25vw;
  }

  .md\\:text-\\[1\\.2vw\\]{
    font-size: 1.2vw;
  }

  .md\\:text-\\[1\\.3vw\\]{
    font-size: 1.3vw;
  }

  .md\\:text-\\[1\\.4vw\\]{
    font-size: 1.4vw;
  }

  .md\\:text-\\[1\\.5vw\\]{
    font-size: 1.5vw;
  }

  .md\\:text-\\[1\\.6vw\\]{
    font-size: 1.6vw;
  }

  .md\\:text-\\[10px\\]{
    font-size: 10px;
  }

  .md\\:text-\\[15px\\]{
    font-size: 15px;
  }

  .md\\:text-\\[16px\\]{
    font-size: 16px;
  }

  .md\\:text-\\[1vw\\]{
    font-size: 1vw;
  }

  .md\\:text-\\[2\\.5vw\\]{
    font-size: 2.5vw;
  }

  .md\\:text-\\[20px\\]{
    font-size: 20px;
  }

  .md\\:text-\\[2vw\\]{
    font-size: 2vw;
  }

  .md\\:text-\\[3\\.75vw\\]{
    font-size: 3.75vw;
  }

  .md\\:text-\\[30px\\]{
    font-size: 30px;
  }

  .md\\:text-\\[3vw\\]{
    font-size: 3vw;
  }

  .md\\:text-\\[4vw\\]{
    font-size: 4vw;
  }

  .md\\:text-base{
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .md\\:text-lg{
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .md\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .md\\:text-xl{
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .md\\:text-xs{
    font-size: 0.75rem;
    line-height: 1rem;
  }

  .md\\:leading-\\[1\\.5vw\\]{
    line-height: 1.5vw;
  }

  .md\\:leading-\\[2vw\\]{
    line-height: 2vw;
  }

  .md\\:leading-\\[3vw\\]{
    line-height: 3vw;
  }

  .md\\:leading-\\[4\\.5vw\\]{
    line-height: 4.5vw;
  }

  .md\\:leading-\\[4vw\\]{
    line-height: 4vw;
  }

  .md\\:leading-none{
    line-height: 1;
  }
}
@media (min-width: 1024px){

  .lg\\:sticky{
    position: sticky;
  }

  .lg\\:top-4{
    top: 1rem;
  }

  .lg\\:col-span-1{
    grid-column: span 1 / span 1;
  }

  .lg\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .lg\\:col-span-3{
    grid-column: span 3 / span 3;
  }

  .lg\\:block{
    display: block;
  }

  .lg\\:inline{
    display: inline;
  }

  .lg\\:flex{
    display: flex;
  }

  .lg\\:grid{
    display: grid;
  }

  .lg\\:hidden{
    display: none;
  }

  .lg\\:h-\\[560px\\]{
    height: 560px;
  }

  .lg\\:max-h-none{
    max-height: none;
  }

  .lg\\:min-h-0{
    min-height: 0px;
  }

  .lg\\:w-52{
    width: 13rem;
  }

  .lg\\:w-\\[52\\%\\]{
    width: 52%;
  }

  .lg\\:w-auto{
    width: auto;
  }

  .lg\\:w-full{
    width: 100%;
  }

  .lg\\:min-w-0{
    min-width: 0px;
  }

  .lg\\:min-w-\\[180px\\]{
    min-width: 180px;
  }

  .lg\\:max-w-xs{
    max-width: 20rem;
  }

  .lg\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .lg\\:grid-cols-6{
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .lg\\:grid-cols-\\[1\\.2fr_0\\.8fr\\]{
    grid-template-columns: 1.2fr 0.8fr;
  }

  .lg\\:grid-cols-\\[1fr_260px\\]{
    grid-template-columns: 1fr 260px;
  }

  .lg\\:grid-cols-\\[1fr_auto_1fr\\]{
    grid-template-columns: 1fr auto 1fr;
  }

  .lg\\:grid-cols-\\[240px_minmax\\(0\\2c 1fr\\)\\]{
    grid-template-columns: 240px minmax(0,1fr);
  }

  .lg\\:grid-cols-\\[minmax\\(0\\2c 1\\.4fr\\)_280px\\]{
    grid-template-columns: minmax(0,1.4fr) 280px;
  }

  .lg\\:grid-cols-\\[minmax\\(0\\2c 420px\\)_minmax\\(0\\2c 1fr\\)\\]{
    grid-template-columns: minmax(0,420px) minmax(0,1fr);
  }

  .lg\\:grid-cols-\\[minmax\\(220px\\2c 0\\.38fr\\)_minmax\\(0\\2c 1fr\\)_240px\\]{
    grid-template-columns: minmax(220px,0.38fr) minmax(0,1fr) 240px;
  }

  .lg\\:flex-row{
    flex-direction: row;
  }

  .lg\\:flex-col{
    flex-direction: column;
  }

  .lg\\:items-start{
    align-items: flex-start;
  }

  .lg\\:items-end{
    align-items: flex-end;
  }

  .lg\\:items-center{
    align-items: center;
  }

  .lg\\:justify-between{
    justify-content: space-between;
  }

  .lg\\:gap-3{
    gap: 0.75rem;
  }

  .lg\\:gap-4{
    gap: 1rem;
  }

  .lg\\:gap-6{
    gap: 1.5rem;
  }

  .lg\\:divide-x > :not([hidden]) ~ :not([hidden]){
    --tw-divide-x-reverse: 0;
    border-right-width: calc(1px * var(--tw-divide-x-reverse));
    border-left-width: calc(1px * calc(1 - var(--tw-divide-x-reverse)));
  }

  .lg\\:divide-gray-100 > :not([hidden]) ~ :not([hidden]){
    --tw-divide-opacity: 1;
    border-color: rgb(243 244 246 / var(--tw-divide-opacity, 1));
  }

  .lg\\:overflow-y-auto{
    overflow-y: auto;
  }

  .lg\\:overflow-x-visible{
    overflow-x: visible;
  }

  .lg\\:border-b-0{
    border-bottom-width: 0px;
  }

  .lg\\:border-l{
    border-left-width: 1px;
  }

  .lg\\:border-r{
    border-right-width: 1px;
  }

  .lg\\:border-t-0{
    border-top-width: 0px;
  }

  .lg\\:px-10{
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .lg\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .lg\\:px-\\[6vw\\]{
    padding-left: 6vw;
    padding-right: 6vw;
  }

  .lg\\:pb-0{
    padding-bottom: 0px;
  }

  .lg\\:pl-0{
    padding-left: 0px;
  }

  .lg\\:pt-7{
    padding-top: 1.75rem;
  }

  .lg\\:text-base{
    font-size: 1rem;
    line-height: 1.5rem;
  }
}
@media (min-width: 1280px){

  .xl\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .xl\\:col-span-3{
    grid-column: span 3 / span 3;
  }

  .xl\\:w-auto{
    width: auto;
  }

  .xl\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .xl\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .xl\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .xl\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .xl\\:grid-cols-6{
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .xl\\:grid-cols-\\[1fr_280px\\]{
    grid-template-columns: 1fr 280px;
  }

  .xl\\:grid-cols-\\[320px_1fr\\]{
    grid-template-columns: 320px 1fr;
  }

  .xl\\:grid-cols-\\[minmax\\(240px\\2c 0\\.36fr\\)_minmax\\(0\\2c 1fr\\)_260px\\]{
    grid-template-columns: minmax(240px,0.36fr) minmax(0,1fr) 260px;
  }

  .xl\\:grid-cols-\\[repeat\\(auto-fit\\2c minmax\\(230px\\2c 1fr\\)\\)\\]{
    grid-template-columns: repeat(auto-fit,minmax(230px,1fr));
  }

  .xl\\:flex-row{
    flex-direction: row;
  }

  .xl\\:items-center{
    align-items: center;
  }

  .xl\\:justify-between{
    justify-content: space-between;
  }
}
.\\[\\&\\:\\:-webkit-details-marker\\]\\:hidden::-webkit-details-marker{
  display: none;
}
.\\[\\&\\>\\*\\]\\:min-w-0>*{
  min-width: 0px;
}
.\\[\\&\\>option\\]\\:text-gray-800>option{
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;;CAAc;;AAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gBAAc,EAAd,MAAc;EAAd,cAAc;KAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;EAAA,kBAAc;EAAd,4DAAc;EAAd,oBAAc;EAAd;AAAc;;AAAd;EAAA,yBAAc;AAAA;AACd;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AACpB;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;KAAnB,sBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;KAAnB,qBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;OAAnB;AAAmB;AAAnB;EAAA,uBAAmB;OAAnB;AAAmB;AAAnB;EAAA,uBAAmB;OAAnB;AAAmB;AAAnB;EAAA,wBAAmB;OAAnB;AAAmB;AAAnB;EAAA,qBAAmB;OAAnB;AAAmB;AAAnB;EAAA,qBAAmB;OAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,yDAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,wEAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,iEAAmB;EAAnB;AAAmB;AAAnB;EAAA,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;KAAnB;AAAmB;AAAnB;EAAA,oBAAmB;KAAnB;AAAmB;AAAnB;EAAA,mBAAmB;KAAnB;AAAmB;AAAnB;EAAA,0BAAmB;KAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,oCAAmB;EAAnB,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA,qCAAmB;EAAnB,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,kDAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,oCAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,oCAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,oCAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,oCAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,oCAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,oCAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,oCAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,oCAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,oCAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,oCAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,oCAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kGAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,+QAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,+QAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,+QAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,+QAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,+QAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,+QAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,+QAAmB;EAAnB;AAAmB;AAAnB;EAAA,gKAAmB;EAAnB,wJAAmB;EAAnB,iLAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAQnB,kCAAkC;AAClC;EACE,oBAAoB;EACpB,0CAA0C;EAC1C,oBAAoB;EACpB,qBAAqB;EACrB,kFAAkF;AACpF;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;EACtB,oBAAoB;EACpB,0BAA0B;EAC1B,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;EACtB,oBAAoB;EACpB,0BAA0B;EAC1B,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,2BAA2B;EAC3B,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;EACtB,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA,4EAA4E;AAC5E;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA,uEAAuE;AACvE;EACE,oBAAoB;EACpB,2CAA2C;EAC3C,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,oCAAoC;AACpC;EACE,oCAAoC;AACtC;;AAEA;;;EAGE,oBAAoB;EACpB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA,6BAA6B;AAC7B;;;;;EAKE,oCAAoC;AACtC;;AAEA,gFAAgF;AAChF;;;;;;;EAOE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA,kCAAkC;AAClC;;;EAGE,sCAAsC;EACtC,iDAAiD;EACjD,8EAA8E;AAChF;AACA;;;EAGE,oCAAoC;AACtC;;AAEA,8BAA8B;AAC9B;;;;;EAKE,gCAAgC;AAClC;AACA;;;EAGE,mCAAmC;AACrC;AACA;;EAEE,gCAAgC;AAClC;;AAEA,4EAA4E;AAC5E;;;;;;;;EAQE,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,yBAAyB;AAC3B;;AAEA,mCAAmC;AACnC;;EAEE,oCAAoC;AACtC;;AAEA,sCAAsC;AACtC;EACE,gCAAgC;AAClC;AACA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA,gFAAgF;;AAEhF,kEAAkE;AAClE;;;;;;EAME,oCAAoC;EACpC,yBAAyB;AAC3B;AACA;;;EAGE,oCAAoC;AACtC;AACA;;;;;;EAME,yBAAyB;AAC3B;AACA;;;;EAIE,gCAAgC;AAClC;AACA;;EAEE,mCAAmC;AACrC;AACA;EACE,oCAAoC;AACtC;;AAEA,2EAA2E;AAC3E;EACE,6CAA6C;EAC7C,cAAc;AAChB;AACA;;;EAGE,yDAAyD;AAC3D;;AAEA,0FAA0F;AAC1F;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;;;EAGE,oCAAoC;AACtC;AACA;;;;;EAKE,oCAAoC;EACpC,sBAAsB;AACxB;AACA;;EAEE,yBAAyB;AAC3B;AACA;;;;EAIE,yBAAyB;AAC3B;AACA;;;;;;EAME,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;;EAGE,gCAAgC;AAClC;AACA;;;;;EAKE,gCAAgC;AAClC;AACA;;EAEE,gCAAgC;AAClC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,gCAAgC;AAClC;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;AACA;;;EAGE,yBAAyB;EACzB,WAAW;EACX,qBAAqB;AACvB;AACA;;EAEE,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;;;EAGE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;;;EAGE,oCAAoC;AACtC;AACA;EACE,gCAAgC;AAClC;;;AAGA;EACE;IACE,oBAAoB;IACpB,qBAAqB;IACrB,2BAA2B;EAC7B;AACF;;;;AAIA;EACE,2BAA2B;EAC3B,OAAO,UAAU,EAAE,iCAAiC,EAAE;EACtD,QAAQ,UAAU,EAAE;EACpB,MAAM,UAAU,EAAE;EAClB,QAAQ,UAAU,EAAE;EACpB,OAAO,UAAU,EAAE;;EAEnB,eAAe;EACf;IACE,iCAAiC;IACjC,UAAU;EACZ;;EAEA,oBAAoB;EACpB;IACE,qCAAqC;IACrC,UAAU;EACZ;;EAEA,yBAAyB;EACzB;IACE,mCAAmC;IACnC,UAAU;EACZ;;EAEA,kBAAkB;EAClB,MAAM,UAAU,EAAE;EAClB,MAAM,UAAU,EAAE;EAClB,MAAM,UAAU,EAAE;EAClB,MAAM,UAAU,EAAE;EAClB,MAAM,UAAU,EAAE;EAClB,OAAO,UAAU,EAAE;AACrB;;;;AAIA;EACE,WAAW,YAAY,EAAE;EACzB,MAAM,YAAY,EAAE;AACtB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW,yBAAyB,EAAE;EACtC,MAAM,yBAAyB,EAAE;AACnC;;AAEA;EACE,0CAA0C;AAC5C;;;;;AAKA,yBAAyB;AACzB;EACE,uBAAuB;EACvB,qBAAqB;EACrB,kEAAkE;AACpE;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qCAAqC;EACrC,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE;;;;GAIC;EACD,oBAAoB;EACpB,2CAA2C;AAC7C;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,qDAAqD;EACrD,iCAAiC;AACnC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA;EACE;;;;GAIC;AACH;;;AAGA,YAAY;AACZ;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,cAAc;AACd;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,gBAAgB;EAChB,kBAAkB;;EAElB,iBAAiB;EACjB,gBAAgB;;EAEhB,qBAAqB;;EAErB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;;EAEtB,WAAW;EACX,sBAAsB;AACxB;;AAEA,oCAAoC;AACpC;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA,sBAAsB;AACtB;EACE,SAAS;AACX;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,SAAS;AACX;;AAEA;;EAEE,kBAAkB;EAClB,aAAa;AACf;;;;;AAKA,yBAAyB;AACzB;EACE,WAAW;EACX,gBAAgB;;EAEhB,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA,eAAe;AACf;EACE,SAAS;AACX;;AAEA,UAAU;AACV,iBAAiB;AACjB;EACE,wBAAwB;EACxB,kBAAkB;EAClB,aAAa;AACf;;AAEA,mBAAmB;AACnB;EACE,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;AACf;;AAEA,eAAe;AACf;EACE,aAAa;AACf;;AAEA,WAAW;AACX;EACE,eAAe;EACf,YAAY;AACd;;AAEA,oBAAoB;AACpB;;EAEE,qBAAqB;EACrB,sBAAsB;AACxB;AAroBA;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,qBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,mBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,+BAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,+BAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,+BAqoBC;EAroBD;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA,gCAqoBC;EAroBD;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA,2BAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,0BAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,0BAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,0BAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,mBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,eAqoBC;EAroBD,eAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,iBAqoBC;EAroBD,iBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,sBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA,sBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA,sBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA,sBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,sBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,sBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,sBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA,sBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,sBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,sBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA,sBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,sBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA,sBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,sBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,sBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,sBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA,6BAqoBC;EAroBD;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA,4DAqoBC;EAroBD,oEAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,4DAqoBC;EAroBD,qEAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,4DAqoBC;EAroBD,oEAqoBC;EAroBD;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA,+BAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA,mDAqoBC;EAroBD,4DAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,6CAqoBC;EAroBD,uDAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,8BAqoBC;EAroBD,qDAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,6EAqoBC;EAroBD,iGAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,yCAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,gCAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,iCAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,sBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,sBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA,sBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,sBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,sBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,sBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,sBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,sBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,sBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,sBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,sBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,sBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,2CAqoBC;EAroBD,qDAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,8BAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,2GAqoBC;EAroBD,yGAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,2GAqoBC;EAroBD,yGAqoBC;EAroBD;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA,yBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,mBAqoBC;EAroBD,mBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,sBAqoBC;EAroBD,8BAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,sBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,sBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA,eAqoBC;EAroBD,eAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,yBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA,yBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,kBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,sBAqoBC;EAroBD;AAqoBC;AAroBD;EAAA,2GAqoBC;EAroBD,yGAqoBC;EAroBD;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;;EAAA;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA,gBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,oBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA,uBAqoBC;IAroBD,8DAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,gBAqoBC;IAroBD,uBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA,sBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,qBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,kBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,qBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,oBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,mBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,qBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,iBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,oBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,iBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,oBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,iBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA,iBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,mBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,kBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,eAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,kBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA,eAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,mBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,mBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,kBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA;EAqoBC;AAAA;AAroBD;;EAAA;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA,QAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA,gBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,qBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,eAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,mBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,gBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA,qBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,eAqoBC;IAroBD,eAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA,uBAqoBC;IAroBD,4DAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA,kBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,kBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,kBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA,iBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,oBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,kBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,oBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,kBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,qBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,oBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,kBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,gBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,iBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,iBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,iBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,gBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,mBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,qBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,iBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,oBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,mBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,iBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,kBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,gBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,iBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,gBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,gBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,gBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,gBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,gBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA,iBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,mBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,kBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,eAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA,eAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,mBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,mBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,kBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,kBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;AAAA;AAroBD;;EAAA;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA,wBAqoBC;IAroBD,0DAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,sBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA,oBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,kBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA,iBAqoBC;IAroBD;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA,eAqoBC;IAroBD;EAqoBC;AAAA;AAroBD;;EAAA;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;;EAroBD;IAAA;EAqoBC;AAAA;AAroBD;EAAA;AAqoBC;AAroBD;EAAA;AAqoBC;AAroBD;EAAA,oBAqoBC;EAroBD;AAqoBC","sourcesContent":["@import \"./styles/smileStudio.css\";\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@layer base {\n  body {\n    @apply bg-gray-50 text-gray-900;\n  }\n}\n\n/* Case upload form theme tokens */\n.case-upload-theme {\n  --cu-accent: #2fa9bf;\n  --cu-accent-soft: rgba(47, 169, 191, 0.12);\n  --cu-danger: #e07070;\n  color: var(--cu-text);\n  transition: background-color 0.25s ease, color 0.25s ease, border-color 0.25s ease;\n}\n\n.case-upload-theme[data-theme=\"dark\"] {\n  --cu-bg: #1a1f27;\n  --cu-surface: #161b22;\n  --cu-input: #12151a;\n  --cu-elevated: #222831;\n  --cu-border: #2a3140;\n  --cu-border-hover: #3a4558;\n  --cu-text: #e8eaed;\n  --cu-heading: #ffffff;\n  --cu-muted: #9aa3b2;\n  --cu-subtle: #6b7380;\n  --cu-placeholder: #5a6270;\n  --cu-chip: #12151a;\n  --cu-disabled-bg: #2a3140;\n  --cu-disabled-text: #6b7380;\n}\n\n.case-upload-theme[data-theme=\"light\"] {\n  --cu-bg: #f7f8fa;\n  --cu-surface: #ffffff;\n  --cu-input: #ffffff;\n  --cu-elevated: #f0f2f5;\n  --cu-border: #e2e5ea;\n  --cu-border-hover: #c8ced8;\n  --cu-text: #1c1c1a;\n  --cu-heading: #111827;\n  --cu-muted: #5b6472;\n  --cu-subtle: #8a93a0;\n  --cu-placeholder: #a0a8b4;\n  --cu-chip: #f3f4f6;\n  --cu-disabled-bg: #e5e7eb;\n  --cu-disabled-text: #9ca3af;\n  --cu-danger: #dc5c5c;\n  --cu-accent-soft: rgba(47, 169, 191, 0.1);\n}\n\n.case-upload-theme[data-brand=\"uris\"] {\n  --cu-accent: #c31c30;\n  --cu-accent-soft: rgba(195, 28, 48, 0.16);\n}\n\n.case-upload-theme[data-brand=\"uris\"][data-theme=\"dark\"] {\n  --cu-bg: #1a1b1f;\n  --cu-surface: #1d1e22;\n  --cu-input: #141517;\n  --cu-elevated: #141517;\n  --cu-border: #2e3036;\n  --cu-border-hover: #c31c30;\n}\n\n/* PNG service icons: solid black in light, solid white in dark / selected */\n.case-upload-theme[data-theme=\"light\"] .cu-service-icon-mono {\n  background-color: #000000;\n}\n.case-upload-theme[data-theme=\"dark\"] .cu-service-icon-mono {\n  background-color: #ffffff;\n}\n.case-upload-theme [aria-pressed=\"true\"] .cu-service-icon-mono {\n  background-color: #ffffff;\n}\n\n/* ── Velvet brand (lab token JU): cream replaces portal teal/blue ── */\nhtml[data-brand=\"velvet\"] {\n  --cu-accent: #FCF2E5;\n  --cu-accent-soft: rgba(252, 242, 229, 0.55);\n  --ss-teal: #FCF2E5;\n  --ss-teal-soft: rgba(252, 242, 229, 0.22);\n}\n\nhtml[data-brand=\"velvet\"] body {\n  background-color: #FCF2E5;\n}\n\n/* Main portal canvas gray → cream */\nhtml[data-brand=\"velvet\"] [class*=\"bg-[#F4F4F2]\"] {\n  background-color: #FCF2E5 !important;\n}\n\nhtml[data-brand=\"velvet\"] .case-upload-theme,\nhtml[data-brand=\"velvet\"] .case-upload-theme[data-theme=\"light\"],\nhtml[data-brand=\"velvet\"] .case-upload-theme[data-theme=\"dark\"] {\n  --cu-accent: #FCF2E5;\n  --cu-accent-soft: rgba(252, 242, 229, 0.55);\n}\n\nhtml[data-brand=\"velvet\"] .smile-studio {\n  --ss-teal: #FCF2E5;\n  --ss-teal-soft: rgba(252, 242, 229, 0.22);\n}\n\n/* Soft blue washes → cream */\nhtml[data-brand=\"velvet\"] [class*=\"bg-[#eef9fc]\"],\nhtml[data-brand=\"velvet\"] [class*=\"bg-[#E5F4F7]\"],\nhtml[data-brand=\"velvet\"] [class*=\"bg-[#F0F7F8]\"],\nhtml[data-brand=\"velvet\"] [class*=\"bg-[#F3FBFC]\"],\nhtml[data-brand=\"velvet\"] [class*=\"bg-[#D4EBEF]\"] {\n  background-color: #FCF2E5 !important;\n}\n\n/* Brand teal/cyan fills → cream (+ dark ink for former white-on-teal buttons) */\nhtml[data-brand=\"velvet\"] [class*=\"bg-[#2fa9bf]\"],\nhtml[data-brand=\"velvet\"] [class*=\"bg-[#1DA8C6]\"],\nhtml[data-brand=\"velvet\"] [class*=\"bg-[#1da8c6]\"],\nhtml[data-brand=\"velvet\"] [class*=\"bg-[#2296aa]\"],\nhtml[data-brand=\"velvet\"] [class*=\"bg-[#258ca0]\"],\nhtml[data-brand=\"velvet\"] [class*=\"bg-[#36bfd8]\"],\nhtml[data-brand=\"velvet\"] [class*=\"bg-[#14879f]\"] {\n  background-color: #FCF2E5 !important;\n  color: #2C2C2C !important;\n}\n\n/* Gradient stops that used teal */\nhtml[data-brand=\"velvet\"] [class*=\"from-[#2fa9bf]\"],\nhtml[data-brand=\"velvet\"] [class*=\"from-[#1DA8C6]\"],\nhtml[data-brand=\"velvet\"] [class*=\"from-[#1da8c6]\"] {\n  --tw-gradient-from: #FCF2E5 !important;\n  --tw-gradient-to: rgb(252 242 229 / 0) !important;\n  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to) !important;\n}\nhtml[data-brand=\"velvet\"] [class*=\"to-[#2fa9bf]\"],\nhtml[data-brand=\"velvet\"] [class*=\"to-[#1DA8C6]\"],\nhtml[data-brand=\"velvet\"] [class*=\"to-[#14879f]\"] {\n  --tw-gradient-to: #FCF2E5 !important;\n}\n\n/* Borders / rings / accents */\nhtml[data-brand=\"velvet\"] [class*=\"border-[#2fa9bf]\"],\nhtml[data-brand=\"velvet\"] [class*=\"border-[#1DA8C6]\"],\nhtml[data-brand=\"velvet\"] [class*=\"border-[#1da8c6]\"],\nhtml[data-brand=\"velvet\"] [class*=\"border-[#2296aa]\"],\nhtml[data-brand=\"velvet\"] [class*=\"border-[#D4EBEF]\"] {\n  border-color: #FCF2E5 !important;\n}\nhtml[data-brand=\"velvet\"] [class*=\"ring-[#2fa9bf]\"],\nhtml[data-brand=\"velvet\"] [class*=\"ring-[#1DA8C6]\"],\nhtml[data-brand=\"velvet\"] [class*=\"ring-[#D4EBEF]\"] {\n  --tw-ring-color: #FCF2E5 !important;\n}\nhtml[data-brand=\"velvet\"] [class*=\"accent-[#2fa9bf]\"],\nhtml[data-brand=\"velvet\"] [class*=\"accent-[#1DA8C6]\"] {\n  accent-color: #FCF2E5 !important;\n}\n\n/* Teal text / icons → velvet ink on light UIs; cream on dark smile studio */\nhtml[data-brand=\"velvet\"] [class*=\"text-[#2fa9bf]\"],\nhtml[data-brand=\"velvet\"] [class*=\"text-[#1DA8C6]\"],\nhtml[data-brand=\"velvet\"] [class*=\"text-[#1da8c6]\"],\nhtml[data-brand=\"velvet\"] [class*=\"text-[#2296aa]\"],\nhtml[data-brand=\"velvet\"] [class*=\"text-[#268a9c]\"],\nhtml[data-brand=\"velvet\"] [class*=\"text-[#36bfd8]\"],\nhtml[data-brand=\"velvet\"] [class*=\"text-[#7dd3e8]\"],\nhtml[data-brand=\"velvet\"] [class*=\"text-[#7dd3ea]\"] {\n  color: #2C2C2C !important;\n}\n\nhtml[data-brand=\"velvet\"] .smile-studio [class*=\"text-[#2fa9bf]\"],\nhtml[data-brand=\"velvet\"] .smile-studio [class*=\"text-[#1DA8C6]\"],\nhtml[data-brand=\"velvet\"] .smile-studio [class*=\"text-[#1da8c6]\"],\nhtml[data-brand=\"velvet\"] .smile-studio [class*=\"text-[#2296aa]\"],\nhtml[data-brand=\"velvet\"] .smile-studio [class*=\"text-[#268a9c]\"],\nhtml[data-brand=\"velvet\"] .smile-studio [class*=\"text-[#36bfd8]\"],\nhtml[data-brand=\"velvet\"] .smile-studio [class*=\"text-[#7dd3e8]\"],\nhtml[data-brand=\"velvet\"] .smile-studio [class*=\"text-[#7dd3ea]\"] {\n  color: #FCF2E5 !important;\n}\n\n/* Spinner / border-t teal tricks */\nhtml[data-brand=\"velvet\"] [class*=\"border-t-[#2fa9bf]\"],\nhtml[data-brand=\"velvet\"] [class*=\"border-t-[#1DA8C6]\"] {\n  border-top-color: #FCF2E5 !important;\n}\n\n/* Hardcoded teal in smileStudio.css */\nhtml[data-brand=\"velvet\"] .smile-filter-slide.is-selected::after {\n  border-color: #FCF2E5 !important;\n}\nhtml[data-brand=\"velvet\"] .smile-filter-slide.is-selected .smile-filter-slide-name {\n  background: #FCF2E5 !important;\n  color: #2C2C2C !important;\n}\n\n/* Sidebar uses class-based Velvet tan theme (see cases-dashboard/sidebar.tsx) */\n\n/* My Cases + case details modal: catch page-specific teal hexes */\nhtml[data-brand=\"velvet\"] .velvet-cases-scope [class*=\"bg-[#29a3b4]\"],\nhtml[data-brand=\"velvet\"] .velvet-cases-scope [class*=\"bg-[#208a99]\"],\nhtml[data-brand=\"velvet\"] .velvet-cases-scope [class*=\"bg-[#1c98ad]\"],\nhtml[data-brand=\"velvet\"] .velvet-cases-scope [class*=\"bg-[#0A5A70]\"],\nhtml[data-brand=\"velvet\"] .velvet-cases-scope [class*=\"bg-[#1DA8C6]\"],\nhtml[data-brand=\"velvet\"] .velvet-cases-scope [class*=\"bg-[#2fa9bf]\"] {\n  background-color: #FCF2E5 !important;\n  color: #2C2C2C !important;\n}\nhtml[data-brand=\"velvet\"] .velvet-cases-scope [class*=\"bg-[#E8F6F8]\"],\nhtml[data-brand=\"velvet\"] .velvet-cases-scope [class*=\"bg-[#eef9fc]\"],\nhtml[data-brand=\"velvet\"] .velvet-cases-scope [class*=\"bg-[#d9f2f7]\"] {\n  background-color: #FCF2E5 !important;\n}\nhtml[data-brand=\"velvet\"] .velvet-cases-scope [class*=\"text-[#29a3b4]\"],\nhtml[data-brand=\"velvet\"] .velvet-cases-scope [class*=\"text-[#1e8a96]\"],\nhtml[data-brand=\"velvet\"] .velvet-cases-scope [class*=\"text-[#1A7A86]\"],\nhtml[data-brand=\"velvet\"] .velvet-cases-scope [class*=\"text-[#2fa9bf]\"],\nhtml[data-brand=\"velvet\"] .velvet-cases-scope [class*=\"text-[#268a9c]\"],\nhtml[data-brand=\"velvet\"] .velvet-cases-scope [class*=\"text-[#1DA8C6]\"] {\n  color: #2C2C2C !important;\n}\nhtml[data-brand=\"velvet\"] .velvet-cases-scope [class*=\"border-[#29a3b4]\"],\nhtml[data-brand=\"velvet\"] .velvet-cases-scope [class*=\"border-[#2fa9bf]\"],\nhtml[data-brand=\"velvet\"] .velvet-cases-scope [class*=\"border-[#b8e8f0]\"],\nhtml[data-brand=\"velvet\"] .velvet-cases-scope [class*=\"border-[#1DA8C6]\"] {\n  border-color: #FCF2E5 !important;\n}\nhtml[data-brand=\"velvet\"] .velvet-cases-scope [class*=\"ring-[#29a3b4]\"],\nhtml[data-brand=\"velvet\"] .velvet-cases-scope [class*=\"ring-[#2fa9bf]\"] {\n  --tw-ring-color: #FCF2E5 !important;\n}\nhtml[data-brand=\"velvet\"] .velvet-cases-scope [class*=\"border-t-[#2fa9bf]\"] {\n  border-top-color: #FCF2E5 !important;\n}\n\n/* Uris dash pages — Montserrat / DM Sans + brand palette from tempurisui */\n.uris-scope {\n  font-family: \"DM Sans\", system-ui, sans-serif;\n  color: #eceaeb;\n}\n.uris-scope h1,\n.uris-scope h2,\n.uris-scope .uris-display {\n  font-family: Montserrat, \"DM Sans\", system-ui, sans-serif;\n}\n\n/* Uris case details modal — dark surfaces, red accent. Scoped so other labs stay light. */\n.uris-cases-scope .bg-white {\n  background-color: #1d1e22 !important;\n}\n.uris-cases-scope .bg-gray-50,\n.uris-cases-scope .bg-\\[\\#F8F8F6\\] {\n  background-color: #1a1b1f !important;\n}\n.uris-cases-scope .bg-gray-100,\n.uris-cases-scope .bg-gray-200 {\n  background-color: #2a2b31 !important;\n}\n.uris-cases-scope .bg-red-50 {\n  background-color: #3a1520 !important;\n}\n.uris-cases-scope .bg-green-50 {\n  background-color: #163226 !important;\n}\n.uris-cases-scope .bg-\\[\\#eef9fc\\],\n.uris-cases-scope .bg-\\[\\#d9f2f7\\],\n.uris-cases-scope .bg-\\[\\#E8F6F8\\] {\n  background-color: #3a1520 !important;\n}\n.uris-cases-scope .bg-\\[\\#2fa9bf\\],\n.uris-cases-scope .bg-\\[\\#1DA8C6\\],\n.uris-cases-scope .bg-\\[\\#0A5A70\\],\n.uris-cases-scope .bg-\\[\\#29a3b4\\],\n.uris-cases-scope .bg-blue-500 {\n  background-color: #e11d2e !important;\n  color: #fff !important;\n}\n.uris-cases-scope .text-gray-800,\n.uris-cases-scope .text-gray-700 {\n  color: #e8e9ed !important;\n}\n.uris-cases-scope .text-gray-600,\n.uris-cases-scope .text-gray-500,\n.uris-cases-scope .text-gray-400,\n.uris-cases-scope .text-gray-300 {\n  color: #9a9ca3 !important;\n}\n.uris-cases-scope .text-\\[\\#2fa9bf\\],\n.uris-cases-scope .text-\\[\\#1DA8C6\\],\n.uris-cases-scope .text-\\[\\#268a9c\\],\n.uris-cases-scope .text-\\[\\#29a3b4\\],\n.uris-cases-scope .text-blue-500,\n.uris-cases-scope .text-red-600 {\n  color: #ff8b96 !important;\n}\n.uris-cases-scope .text-green-600 {\n  color: #7dffa8 !important;\n}\n.uris-cases-scope .border-\\[\\#DDDDD8\\],\n.uris-cases-scope .border-\\[\\#E8E8E4\\],\n.uris-cases-scope .border-gray-300 {\n  border-color: #2e3036 !important;\n}\n.uris-cases-scope .border-\\[\\#2fa9bf\\],\n.uris-cases-scope .border-\\[\\#b8e8f0\\],\n.uris-cases-scope .border-\\[\\#1DA8C6\\],\n.uris-cases-scope .border-red-200,\n.uris-cases-scope .border-red-300 {\n  border-color: #6b2430 !important;\n}\n.uris-cases-scope .border-green-200,\n.uris-cases-scope .border-green-300 {\n  border-color: #1f5c3a !important;\n}\n.uris-cases-scope .ring-\\[\\#DDDDD8\\] {\n  --tw-ring-color: #3a3c42 !important;\n}\n.uris-cases-scope .border-t-\\[\\#2fa9bf\\] {\n  border-top-color: #c31c30 !important;\n}\n.uris-cases-scope .hover\\:border-\\[\\#2fa9bf\\]:hover {\n  border-color: #c31c30 !important;\n}\n.uris-cases-scope .hover\\:bg-\\[\\#eef9fc\\]:hover,\n.uris-cases-scope .hover\\:bg-red-50:hover {\n  background-color: #3a1520 !important;\n}\n.uris-cases-scope .hover\\:bg-green-50:hover {\n  background-color: #163226 !important;\n}\n.uris-cases-scope .group:hover .group-hover\\:text-\\[\\#2fa9bf\\] {\n  color: #ff8b96 !important;\n}\n.uris-cases-scope button:disabled {\n  background-color: #2a2b31 !important;\n  color: #6d6f76 !important;\n}\n.uris-cases-scope input,\n.uris-cases-scope textarea,\n.uris-cases-scope select {\n  background-color: #141517;\n  color: #fff;\n  border-color: #3a3c42;\n}\n.uris-cases-scope .ql-toolbar.ql-snow,\n.uris-cases-scope .ql-container.ql-snow {\n  border-color: #2e3036 !important;\n  background: #141517;\n}\n.uris-cases-scope .ql-editor {\n  color: #fff;\n}\n.uris-cases-scope .ql-editor.ql-blank::before {\n  color: #8b8d93;\n}\n.uris-cases-scope .ql-snow .ql-stroke {\n  stroke: #c5c7cc;\n}\n.uris-cases-scope .ql-snow .ql-fill {\n  fill: #c5c7cc;\n}\n.uris-cases-scope .ql-snow .ql-picker {\n  color: #c5c7cc;\n}\n.uris-cases-scope .text-\\[\\#4A4A48\\],\n.uris-cases-scope .text-\\[\\#1A1A1A\\],\n.uris-cases-scope .text-\\[\\#555552\\] {\n  color: #e8e9ed !important;\n}\n.uris-cases-scope .text-\\[\\#8A8A85\\],\n.uris-cases-scope .text-\\[\\#AAAAAA\\] {\n  color: #9a9ca3 !important;\n}\n.uris-cases-scope .bg-\\[\\#FAFAF8\\],\n.uris-cases-scope .bg-\\[\\#FDFBF2\\],\n.uris-cases-scope .bg-\\[\\#F4F4F2\\] {\n  background-color: #1a1b1f !important;\n}\n.uris-cases-scope .border-\\[\\#F0F0EC\\] {\n  border-color: #2e3036 !important;\n}\n \n\n@media (max-width: 768px) {\n  .relative {\n    --mobile-width: 80vw;\n    --mobile-height: 60vw;\n    --mobile-corner-radius: 4vw;\n  }\n}\n\n\n\n@keyframes flickerSlide {\n  /* Flicker twice (0–0.5s) */\n  0%   { opacity: 1; transform: scale(1) translateX(0); }\n  2.5%  { opacity: 1; }\n  5%  { opacity: 1; }\n  7.5%  { opacity: 1; }\n  10%  { opacity: 1; }\n\n  /* Scale to 0 */\n  12.5% {\n    transform: scale(0) translateX(0);\n    opacity: 1;\n  }\n\n  /* Come from right */\n  15% {\n    transform: scale(0) translateX(120px);\n    opacity: 1;\n  }\n\n  /* Full scale at center */\n  25% {\n    transform: scale(1.1) translateX(0);\n    opacity: 1;\n  }\n\n  /* Flicker again */\n  50% { opacity: 1; }\n  60% { opacity: 1; }\n  70% { opacity: 1; }\n  80% { opacity: 1; }\n  90% { opacity: 1; }\n  100% { opacity: 1; }\n}\n\n\n\n@keyframes blinkRed {\n  0%, 100% { opacity: 0.8; }\n  50% { opacity: 0.5; }\n}\n\n.blink-expired {\n  animation: blinkRed 2s infinite;\n}\n\n@keyframes blinkNewCase {\n  0%, 100% { background-color: #ffffff; }\n  50% { background-color: #f9a8d4; }\n}\n\n.blink-new-case {\n  animation: blinkNewCase 0.5s ease-in-out 4;\n}\n\n\n\n\n/* History panel scroll */\n.history-scroll {\n  scroll-behavior: smooth;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(47, 169, 191, 0.5) rgba(255, 255, 255, 0.08);\n}\n\n.history-scroll::-webkit-scrollbar {\n  width: 6px;\n}\n\n.history-scroll::-webkit-scrollbar-track {\n  background: rgba(255, 255, 255, 0.06);\n  border-radius: 999px;\n  margin-block: 6px;\n}\n\n.history-scroll::-webkit-scrollbar-thumb {\n  background: linear-gradient(\n    180deg,\n    rgba(47, 169, 191, 0.55),\n    rgba(47, 169, 191, 0.35)\n  );\n  border-radius: 999px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.history-scroll-x {\n  scroll-behavior: smooth;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(47, 169, 191, 0.45) transparent;\n  -webkit-overflow-scrolling: touch;\n}\n\n.history-scroll-x::-webkit-scrollbar {\n  height: 4px;\n}\n\n.history-scroll-x::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.history-scroll-x::-webkit-scrollbar-thumb {\n  background: rgba(47, 169, 191, 0.45);\n  border-radius: 999px;\n}\n\n.history-scroll::-webkit-scrollbar-thumb:hover {\n  background: linear-gradient(\n    180deg,\n    rgba(54, 191, 216, 0.85),\n    rgba(47, 169, 191, 0.65)\n  );\n}\n\n\n/* Toolbar */\n.custom-quill .ql-toolbar {\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n}\n\n/* Container */\n.custom-quill .ql-container {\n  border-bottom-left-radius: 8px;\n  border-bottom-right-radius: 8px;\n  overflow: hidden;\n}\n\n/* Editor */\n.custom-quill .ql-editor {\n  min-height: 24px;\n  max-height: 120px;\n\n  overflow-y: auto;\n  overflow-x: hidden;\n\n  padding: 8px 12px;\n  line-height: 1.5;\n\n  white-space: pre-wrap;\n\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  word-break: break-word;\n\n  width: 100%;\n  box-sizing: border-box;\n}\n\n/* Prevent long content stretching */\n.custom-quill .ql-editor * {\n  max-width: 100%;\n  box-sizing: border-box;\n}\n\n/* Paragraph spacing */\n.custom-quill .ql-editor p {\n  margin: 0;\n}\n\n.compact-quill .ql-container {\n  height: 42px !important;\n}\n\n.compact-quill .ql-editor {\n  min-height: 42px !important;\n  max-height: 42px !important;\n  padding: 8px 12px;\n}\n\n/* Placeholder */\n.custom-quill .ql-editor.ql-blank::before {\n  font-style: normal;\n  left: 12px;\n  right: 12px;\n}\n\n/* Receiver side */\n.message-content p {\n  margin: 0;\n}\n\n.message-content ul,\n.message-content ol {\n  padding-left: 20px;\n  margin: 4px 0;\n}\n\n\n\n\n/* Chat message wrapper */\n.message-content {\n  width: 100%;\n  overflow: hidden;\n\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n/* All inner elements */\n.message-content * {\n  max-width: 100%;\n  word-wrap: break-word;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n  box-sizing: border-box;\n}\n\n/* Paragraphs */\n.message-content p {\n  margin: 0;\n}\n\n/* Lists */\n/* Ordered list */\n.message-content ol {\n  list-style-type: decimal;\n  padding-left: 20px;\n  margin: 4px 0;\n}\n\n/* Unordered list */\n.message-content ul {\n  list-style-type: disc;\n  padding-left: 20px;\n  margin: 4px 0;\n}\n\n/* List items */\n.message-content li {\n  margin: 2px 0;\n}\n\n/* Images */\n.message-content img {\n  max-width: 100%;\n  height: auto;\n}\n\n/* Pre/code blocks */\n.message-content pre,\n.message-content code {\n  white-space: pre-wrap;\n  word-break: break-word;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
